{
  "locales": { "en": "English", "zh-TW": "繁體中文", "ja": "日本語" },
  "common": {
    "titles": {
      "error": "錯誤",
      "warning": "警告",
      "remind": "提醒",
      "hint": "提示",
      "checkYourSettings": "檢查你的設定"
    },
    "buttons": {
      "ok": "確定",
      "confirm": "確認",
      "cancel": "取消",
      "submit": "送出",
      "publish": "發佈",
      "delete": "刪除",
      "activate": "啟用",
      "deactivate": "停用",
      "replace": "覆蓋",
      "close": "關閉",
      "leave": "離開",
      "apply": "套用",
      "edit": "編輯",
      "search": "搜尋",
      "save": "儲存",
      "completeAndCheck": "完成並檢查",
      "back": "返回上一步",
      "next": "下一步",
      "nextPage": "下一頁",
      "reject": "拒絕",
      "goSummary": "預覽修改",
      "backModify": "返回修改",
      "review": "檢視",
      "archive": "封存",
      "restore": "復原",
      "download": "下載",
      "goBack": "返回"
    },
    "messages": {
      "succeeded": "成功",
      "failed": "失敗",
      "loading": "讓子彈飛一下 ...",
      "permissionDenied": "您沒有權限進行此操作"
    },
    "units": {
      "seconds": "秒",
      "secs": "秒",
      "device": "台",
      "devices": "台",
      "day": "天",
      "days": "天",
      "hour": "小時",
      "hours": "小時",
      "minutes": "分鐘"
    },
    "timeZone": {
      "taipei": "Asia/Taipei",
      "tokyo": "Asia/Tokyo",
      "hochiminh": "Asia/UTC+7 (Ho_Chi_Ming, Jakarta, etc.)"
    },
    "currency": {
      "twd": "台幣 TWD",
      "ntd": "台幣 NTD",
      "usd": "美金 USD",
      "myr": "馬幣 MYR",
      "jpy": "日幣 JPY",
      "vnd": "越南盾 VND",
      "idr": "印尼盾 IDR",
      "eur": "歐元 EUR"
    },
    "language": { "zhtw": "繁中", "enus": "English", "jajp": "日語" },
    "placeholder": { "pleaseSelect": "請選擇", "all": "所有" },
    "labels": {
      "noData": "無",
      "yes": "是",
      "no": "否",
      "can": "可以",
      "cannot": "不可以",
      "default": "預設",
      "copyToClipBoard": "複製到剪貼簿",
      "total": "總共",
      "showMore": "顯示更多",
      "open": "開啟",
      "close": "關閉",
      "optional": "選填",
      "comingSoon": "功能即將推出",
      "edit": "編輯"
    },
    "notice": "注意",
    "valuePerDay": "{{value}} / 日",
    "day": "日",
    "joinSeparator": "、",
    "duration": "{{start}}<1/>至<3/>{{end}}",
    "warning": "警告"
  },
  "actor": {
    "types": { "system": "系統", "agency": "經銷商", "advertiser": "廣告主" },
    "roles": {
      "admin": "管理者",
      "manager": "廣告活動主管",
      "account": "帳號與授權",
      "sales": "廣告業務",
      "report": "廣告委託人"
    },
    "roleNames": {
      "admin": "系統管理者",
      "agencyAdmin": "經銷商 | 管理人",
      "agencyManager": "經銷商 | 廣告管理主管",
      "agencyOperator": "經銷商 | 廣告操作人員",
      "agencySales": "經銷商 | 廣告業務主管",
      "agencyReport": "經銷商 | 廣告成效管理人員",
      "advertiserAdmin": "廣告主 | 廣告管理師",
      "advertiserSales": "廣告主 | 廣告業務",
      "advertiserReport": "廣告主 | 廣告委託人",
      "reconciliationOfficer": "財務人員",
      "beaconAdmin": "Beacon 管理者",
      "beaconExecutive": "Beacon 操作者"
    },
    "descriptions": {
      "agencyAdmin": "管理該經銷商人員權限 / 管理與審核廣告",
      "agencyManager": "管理與審核該經銷商廣告",
      "agencyOperator": "建立與操作廣告活動與提供客戶廣告成效資訊",
      "agencyAccount": "建立廣告主、指派經銷商 Sales 所屬廣告主",
      "agencySales": "瀏覽該經銷商所有廣告",
      "agencyReport": "瀏覽訂單細節與成效報表",
      "advertiserAdmin": "管理該廣告主廣告",
      "advertiserSales": "建立及管理廣告活動",
      "advertiserReport": "瀏覽該廣告主廣告成效",
      "reconciliationOfficer": "對帳人員",
      "beaconAdmin": "系統管理人員",
      "beaconExecutive": "專注於投放與 beacon 維護，負責設定推播內容"
    }
  },
  "appHeader": {
    "logout": "登出",
    "changePassword": "變更密碼",
    "sudo": { "title": "變換帳號" },
    "changeLanguage": { "message": "變更語言將需要重整頁面，確定要繼續？" }
  },
  "login": {
    "form": {
      "title": "登入 PerforMax",
      "placeholders": {
        "email": "您的帳號",
        "password": "您的密碼",
        "confirmPassword": "再輸入一次密碼"
      },
      "buttons": { "login": "登入" }
    }
  },
  "agencies": {
    "home": {
      "title": "經銷商",
      "addAgency": "+ 經銷商",
      "searchPlaceholder": "搜尋 經銷商 …"
    },
    "status": { "all": "全部", "active": "啟用中", "archived": "已封存" },
    "headers": {
      "id": "編號",
      "name": "經銷商名稱",
      "loginTitle": "登入頁標題",
      "loginDomain": "登入頁網域",
      "oemAgency": "OEM 經銷商",
      "currency": "幣別",
      "timeZone": "所在時區",
      "status": "狀態"
    },
    "filter": {
      "statusFilter": "經銷商狀態",
      "statusTag": "狀態",
      "statusFilterMenuTitle": "選擇經銷商狀態"
    },
    "noDataAvailable": "沒有符合的經銷商"
  },
  "accounts": {
    "home": {
      "searchPlaceholder": "搜尋 帳號 ...",
      "title": "帳號設置",
      "addAccount": "+ 帳號"
    },
    "headers": {
      "email": "電子郵件",
      "name": "帳號名稱",
      "status": "狀態",
      "isAdmin": "系統管理者",
      "companyName": "經銷商",
      "company": "公司名稱",
      "permission": "權限",
      "pending": "待啟用"
    },
    "tabs": { "agencies": "經銷商", "advertisers": "廣告主" },
    "summary": {
      "title": "帳號設置",
      "labels": {
        "email": "電子郵件",
        "name": "帳號名稱",
        "status": "狀態",
        "isAdmin": "系統管理者",
        "edit": "編輯",
        "isPending": "待啟用"
      }
    },
    "detail": { "title": "帳號資訊" },
    "inactive": "停用",
    "active": "啟用",
    "placeholder": {
      "noDataAvailable": "沒有符合的資料",
      "pleaseSearch": "請搜尋要變身的帳號"
    },
    "form": {
      "titles": {
        "new": "新增帳號",
        "edit": "編輯帳號",
        "permission": "權限設定"
      },
      "labels": {
        "email": "電子郵件",
        "name": "帳號名稱",
        "currentPassword": "現在密碼",
        "status": "狀態",
        "activated": "啟用",
        "isAdmin": "具系統管理者身份",
        "account-email": "帳號 - 電子郵件：",
        "permission": "權限",
        "agency": "經銷商",
        "role": "帳號角色",
        "password": "新密碼",
        "confirmPassword": "再輸入一次密碼"
      },
      "messages": {
        "nameRequired": "請填寫帳號名稱",
        "emailRequired": "請填寫電子郵件",
        "invalidEmail": "請填寫格式包含 @ 和 . 的電子郵件",
        "currentPasswordRequired": "請填寫現在密碼",
        "passwordRequired": "請填寫密碼",
        "confirmPasswordRequired": "請再次確認密碼",
        "passwordNotMatched": "與前次輸入的密碼不一致"
      },
      "buttons": { "deletePermission": "刪除權限" },
      "hints": {
        "assignRole": "<1>注意：</1>用戶在被分配為代理商或廣告商角色之前無法登錄。"
      }
    },
    "labels": { "activate": "啟用", "deactivate": "停用" },
    "messages": {
      "activateSuccess": "帳號啟用成功",
      "deactivateSuccess": "帳號停用成功"
    }
  },
  "agencyDetail": {
    "archiveModal": {
      "content": "封存後將暫停此經銷商執行中與未執行的廣告活動，並一併移除此經銷商底下所有成員的角色，確定要封存嗎？",
      "title": "封存經銷商"
    },
    "labels": {
      "editAgency": "編輯經銷商",
      "otherSettingsTab": "其他設定",
      "auditLogTab": "操作歷程紀錄",
      "adDeclarationTab": "廣告聲明書",
      "priceModelTab": "計價模式",
      "bidPriceSettingsTab": "出價設定",
      "adTypeTab": "廣告活動類型",
      "title": "經銷商",
      "basicTab": "基本設定",
      "addonFeatureTab": "額外功能",
      "campaignTargetingTab": "廣告活動目標",
      "memberTab": "成員設定",
      "adLogoTab": "廣告 Logo"
    },
    "buttons": { "back": "返回", "edit": "編輯經銷商" }
  },
  "serverResponse": {
    "400000": "錯誤的請求",
    "400010": "此電子郵件已經被註冊了",
    "400013": "請檢查您的電子郵件的垃圾郵件或垃圾文件夾中是否有帶有密碼重置連結的電子郵件。您需要等待 24 小時才能再次嘗試重置密碼。",
    "400030": "無效的操作",
    "400031": "不合法的經銷商數值",
    "400033": "此經銷商已封存，無法新增或變更成員的角色",
    "400050": "信用額度不足",
    "400061": "無法刪除已經開始或是綁定素材的廣告活動",
    "400070": "無效的素材參數",
    "400071": "不支援的素材比例大小",
    "400072": "素材檔案尺寸超過2M",
    "400073": "不合法的素材檔案格式",
    "400075": "戶外素材中的現有簽章與影片不合法，請重新上傳影片",
    "400076": "偵測到的編碼為 {{codec}}，此渠道僅接受 {{allowed}}",
    "400077": "素材播放尺寸設定有誤，請系統管理員查看銷售渠道設定",
    "400080": "素材送審資料不完整",
    "400100": "不支援的檔案格式",
    "400106": "此帳號已經被停用",
    "400120": "無法刪除已建立廣告活動的廣告群組",
    "400600": "無效的操作",
    "401000": "未授權的使用者",
    "401010": "帳號沒有登入",
    "401500": "無權限使用此功能",
    "401900": "第三方API認證失敗",
    "401950": "Yahoo API認證失敗",
    "401970": "Azure認證失敗",
    "402500": "無效的角色",
    "403000": "禁止存取",
    "403010": "帳號沒有權限存取此資源",
    "403030": "此經銷商已封存，無法使用，將為您登出。",
    "404000": "無法找到指定資源",
    "404010": "此帳號不存在",
    "404012": "此帳號不存在",
    "404020": "此公司不存在",
    "404030": "此經銷商不存在",
    "404040": "此廣告主不存在",
    "404050": "此訂單不存在",
    "404060": "此廣告活動不存在",
    "404062": "此廣告活動AdLogo不存在",
    "404070": "此素材不存在",
    "404090": "此受眾不存在",
    "404091": "此操作必須指定父受眾",
    "404110": "無效的轉換追蹤種類",
    "404111": "此轉換追蹤不存在",
    "404120": "找不到廣告群組",
    "404600": "此資源不存在",
    "405000": "權限不足",
    "406010": "帳號已被停用",
    "408000": "連線逾時",
    "408080": "送審連線失敗",
    "409000": "請求與伺服器目前狀態衝突",
    "409050": "訂單外部編號重複",
    "500000": "未知的錯誤",
    "500080": "Json解析失敗",
    "500081": "Url解析失敗",
    "500910": "發生未知的PVMax錯誤",
    "500920": "無法登入IMax",
    "500921": "建立IMax受眾失敗",
    "500922": "建立IMaxCollector失敗",
    "500923": "取得IMax代碼失敗",
    "500951": "Yahoo API連線失敗",
    "500952": "無法取得Yahoo報表",
    "500960": "Google API連線失敗",
    "500961": "無法取得Google Drive檔案",
    "500970": "Azure服務連線失敗",
    "500971": "Azure MediaService連線失敗",
    "500980": "DMP建立受眾失敗",
    "500981": "DMP更新受眾失敗",
    "500982": "DMP刪除受眾失敗",
    "500983": "DMP匯入受眾失敗",
    "500984": "DMP匯出受眾失敗",
    "500985": "無法取得DMP受眾代碼",
    "500986": "在所設時間區段內，一位受眾觀看到本廣告的最多次數",
    "500987": "無法取得轉換追蹤代碼",
    "4001605": "品牌名稱格式不正確，請檢查內容後再試一次",
    "4001606": "品牌連結格式不正確，請輸入以 http:// 或 https:// 開頭的有效網址",
    "4001607": "地圖標示圖片必須為 SVG 或 PNG 格式，請重新上傳",
    "4001608": "地圖標示圖片的檔案大小須小於 200KB",
    "4001609": "地圖標示圖片（SVG）含有不允許的內容，例如 script 或外部連結，請移除後重新上傳",
    "4001700": "Hardware ID 格式不正確，請重新檢查設定",
    "4001701": "Channel Access Token 格式不正確，請重新檢查設定"
  },
  "auditLog": {
    "company": {
      "archiveAgency": "封存經銷商",
      "restoreAgency": "復原經銷商",
      "createAgency": "建立經銷商",
      "updateAgency": "更新經銷商"
    },
    "headers": {
      "ctime": "日期",
      "srcID": "操作對象",
      "email": "使用者信箱",
      "funcType": "事件"
    },
    "adsOrder": {
      "create": "新增訂單",
      "update": "更新訂單",
      "approve": "核准訂單",
      "reject": "駁回訂單"
    },
    "l1Object": { "create": "建立廣告群組", "update": "更新廣告群組" },
    "campaign": {
      "create": "新增廣告活動",
      "update": "更新廣告活動",
      "delete": "刪除廣告活動",
      "activate": "啟用廣告活動",
      "deactivate": "停用廣告活動",
      "saveCampaign": "儲存廣告活動",
      "bindCreatives": "綁定素材",
      "bindedCreatives": { "activate": "啟用素材", "deactivate": "停用素材" },
      "split": "分割廣告活動",
      "paused": "廣告活動已停用"
    },
    "agency": { "updateRebateRate": "更新媒體獎勵金" },
    "companyRoleMap": {
      "createAgencyRole": "指派成員的經銷商權限",
      "updateAgencyRole": "更新成員的經銷商權限",
      "suspendAgencyRole": "刪除成員的經銷商權限",
      "agencyArchivedSuspendAgencyRole": "因經銷商封存而刪除成員的經銷商權限"
    },
    "labels": {
      "srcAdsOrder": "訂單",
      "srcL1Object": "廣告活動群組",
      "srcCampaign": "廣告活動",
      "srcAdAgency": "經銷商",
      "srcCompanyRoleMap": "權限",
      "from": "從",
      "to": "到",
      "l1ObjectFilterTitle": "廣告活動群組",
      "campaignFilterTitle": "廣告活動",
      "frequencyNoEnable": "無允許項目",
      "fieldFilterTitle": "欄位",
      "autoOptimise": "CBO",
      "channel": "銷售渠道",
      "l1ChannelId": "RTB 廣告群組ID",
      "l1ObjectLifetimeBudget": "預算",
      "dealIds": "指定交易 ID",
      "frequency": "廣告投遞頻率 與 投遞時段限制",
      "viewTrackingCodes": "第三方追蹤",
      "adType": "廣告類型",
      "bidPrice": "投遞上限",
      "camName": "廣告活動名稱",
      "convTrackEvent": "轉換追蹤模式",
      "deliverType": "投遞速率",
      "endDate": "結束日期",
      "id": "編號",
      "optimize": "智慧出價模式",
      "planType": "計價模式",
      "startDate": "開始日期",
      "tags": "標籤",
      "targetBudget": "預算",
      "dayPart": "指定投遞時間區段",
      "advertiserId": "廣告主ID",
      "budget": "訂單預算",
      "orderMargin": "經銷商利潤",
      "projectName": "訂單名稱",
      "agcPercent": "經銷商利潤",
      "sysPercent": "系統利潤",
      "state": "狀態",
      "spentCheckpoints": "Check Point",
      "currencyRate": "匯率",
      "selfBuyOnly": "自有流量",
      "bindCreatives": "綁定素材",
      "stopping": "廣告活動暫停中",
      "dailyTargetBudget": "日預算",
      "videoProgressTrackingCode": "再行銷追蹤",
      "adLogo": "廣告Logo",
      "conversionTracking": "轉換追縱",
      "orderPrice": "合約價格",
      "videoAdViewObjective": "觀看目標",
      "externalId": "外部訂單編號",
      "checkpoints": "Check Points",
      "expectedSpent": "預期花費",
      "daterange": "日期區間",
      "dealID": "指定交易 ID",
      "creativeDeliverType": "素材投遞方式",
      "changeBudget": "待改預算",
      "changeOrderMargin": "待改訂單利潤",
      "modifyReason": "修改理由",
      "ageMin": "最小年齡",
      "ageMax": "最大年齡",
      "gender": "性別",
      "creativeDuration": "素材秒數",
      "finalReportTargetType": "目標類型",
      "finalReportTargetValue": "目標次數",
      "finalReportAdvertiserName": "廣告主名稱",
      "targetImpressions": "目標曝光數",
      "goGanGroupId": "廣告群組 ID",
      "orderNumber": "訂單編號",
      "outdoorDeliverType": "機台投遞方式",
      "adminBidPrice": "出價設定",
      "Magnification": "權重",
      "compositePixelWidth": "實際播放寬度",
      "compositePixelHeight": "實際播放高度",
      "clicks": "點擊數",
      "impres": "曝光數",
      "lastHourOlapActualSpent": "上小時花費",
      "olapActualSpent": "實際花費",
      "olapExpectedSpent": "預期花費",
      "olapExpectSpent": "預期花費",
      "spent": "已花費",
      "uniqueUser": "不重複使用者",
      "viewable": "可視曝光",
      "priceModel": "計價模式",
      "spents": "已花費",
      "isMonitorEnable": "監控進度異常的廣告活動",
      "name": "名稱",
      "createDate": "建立日期",
      "campaignId": "廣告活動編號",
      "uniqueUsers": "不重複使用者",
      "orderId": "訂單編號",
      "agencyId": "經銷商編號",
      "bidPriceMin": "最低出價上限",
      "campaignConstraint": "廣告活動最低出價",
      "externalType": "外部訂單類型",
      "timezone": "時區",
      "comments": "備註",
      "currency": "幣別",
      "monitorEnable": "監控進度異常的廣告活動",
      "rebateRate": "媒體獎勵金",
      "companyId": "公司編號",
      "companyName": "公司名稱",
      "comComment": "其他說明事項",
      "language": "語言",
      "loginEmail": "登入頁帳號",
      "loginDomain": "登入頁網域",
      "sysPercentIn": "系統抽成(內部)",
      "sysPercentOut": "媒體獎勵金(對外)",
      "maxOrderProfit": "經銷商利潤上限",
      "taxPercent": "稅金",
      "providerId": "Provider ID",
      "oem": "OEM 經銷商",
      "logoUrl": "Logo",
      "priority": "投遞優先權",
      "limitPublisher": "網站主 ID",
      "limitPublisherCountry": "發佈商國家",
      "limitAdx": "廣告交換平台",
      "defaultCountry": "國家",
      "defaultSpace": "版位",
      "segmentCountry": "受眾國家",
      "segmentLabel": "受眾標籤",
      "defaultCountryOp": "國家投遞流量方向",
      "defaultSpaceOp": "版位投遞流量方向",
      "limitAdxOp": "廣告交換平台投遞流量方向",
      "interstitial": "允許蓋板流量",
      "credit": "信用額度",
      "noLimitSelfBuyStatus": "投遞非自有流量",
      "selfBuy": "自有流量",
      "timeZone": "時區",
      "roleName": "權限",
      "account": "帳號 - 電子郵件",
      "agencyID": "經銷商編號",
      "rate": "未來媒體獎勵金比例",
      "effectDate": "未來獎勵金生效日期",
      "effectiveArchived": "渠道停用狀態",
      "pmaxArchiveReason": "PMax 停用理由",
      "pmaxArchived": "PMax 停用狀態",
      "rmaxArchiveReason": "RMax 停用理由",
      "srcChannelGroup": "投遞渠道",
      "channelGroupStatus": "RMax 渠道狀態",
      "channelGroupId": "渠道 ID",
      "channelGroupType": "渠道類型",
      "campaignAdTypeSettings": "廣告類型設定",
      "reportIgnoredDV360Items": "報表排除的 DV360 項目",
      "campaignBidPrice": "出價設定",
      "screenPixelWidth": "螢幕寬度（px）",
      "screenPixelHeight": "螢幕高度（px）"
    },
    "placeholders": {
      "l1ObjectFilter": "請選擇要查看的廣告活動群組",
      "campaignFilter": "請選擇要查看的廣告活動",
      "fieldFilter": "請選擇要查看的欄位"
    },
    "limitation": { "create": "儲存目標設定" },
    "channelGroup": {
      "pmaxArchive": "停用投遞渠道",
      "pmaxUnarchive": "重新啟用投遞渠道",
      "update": "編輯投遞渠道"
    }
  },
  "appMenus": {
    "report": {
      "title": "廣告成效",
      "items": {
        "performance": "廣告成效",
        "dataMarketplace": "資料市集",
        "video": "影音成效",
        "campaignDashboard": "廣告活動儀表板",
        "reconciliation": "經銷商對帳報表",
        "credit": "信用額度",
        "storedValue": "儲值額度",
        "salesChannelReconciliation": "銷售渠道對帳報表"
      }
    },
    "comapnyManagement": {
      "title": "公司管理",
      "items": {
        "agencies": "經銷商",
        "advertisers": "廣告主",
        "accounts": "帳號",
        "newAccount": "新增帳號",
        "oemAccounts": "白牌帳號",
        "pmp": "PMP 訂單"
      }
    },
    "system": {
      "title": "系統管理",
      "items": {
        "productGroups": "產品群組管理",
        "roles": "功能群組",
        "currencyRate": "匯率設定",
        "auditLog": "操作歷程紀錄",
        "channelGroups": "投遞渠道管理",
        "streamingStatus": "直撥素材調整"
      }
    },
    "ads": {
      "title": "廣告管理",
      "items": {
        "orders": "訂單與廣告",
        "creatives": "素材",
        "creativeTemplates": "素材樣板庫",
        "conversion": "轉換追蹤"
      }
    },
    "data": {
      "title": "資料管理",
      "items": {
        "audienceSegments": "再行銷受眾",
        "marketplace": "資料市集",
        "tenmaxSegments": "TenMax 受眾",
        "messageSegments": "簡訊受眾",
        "customLayouts": "手刻版型",
        "deviceManagement": "機台管理"
      }
    },
    "eCommerce": {
      "title": "電子商務",
      "items": {
        "products": "商品庫",
        "conversion": "銷售漏斗",
        "events": "行為事件",
        "strategies": "程序化策略"
      }
    },
    "other": {
      "title": "其他功能",
      "items": {
        "doctor": "排查投遞限制",
        "outdoorMonitor": "戶外廣告流量監控"
      }
    },
    "beaconComapnyManagement": {
      "title": "Beacon 管理",
      "items": { "merchants": "官方帳號列表", "restaurants": "商家列表" }
    },
    "beaconMessageManagement": {
      "title": "Beacon 訊息管理",
      "items": { "beaconMessages": "Beacon 訊息設定" }
    },
    "announcement": {
      "title": "最新消息",
      "items": { "siteAnnouncement": "通知中心" }
    }
  },
  "agency": {
    "companyAttribute": "公司類型",
    "currentRebateRate": "目前媒體獎勵金",
    "futureEffectDate": "生效日期",
    "futureRebateRate": "未來媒體獎勵金",
    "id": "經銷商ID",
    "companyName": "公司名稱",
    "language": "語言",
    "currency": "幣別",
    "timeZone": "時區",
    "targetBudgetMinimum": "最低投遞金額",
    "taxPercent": "稅金",
    "priority": "投遞優先權",
    "limitPublisherCountryStr": "發佈商國家",
    "selfBuy": "自有流量",
    "limitPublisherStr": "網站主 ID",
    "noLimitSelfBuyStatus": "投遞非自有流量",
    "limitAdxStr": "廣告交換平台",
    "defaultCountryStr": "國家",
    "defaultSpaceStr": "版位",
    "segmentCountryStr": "受眾國家",
    "segmentLabelStr": "受眾標籤",
    "campaignBudgetMinimum": "廣告活動預算最小值",
    "interstitial": "允許蓋板流量",
    "comComment": "其他說明事項",
    "sysPercentIn": "系統抽成(內部)",
    "sysPercentOut": "媒體獎勵金(對外)",
    "margin": "利潤",
    "information": "經銷商資訊",
    "marginSetting": "利潤設定",
    "agcPercent": "經銷商預設利潤",
    "logo": "Logo",
    "yes": "是",
    "no": "否",
    "form": {
      "titles": {
        "new": "新增經銷商",
        "edit": "編輯經銷商",
        "deliverySetting": "投遞設定",
        "rtbDeliverySetting": "RTB投遞設定",
        "generalDeliverySetting": "General投遞設定"
      }
    },
    "member": {
      "addMember": "+ 成員",
      "addAccount": "+ 帳號",
      "headers": {
        "index": "編號",
        "email": "電子郵件",
        "name": "成員名稱",
        "status": "狀態",
        "permission": "權限"
      },
      "active": "啟用",
      "inactive": "停用",
      "permissions": {
        "AGENCY_ADMIN": "經銷商 - 管理人",
        "AGENCY_MANAGER": "經銷商 - 廣告管理主管",
        "AGENCY_OPERATOR": "經銷商 - 廣告操作人員",
        "AGENCY_SALES": "經銷商 - 廣告業務主管",
        "AGENCY_REPORT": "經銷商 - 廣告成效管理人員",
        "BEACON_EXECUTIVE": "Beacon 操作者"
      },
      "noDataAvailable": "目前無成員，可由 + 成員 開始新增哦！"
    },
    "addonProps": { "maxOrderProfit": "經銷商利潤上限" },
    "addonGroup": {
      "channel": "投遞渠道",
      "creatives": "素材類型",
      "company": "公司管理",
      "adsOrder": "訂單類型",
      "order": "訂單類型",
      "campaign": "廣告活動",
      "creative-studio": "素材樣板庫",
      "conversiontracking": "轉換追蹤",
      "report": "報表",
      "monitor": "監控",
      "campaignLimitation": "廣告活動目標",
      "creativeLimitation": "素材優化目標",
      "reconciliationAndBudget": "對帳報表與訂單預算控制",
      "creativeReview": "素材送審管理",
      "adTypes": "廣告活動類型"
    },
    "addonItem": {
      "channel": {
        "openRTB": "OpenRTB",
        "pic": "PIC Outdoor",
        "salesChannelMargin": "經銷商利潤",
        "message": "Message",
        "fridge": "WI Fridge",
        "matsukiyo": "Retail Beacon Network",
        "hwacom": "華電聯網",
        "salesChannelExpressPass": "素材是否屬於快速通關"
      },
      "creatives": {
        "option_image": "圖像式廣告",
        "option_html5": "HTML 廣告",
        "option_native": "原生廣告",
        "option_video": "影片廣告",
        "option_dynamic": "動態廣告",
        "option_flash": "Flash廣告",
        "option_thirdParty": "第三方廣告",
        "option_combo": "影+圖廣告",
        "option_oneForAll": "One For ALL 廣告",
        "option_oneForAllDisplay": "One For All Display 廣告",
        "option_oneForAllVideo": "One For All Video 廣告",
        "option_ctv": "數位電視廣告",
        "option_customRectangle": "手刻中矩形廣告",
        "option_customBottom": "手刻置底廣告",
        "option_edimax": "EdiMax 戶外廣告",
        "option_picShort": "PIC 戶外 15 秒廣告",
        "option_picLong": "PIC 戶外 30 秒廣告",
        "option_picExtended": "PIC 戶外 60 秒廣告",
        "option_picBroad": "PIC 戶外 60+ 秒廣告",
        "option_fridgeBroad": "冰櫃戶外 60+ 秒廣告",
        "option_fridgeLong": "冰櫃戶外 30 秒廣告",
        "option_fridgeExtended": "冰櫃戶外 60 秒廣告",
        "option_outdoorLineMessage": "Outdoor Line Message 廣告",
        "option_lineMessage": "Line Message 廣告",
        "option_sandboxOutdoor": "研發測試用戶外廣告",
        "option_hwacomShort": "華電聯網 15 秒廣告",
        "option_hwacomLong": "華電聯網 30 秒廣告",
        "option_hwacomExtended": "華電聯網 60 秒廣告",
        "option_hwacomBroad": "華電聯網 60+ 秒廣告",
        "adType_one_for_all_display": "One For All 展示型廣告",
        "adType_display": "展示型廣告",
        "adType_third_party": "第三方廣告",
        "adType_third_party_bottom": "行動置底廣告",
        "adType_third_party_rectangle": "中矩形廣告",
        "adType_video": "影音廣告",
        "adType_combo": "影+圖廣告",
        "adType_ctv": "數位電視廣告",
        "adType_keyword": "關鍵字廣告",
        "adType_pic_short": "PIC 戶外 15 秒廣告",
        "adType_pic_long": "PIC 戶外 30 秒廣告",
        "adType_pic_extended": "PIC 戶外 60 秒廣告",
        "adType_pic_broad": "PIC 戶外 60+ 秒廣告",
        "adType_fridge_broad": "冰櫃戶外 60+ 秒廣告",
        "adType_fridge_long": "冰櫃戶外 30 秒廣告",
        "adType_fridge_extended": "冰櫃戶外 60 秒廣告",
        "adType_pmp_pic": "PMP PIC 戶外廣告",
        "adType_pmp_fridge": "PMP 冰櫃戶外廣告",
        "adType_sandbox_outdoor": "研發測試用戶外廣告",
        "adType_outdoor_line_message": "Outdoor Line Message 廣告",
        "adType_line_message": "Line Message 廣告",
        "adType_sandbox_movable_outdoor": "研發測試用移動式戶外廣告",
        "adType_hwacom_short": "華電聯網 15 秒廣告",
        "adType_hwacom_long": "華電聯網 30 秒廣告",
        "adType_hwacom_extended": "華電聯網 60 秒廣告",
        "adType_hwacom_broad": "華電聯網 60+ 秒廣告",
        "landingPage": "目標頁面",
        "customizeAdLogo": "自訂廣告 Logo"
      },
      "order": { "showOrderExternalType": "外部訂單類型選單" },
      "company": {
        "agencyProfit": "設定經銷商利潤",
        "rebate": "媒體獎勵金",
        "incentive": "獎勵金目標／目標獎勵金",
        "provideReportToWorkflow": "經銷商對帳報表",
        "singleOrderBudgetConstraint": "單筆訂單預算上限",
        "productGroup": "產品群組",
        "orderBudgetMaximum": "最高",
        "useAgencyProfitOnRebateReport": "在經銷商月報表使用經銷商利潤計算利潤",
        "showOutComeOnRebateReport": "在經銷商月報表顯示超支",
        "creditLimit": "信用額度",
        "creditLimitMaximum": "額度上限",
        "allowOrderSettlement": "允許執行訂單結算",
        "allowOrderAutoSettlement": "允許訂單自動結算",
        "modifyOrderBudgetAfterSettlement": "允許結算功能異動訂單預算",
        "fixedExchangeRate": "在廣告投遞中使用固定匯率",
        "ExchangeRate": "匯率",
        "showOrderExternalType": "在訂單建立及編輯頁面顯示外部類型選單",
        "advertiserViewSpentInReport": "廣告主允許在報表頁面觀看花費",
        "lookalikeAudienceCreation": "允許建立 Lookalike 受眾",
        "allowBidPriceMoreThenContractPrice": "允許出價上限高於合約價",
        "outdoorAgency": "戶外廣告經銷商",
        "outdoorMachineCount": "戶外廣告機器數量",
        "storedValue": "儲值額度",
        "advAdminInfoRestriction": "廣告主 | 廣告管理師只能看到個人相關的資訊",
        "directlyApproveCreative": "允許素材送審到 RMax 會自動通過，不需要審核",
        "agencySegment": "使用經銷商受眾包",
        "agencySegmentLimitationName": "經銷商受眾包目標設定名稱"
      },
      "dependenceHint": "必須相依：{{addon}}",
      "campaign": {
        "bid_weight_setting": "投遞權重設定",
        "admin_bid_price_setting": "投遞金額設定",
        "orderAgcProfitSetting": "建立訂單時，可以設定經銷商利潤",
        "bidPriceMin": "{{type}}最低投遞金額",
        "enableOptimizedPrice": "允許使用智慧出價模式",
        "revenueSharing": "可使用動態競價計費模式",
        "budgetDominate": "能否使用每日預算分配",
        "roadblock": "可使用包版計費模式",
        "videoAdViewObjective": "影片廣告觀看目標",
        "thirdparty_tracking": "第三方追蹤",
        "retargeting_tracker": "再行銷追蹤",
        "ignoreVideoAdViewConstraint": "忽略觀看比例",
        "fix_cpc": "可使用固定式CPC計費模式",
        "fix_cpm": "可使用固定式CPM計費模式",
        "fix_cpv": "可使用固定式CPV計費模式",
        "fix_vcpm": "可使用固定式vCPM計費模式",
        "fix_acpm": "可使用固定式aCPM計費模式",
        "fix_wcpm": "可使用固定式wCPM計費模式",
        "bidPriceConstraint": "投遞金額限制",
        "dynamic_cpm": "可使用動態式CPM計費模式",
        "frequencyCapping": "可使用頻次控制"
      },
      "creative-studio": { "creative-studio": "素材樣板庫" },
      "product": { "index": "商品庫" },
      "conversiontracking": { "TrackingList": "轉換追蹤" },
      "report": {
        "viewableCtr": "採用可視曝光計算",
        "campaign_dashboard": "廣告活動儀表板",
        "booking_calendar": "原生廣告排程",
        "yahooAd": "Verizon 報表整合",
        "closingReport": "結案報表",
        "restrictFinalReport": "關閉結案報告",
        "campaignDashboard": "廣告活動儀表板",
        "bookingCalendar": "廣告排程",
        "orderCustom": "客製化訂單報表",
        "cantDownloadOutdoorFinalReport": "Outdoor 結案報告",
        "deliveryBriefReport": "投遞數據簡要報告"
      },
      "monitor": {
        "campaignUnderBidFloor": "監控under bid floor的廣告活動",
        "campaignBehindProgress": "監控進度異常的廣告活動"
      },
      "creativeLimitation": {
        "country": "國家",
        "spaceType": "版位類型",
        "device": "裝置類型",
        "target_audience": "再行銷受眾",
        "habits": "消費習慣",
        "adexchange": "廣告交換平台",
        "asiamax_space": "版位",
        "domain": "網域",
        "space_category": "網站分類",
        "tenmax_audience": "TenMax 受眾群",
        "city": "城市",
        "gender": "性別",
        "age": "年齡",
        "carrier": "電信商",
        "enablePMPDeal": "指定交易",
        "keyword": "關鍵字",
        "unicornkeywords": "Unicorn 關鍵字",
        "content_language": "網頁語系",
        "content_category": "文章分類"
      },
      "campaignLimitation": {
        "country": "國家",
        "spaceType": "版位類型",
        "device": "裝置類型",
        "target_audience": "再行銷受眾",
        "habits": "消費習慣",
        "adexchange": "廣告交換平台",
        "asiamax_space": "版位",
        "domain": "網域",
        "space_category": "網站分類",
        "tenmax_audience": "TenMax 受眾群",
        "city": "城市",
        "gender": "性別",
        "age": "年齡",
        "carrier": "電信商",
        "enablePMPDeal": "指定交易",
        "testMode": "測試模式",
        "keyword": "關鍵字",
        "unicornkeywords": "Unicorn 關鍵字",
        "content_language": "網頁語系",
        "content_category": "文章分類",
        "storeNum": "門市資訊",
        "cityGroup": "地理分區",
        "administrativeArea": "行政區",
        "outdoorPlaceCategories": "區域特性",
        "deviceCharacteristic": "機台資訊",
        "systemRecommendOutdoorDevice": "系統推薦"
      }
    },
    "placeholders": {
      "addon": "請先啟用對應的{{parent}}，才能設定{{child}}。"
    },
    "currentRate": "目前媒體獎勵金比例",
    "effectDate": "未來獎勵金生效日期",
    "futureRate": "未來媒體獎勵金比例",
    "rebateRate": "獎勵金設定",
    "gogan": {
      "targetBudgetMinimum": "廣告活動每日預算最小值",
      "addonItem": {
        "campaignLimitation": { "target_audience": "客製化受眾" }
      },
      "addonGroup": { "campaignLimitation": "RTB 廣告活動目標設定" }
    },
    "labels": {
      "role_agency_admin": "經銷商│管理人 - 管理該經銷商人員權限 / 管理與審核廣告",
      "role_agency_operator": "經銷商│廣告操作人員 - 建立與操作廣告活動與提供客戶廣告成效資訊",
      "role_agency_manager": "經銷商│廣告管理主管 - 管理與審核該經銷商廣告",
      "role_agency_sales": "經銷商│廣告業務主管 - 瀏覽該經銷商所有廣告",
      "role_agency_report": "經銷商│廣告成效管理人員 - 瀏覽訂單細節與成效報表"
    }
  },
  "geography": {
    "country": {
      "vnm": "Vietnam",
      "twn": "Taiwan",
      "usa": "United States",
      "tha": "Thailand",
      "can": "Canada",
      "sgp": "Singapore",
      "mys": "Malaysia",
      "hkg": "Hong Kong",
      "kor": "Korea",
      "jpn": "Japan",
      "idn": "Indonesia",
      "chn": "China",
      "phl": "Philippines"
    },
    "region": {
      "twn": {
        "changhua": "Changhua",
        "chiayi": "Chiayi",
        "chiayi_county": "Chiayi County",
        "hsinchu": "Hsinchu",
        "hsinchu_county": "Hsinchu County",
        "hualien": "Hualien",
        "kaohsiung": "Kaohsiung",
        "keelung": "Keelung",
        "miaoli": "Miaoli",
        "nantou": "Nantou",
        "new_taipei": "New Taipei",
        "penghu": "Penghu",
        "pingtung": "Pingtung",
        "taichung_city": "Taichung City",
        "tainan": "Tainan",
        "taipei_city": "Taipei City",
        "taitung": "Taitung",
        "taoyuan": "Taoyuan",
        "yilan": "Yilan",
        "yunlin_county": "Yunlin County"
      },
      "vnm": {
        "an_giang": "An Giang",
        "dak_nong": "Dak Nong",
        "gia_lai": "Gia Lai",
        "hau_giang": "Hau Giang",
        "ho_chi_minh_city": "Ho Chi Minh City",
        "kon_tum": "Kon Tum",
        "long_an": "Long An",
        "thanh_pho_can_tho": "Thanh Pho Can Tho",
        "thanh_pho_gja_nang": "Thanh Pho GJa Nang",
        "thanh_pho_ha_noi": "Thanh Pho Ha Noi",
        "thanh_pho_hai_phong": "Thanh Pho Hai Phong",
        "tinh_ba_ria-vung_tau": "Tinh Ba Ria-Vung Tau",
        "tinh_bac_giang": "Tinh Bac Giang",
        "tinh_bac_kan": "Tinh Bac Kan",
        "tinh_bac_lieu": "Tinh Bac Lieu",
        "tinh_bac_ninh": "Tinh Bac Ninh",
        "tinh_ben_tre": "Tinh Ben Tre",
        "tinh_binh_duong": "Tinh Binh Duong",
        "tinh_binh_gjinh": "Tinh Binh GJinh",
        "tinh_binh_phuoc": "Tinh Binh Phuoc",
        "tinh_binh_thuan": "Tinh Binh Thuan",
        "tinh_ca_mau": "Tinh Ca Mau",
        "tinh_cao_bang": "Tinh Cao Bang",
        "tinh_dien_bien": "Tinh Dien Bien",
        "tinh_gjak_lak": "Tinh GJak Lak",
        "tinh_gjong_nai": "Tinh GJong Nai",
        "tinh_gjong_thap": "Tinh GJong Thap",
        "tinh_ha_giang": "Tinh Ha Giang",
        "tinh_ha_nam": "Tinh Ha Nam",
        "tinh_ha_tinh": "Tinh Ha Tinh",
        "tinh_hai_duong": "Tinh Hai Duong",
        "tinh_hoa_binh": "Tinh Hoa Binh",
        "tinh_hung_yen": "Tinh Hung Yen",
        "tinh_khanh_hoa": "Tinh Khanh Hoa",
        "tinh_kien_giang": "Tinh Kien Giang",
        "tinh_lai_chau": "Tinh Lai Chau",
        "tinh_lam_gjong": "Tinh Lam GJong",
        "tinh_lang_son": "Tinh Lang Son",
        "tinh_lao_cai": "Tinh Lao Cai",
        "tinh_nam_gjinh": "Tinh Nam GJinh",
        "tinh_nghe_an": "Tinh Nghe An",
        "tinh_ninh_binh": "Tinh Ninh Binh",
        "tinh_ninh_thuan": "Tinh Ninh Thuan",
        "tinh_phu_tho": "Tinh Phu Tho",
        "tinh_phu_yen": "Tinh Phu Yen",
        "tinh_quang_binh": "Tinh Quang Binh",
        "tinh_quang_nam": "Tinh Quang Nam",
        "tinh_quang_ngai": "Tinh Quang Ngai",
        "tinh_quang_ninh": "Tinh Quang Ninh",
        "tinh_quang_tri": "Tinh Quang Tri",
        "tinh_soc_trang": "Tinh Soc Trang",
        "tinh_son_la": "Tinh Son La",
        "tinh_tay_ninh": "Tinh Tay Ninh",
        "tinh_thai_binh": "Tinh Thai Binh",
        "tinh_thai_nguyen": "Tinh Thai Nguyen",
        "tinh_thanh_hoa": "Tinh Thanh Hoa",
        "tinh_thua_thien-hue": "Tinh Thua Thien-Hue",
        "tinh_tien_giang": "Tinh Tien Giang",
        "tinh_tra_vinh": "Tinh Tra Vinh",
        "tinh_tuyen_quang": "Tinh Tuyen Quang",
        "tinh_vinh_long": "Tinh Vinh Long",
        "tinh_vinh_phuc": "Tinh Vinh Phuc",
        "tinh_yen_bai": "Tinh Yen Bai",
        "thanh_pho_da_nang": "Thanh Pho Da Nang"
      },
      "mys": {
        "johor": "Johor",
        "kedah": "Kedah",
        "kelantan": "Kelantan",
        "kuala_lumpur": "Kuala Lumpur",
        "labuan": "Labuan",
        "melaka": "Melaka",
        "negeri_sembilan": "Negeri Sembilan",
        "pahang": "Pahang",
        "penang": "Penang",
        "perak": "Perak",
        "perlis": "Perlis",
        "putrajaya": "Putrajaya",
        "sabah": "Sabah",
        "sarawak": "Sarawak",
        "selangor": "Selangor",
        "terengganu": "Terengganu"
      },
      "jpn": {
        "aichi": "Aichi",
        "akita": "Akita",
        "aomori": "Aomori",
        "chiba": "Chiba",
        "ehime": "Ehime",
        "fukui": "Fukui",
        "fukuoka": "Fukuoka",
        "fukushima-ken": "Fukushima-ken",
        "gifu": "Gifu",
        "gunma": "Gunma",
        "hiroshima": "Hiroshima",
        "hokkaido": "Hokkaido",
        "hyōgo": "Hyōgo",
        "ibaraki": "Ibaraki",
        "ishikawa": "Ishikawa",
        "iwate": "Iwate",
        "kagawa": "Kagawa",
        "kagoshima": "Kagoshima",
        "kanagawa": "Kanagawa",
        "kochi": "Kochi",
        "kumamoto": "Kumamoto",
        "kyoto": "Kyoto",
        "mie": "Mie",
        "miyagi": "Miyagi",
        "miyazaki": "Miyazaki",
        "nagano": "Nagano",
        "nagasaki": "Nagasaki",
        "nara": "Nara",
        "niigata": "Niigata",
        "oita": "Oita",
        "okayama": "Okayama",
        "okinawa": "Okinawa",
        "Ōsaka": "Ōsaka",
        "saga": "Saga",
        "saitama": "Saitama",
        "shiga": "Shiga",
        "shimane": "Shimane",
        "shizuoka": "Shizuoka",
        "tochigi": "Tochigi",
        "tokushima": "Tokushima",
        "tokyo": "Tokyo",
        "tottori": "Tottori",
        "toyama": "Toyama",
        "wakayama": "Wakayama",
        "yamagata": "Yamagata",
        "yamaguchi": "Yamaguchi",
        "yamanashi": "Yamanashi"
      },
      "armm": "ARMM",
      "bicol": "Bicol",
      "cagayan_valley": "Cagayan Valley",
      "calabarzon": "Calabarzon",
      "caraga": "Caraga",
      "central_luzon": "Central Luzon",
      "central_visayas": "Central Visayas",
      "cordillera": "Cordillera",
      "davao": "Davao",
      "eastern_visayas": "Eastern Visayas",
      "ilocos": "Ilocos",
      "mimaropa": "Mimaropa",
      "national_capital_region": "National Capital Region",
      "northern_mindanao": "Northern Mindanao",
      "province_of_negros_occidental": "Province of Negros Occidental",
      "province_of_negros_oriental": "Province of Negros Oriental",
      "soccsksargen": "Soccsksargen",
      "western_visayas": "Western Visayas",
      "zamboanga_peninsula": "Zamboanga Peninsula",
      "idn": {
        "aceh": {
          "banda_aceh": "Banda Aceh",
          "bireun": "Bireun",
          "langsa": "Langsa",
          "lhokseumawe": "Lhokseumawe",
          "pasir": "Pasir",
          "pondok": "Pondok",
          "sigli": "Sigli",
          "tanjung_balai": "Tanjung Balai"
        },
        "bali": {
          "badung": "Badung",
          "bangli": "Bangli",
          "banjar_asem": "Banjar Asem",
          "candi_dasa": "Candi Dasa",
          "canggu": "Canggu",
          "denpasar": "Denpasar",
          "gianyar": "Gianyar",
          "karangasem": "Karangasem",
          "kartika": "Kartika",
          "kecamatan_buleleng": "Kecamatan Buleleng",
          "kedunganan": "Kedunganan",
          "kerobokan": "Kerobokan",
          "klungkung": "Klungkung",
          "padang": "Padang",
          "padangsambian": "Padangsambian",
          "sanur": "Sanur",
          "seminyak_town": "Seminyak town",
          "singaraja": "Singaraja",
          "tabanan": "Tabanan",
          "ubud": "Ubud"
        },
        "bangka–belitung_islands": {
          "kotawaringin": "Kotawaringin",
          "pangkalpinang": "Pangkalpinang"
        },
        "banten": {
          "baratjaya": "Baratjaya",
          "cakung": "Cakung",
          "cibubur": "Cibubur",
          "cilegon": "Cilegon",
          "cipare": "Cipare",
          "kramatwatu": "Kramatwatu",
          "pandeglang": "Pandeglang",
          "pasir": "Pasir",
          "rangkasbitung": "Rangkasbitung",
          "serang": "Serang",
          "tangerang": "Tangerang"
        },
        "bengkulu": { "bengkulu": "Bengkulu" },
        "central_java": {
          "adiwarno": "Adiwarno",
          "asinan": "Asinan",
          "badran": "Badran",
          "bandung": "Bandung",
          "bandungrejo": "Bandungrejo",
          "bangkok": "Bangkok",
          "bangkong": "Bangkong",
          "banguntapan": "Banguntapan",
          "banjarnegara": "Banjarnegara",
          "bantarwuni": "Bantarwuni",
          "banyuasin": "Banyuasin",
          "banyumas": "Banyumas",
          "banyuurip": "Banyuurip",
          "baru": "Baru",
          "beji": "Beji",
          "bintaro": "Bintaro",
          "blora": "Blora",
          "blorong": "Blorong",
          "bojongsalaman": "Bojongsalaman",
          "boyolali": "Boyolali",
          "brebes": "Brebes",
          "bringin": "Bringin",
          "bulupayung": "Bulupayung",
          "buniayu": "Buniayu",
          "cilacap": "Cilacap",
          "comal": "Comal",
          "demak": "Demak",
          "donoharjo": "Donoharjo",
          "duren": "Duren",
          "gajahan": "Gajahan",
          "grobogan": "Grobogan",
          "grogol": "Grogol",
          "jati": "Jati",
          "jepara": "Jepara",
          "kalimantan": "Kalimantan",
          "karanganyar": "Karanganyar",
          "kartasura": "Kartasura",
          "kebon": "Kebon",
          "kebumen": "Kebumen",
          "kendal": "Kendal",
          "klaten": "Klaten",
          "kudus": "Kudus",
          "kuta": "Kuta",
          "lebak": "Lebak",
          "magelang": "Magelang",
          "malang": "Malang",
          "manggung": "Manggung",
          "menteng": "Menteng",
          "mungkid": "Mungkid",
          "pati": "Pati",
          "pekalongan": "Pekalongan",
          "pemalang": "Pemalang",
          "plalangan": "Plalangan",
          "purbalingga": "Purbalingga",
          "purwodadi_grobogan": "Purwodadi Grobogan",
          "purwokerto": "Purwokerto",
          "purworejo": "Purworejo",
          "salatiga": "Salatiga",
          "sawahbesar": "Sawahbesar",
          "sedayu": "Sedayu",
          "semarang": "Semarang",
          "slawi": "Slawi",
          "sragen": "Sragen",
          "sukoharjo": "Sukoharjo",
          "surakarta": "Surakarta",
          "tegal": "Tegal",
          "tlogosari": "Tlogosari",
          "umbulharjo": "Umbulharjo",
          "ungaran": "Ungaran",
          "weleri": "Weleri",
          "wonogiri": "Wonogiri",
          "wonosobo": "Wonosobo"
        },
        "central_kalimantan": {
          "lampeong": "Lampeong",
          "palangkaraya": "Palangkaraya",
          "sampit": "Sampit"
        },
        "central_sulawesi": {
          "palu": "Palu",
          "pengawu": "Pengawu",
          "tolitoli": "Tolitoli"
        },
        "east_java": {
          "alassumur": "Alassumur",
          "andongrejo": "Andongrejo",
          "ardirejo": "Ardirejo",
          "argosari": "Argosari",
          "babat": "Babat",
          "bacem": "Bacem",
          "badal": "Badal",
          "bajang": "Bajang",
          "bajulan": "Bajulan",
          "bakalan": "Bakalan",
          "baleturi": "Baleturi",
          "balongdowo": "Balongdowo",
          "balung": "Balung",
          "bandulan": "Bandulan",
          "bandung_barat": "Bandung Barat",
          "bangil": "Bangil",
          "bangkal": "Bangkal",
          "bangkalan": "Bangkalan",
          "banjarejo": "Banjarejo",
          "banjarsari": "Banjarsari",
          "banyuwangi": "Banyuwangi",
          "baratan": "Baratan",
          "bataan": "Bataan",
          "batokan": "Batokan",
          "batu": "Batu",
          "bayeman": "Bayeman",
          "bebekan": "Bebekan",
          "bedah": "Bedah",
          "bendo": "Bendo",
          "beton": "Beton",
          "blimbing": "Blimbing",
          "blitar": "Blitar",
          "bojonegoro": "Bojonegoro",
          "bondowoso": "Bondowoso",
          "bulukerto": "Bulukerto",
          "dukuh_kupang": "Dukuh Kupang",
          "genteng": "Genteng",
          "glenmore": "Glenmore",
          "gresik": "Gresik",
          "gubeng": "Gubeng",
          "indragiri": "Indragiri",
          "jatirejo": "Jatirejo",
          "jember": "Jember",
          "jombang": "Jombang",
          "kademangan": "Kademangan",
          "kanigaran": "Kanigaran",
          "karang": "Karang",
          "kauman": "Kauman",
          "kebonsari": "Kebonsari",
          "kebonsari_kulon": "Kebonsari Kulon",
          "kediri": "Kediri",
          "kembangbilo": "Kembangbilo",
          "ketanon": "Ketanon",
          "ketintang": "Ketintang",
          "kutai": "Kutai",
          "lamongan": "Lamongan",
          "lawang": "Lawang",
          "legian": "Legian",
          "lumajang": "Lumajang",
          "madiun": "Madiun",
          "magetan": "Magetan",
          "malang": "Malang",
          "medokan": "Medokan",
          "mojo": "Mojo",
          "mojokerto": "Mojokerto",
          "nganjuk": "Nganjuk",
          "ngronggot": "Ngronggot",
          "nyamplungan": "Nyamplungan",
          "pacitan": "Pacitan",
          "pare": "Pare",
          "pasuruan": "Pasuruan",
          "polerejo": "Polerejo",
          "ponorogo": "Ponorogo",
          "probolinggo": "Probolinggo",
          "puri": "Puri",
          "rungkut_kidul": "Rungkut Kidul",
          "sanur": "Sanur",
          "selatan": "Selatan",
          "senori": "Senori",
          "sidoarjo": "Sidoarjo",
          "sidomoro": "Sidomoro",
          "situbondo": "Situbondo",
          "sumenep": "Sumenep",
          "surabaya": "Surabaya",
          "tebas": "Tebas",
          "trenggalek": "Trenggalek",
          "tuban": "Tuban",
          "tulungagung": "Tulungagung",
          "tulungrejo": "Tulungrejo",
          "utara": "Utara",
          "waru": "Waru",
          "wates": "Wates",
          "yosowilangun": "Yosowilangun"
        },
        "east_kalimantan": {
          "balikpapan": "Balikpapan",
          "bontang": "Bontang",
          "nunukan": "Nunukan",
          "samarinda": "Samarinda"
        },
        "east_nusa_tenggara": {
          "ende": "Ende",
          "fontein": "Fontein",
          "kota": "Kota",
          "kupang": "Kupang",
          "maumere": "Maumere",
          "naikolan": "Naikolan"
        },
        "gorontalo": { "damai": "Damai", "gorontalo": "Gorontalo" },
        "jakarta": {
          "batuampar": "Batuampar",
          "bendungan_hilir": "Bendungan Hilir",
          "bintaro": "Bintaro",
          "cawang": "Cawang",
          "cempaka_baru": "Cempaka Baru",
          "cengkareng": "Cengkareng",
          "ciganjur": "Ciganjur",
          "cilandak": "Cilandak",
          "cipayung": "Cipayung",
          "cipete": "Cipete",
          "cipinang": "Cipinang",
          "ciracas": "Ciracas",
          "gambir": "Gambir",
          "grogol": "Grogol",
          "gunung": "Gunung",
          "jagakarsa": "Jagakarsa",
          "jakarta": "Jakarta",
          "jelambar": "Jelambar",
          "joglo": "Joglo",
          "karet": "Karet",
          "kebayoran_baru": "Kebayoran Baru",
          "kebayoran_lama_selatan": "Kebayoran Lama Selatan",
          "kebon_baru": "Kebon Baru",
          "kedoya_selatan": "Kedoya Selatan",
          "kemanggisan": "Kemanggisan",
          "kramat": "Kramat",
          "kuningan_barat": "Kuningan Barat",
          "kwitang": "Kwitang",
          "malaka": "Malaka",
          "pademangan_barat": "Pademangan Barat",
          "pasar_baru": "Pasar Baru",
          "pegadungan": "Pegadungan",
          "pegangsaan_dua": "Pegangsaan Dua",
          "penggilingan": "Penggilingan",
          "penjaringan": "Penjaringan",
          "petukangan_selatan": "Petukangan Selatan",
          "petukangan_utara": "Petukangan Utara",
          "pisangan_lama": "Pisangan Lama",
          "rorotan": "Rorotan",
          "serdang": "Serdang",
          "setiabudi": "Setiabudi",
          "sukabumi_selatan": "Sukabumi Selatan",
          "tambun_selatan": "Tambun Selatan"
        },
        "jambi": { "bangko": "Bangko", "jambi_city": "Jambi City" },
        "lampung": {
          "natar": "Natar",
          "ogan": "Ogan",
          "pringsewu": "Pringsewu",
          "teluk_betung": "Teluk Betung"
        },
        "maluku": {
          "ambon_city": "Ambon City",
          "ternate": "Ternate",
          "timoer": "Timoer"
        },
        "north_kalimantan": { "lingkas": "Lingkas", "tarakan": "Tarakan" },
        "north_maluku": { "ternate": "Ternate" },
        "north_sulawesi": {
          "bitung": "Bitung",
          "lolak": "Lolak",
          "manado": "Manado",
          "tomohon": "Tomohon",
          "tondano": "Tondano"
        },
        "north_sumatra": {
          "adiantorop": "Adiantorop",
          "amplas": "Amplas",
          "asahan": "Asahan",
          "bali": "Bali",
          "balige": "Balige",
          "bandar": "Bandar",
          "binjai": "Binjai",
          "bukit_tinggi": "Bukit Tinggi",
          "gunungsitoli": "Gunungsitoli",
          "helvetia": "Helvetia",
          "kabanjahe": "Kabanjahe",
          "kampung_dalam": "Kampung Dalam",
          "kisaran": "Kisaran",
          "lubuk_pakam": "Lubuk Pakam",
          "mabar": "Mabar",
          "medan": "Medan",
          "nangka": "Nangka",
          "padang_bulan": "Padang Bulan",
          "pancuran": "Pancuran",
          "pasar_baru": "Pasar Baru",
          "pematangsiantar": "Pematangsiantar",
          "sepinggan": "Sepinggan",
          "serdang": "Serdang",
          "sibolga": "Sibolga",
          "simalungun": "Simalungun",
          "stabat": "Stabat",
          "sunggal": "Sunggal",
          "tanah_enam_ratus": "Tanah Enam Ratus",
          "tanjung_gusta": "Tanjung Gusta",
          "tebingtinggi": "Tebingtinggi",
          "titi_papan": "Titi Papan"
        },
        "papua": {
          "jayapura": "Jayapura",
          "merauke": "Merauke",
          "serui": "Serui",
          "tembagapura": "Tembagapura",
          "timika": "Timika",
          "wamena": "Wamena"
        },
        "riau": {
          "bengkalis": "Bengkalis",
          "dumai": "Dumai",
          "karanganunggi": "Karanganunggi",
          "pekanbaru": "Pekanbaru",
          "siak_sri_indrapura": "Siak Sri Indrapura",
          "tangkerang": "Tangkerang"
        },
        "riau_islands": {
          "batam": "Batam",
          "sekupang": "Sekupang",
          "tanjung_balai": "Tanjung Balai",
          "tanjungpinang": "Tanjungpinang",
          "tengah": "Tengah"
        },
        "south_kalimantan": {
          "alabio": "Alabio",
          "amuntai": "Amuntai",
          "banjarbaru": "Banjarbaru",
          "banjarmasin": "Banjarmasin",
          "belandean": "Belandean",
          "kotabaru_hilir": "Kotabaru Hilir",
          "martapura": "Martapura",
          "sungkai": "Sungkai"
        },
        "south_sulawesi": {
          "ballaparang": "Ballaparang",
          "baranti": "Baranti",
          "batang": "Batang",
          "bombong": "Bombong",
          "daya": "Daya",
          "duri": "Duri",
          "jaya": "Jaya",
          "jempang": "Jempang",
          "karampuang": "Karampuang",
          "makale": "Makale",
          "makassar": "Makassar",
          "malili": "Malili",
          "maros": "Maros",
          "masamba": "Masamba",
          "melayu": "Melayu",
          "palangka": "Palangka",
          "palopo": "Palopo",
          "parepare": "Parepare",
          "salupontu": "Salupontu",
          "sidenreng": "Sidenreng",
          "sinjai": "Sinjai",
          "solo": "Solo"
        },
        "south_sumatra": {
          "baturaja": "Baturaja",
          "lubuklinggau": "Lubuklinggau",
          "palembang": "Palembang"
        },
        "southeast_sulawesi": {
          "kendari": "Kendari",
          "kolaka": "Kolaka",
          "muara": "Muara",
          "poanaha": "Poanaha"
        },
        "west_java": {
          "andir": "Andir",
          "antapani": "Antapani",
          "babakan": "Babakan",
          "babakan_ciparay": "Babakan Ciparay",
          "babakan_sari": "Babakan Sari",
          "balaraja": "Balaraja",
          "bandung": "Bandung",
          "banjar": "Banjar",
          "barengkok": "Barengkok",
          "bekasi": "Bekasi",
          "bogor": "Bogor",
          "bojong": "Bojong",
          "bungursari": "Bungursari",
          "cempaka": "Cempaka",
          "ciamis": "Ciamis",
          "cianjur": "Cianjur",
          "ciapus": "Ciapus",
          "ciateul": "Ciateul",
          "cibabat": "Cibabat",
          "cibadung": "Cibadung",
          "cibinong": "Cibinong",
          "cibiru": "Cibiru",
          "cigadung": "Cigadung",
          "cikampek": "Cikampek",
          "cikarang": "Cikarang",
          "cikiwul": "Cikiwul",
          "cilegon": "Cilegon",
          "cileungsir": "Cileungsir",
          "cimahi": "Cimahi",
          "cindogo": "Cindogo",
          "cinere": "Cinere",
          "cipageran": "Cipageran",
          "cipondoh": "Cipondoh",
          "ciporeat": "Ciporeat",
          "ciputat": "Ciputat",
          "cirangrang": "Cirangrang",
          "cirebon": "Cirebon",
          "cisaranten_kulon": "Cisaranten Kulon",
          "cisarua": "Cisarua",
          "ciseureuh": "Ciseureuh",
          "citeureup": "Citeureup",
          "depok": "Depok",
          "garut": "Garut",
          "hegarmanah": "Hegarmanah",
          "indramayu": "Indramayu",
          "jatiasih": "Jatiasih",
          "jatibening": "Jatibening",
          "karangtawang": "Karangtawang",
          "karawang": "Karawang",
          "kertasari": "Kertasari",
          "kunciran": "Kunciran",
          "kuningan": "Kuningan",
          "majalengka": "Majalengka",
          "melong": "Melong",
          "ngawi": "Ngawi",
          "padalarang": "Padalarang",
          "padasuka": "Padasuka",
          "pajajaran": "Pajajaran",
          "pakulonan_barat": "Pakulonan Barat",
          "pamanukan": "Pamanukan",
          "pamulang": "Pamulang",
          "pamulang_barat": "Pamulang Barat",
          "purwakarta": "Purwakarta",
          "rahayu": "Rahayu",
          "sawangan": "Sawangan",
          "sentul": "Sentul",
          "serang": "Serang",
          "serpong": "Serpong",
          "sindangrasa": "Sindangrasa",
          "subang": "Subang",
          "sukabumi": "Sukabumi",
          "sukamaju": "Sukamaju",
          "sumedang": "Sumedang",
          "tangsel": "Tangsel",
          "tasikmalaya": "Tasikmalaya",
          "utama": "Utama"
        },
        "west_kalimantan": {
          "bengkayang": "Bengkayang",
          "pontianak": "Pontianak",
          "singkawang": "Singkawang",
          "sintang": "Sintang"
        },
        "west_nusa_tenggara": {
          "gunungsari": "Gunungsari",
          "labuan_lombok": "Labuan Lombok",
          "leneng": "Leneng",
          "luk": "Luk",
          "mataram": "Mataram",
          "sandubaya": "Sandubaya",
          "selong": "Selong",
          "sumbawa_besar": "Sumbawa Besar",
          "tanjung": "Tanjung"
        },
        "west_papua": { "sorong": "Sorong" },
        "west_sulawesi": {
          "mamuju": "Mamuju",
          "panasuan": "Panasuan",
          "polewali": "Polewali"
        },
        "west_sumatra": {
          "batusangkar": "Batusangkar",
          "bukittinggi": "Bukittinggi",
          "gadang": "Gadang",
          "karang": "Karang",
          "padang": "Padang",
          "payakumbuh": "Payakumbuh",
          "solok": "Solok"
        },
        "yogyakarta": {
          "baciro": "Baciro",
          "bantul": "Bantul",
          "canden": "Canden",
          "condong": "Condong",
          "pandeyan": "Pandeyan",
          "panggung": "Panggung",
          "panjangrejo": "Panjangrejo",
          "patehan": "Patehan",
          "sleman": "Sleman",
          "yogyakarta": "Yogyakarta"
        }
      }
    }
  },
  "limitation": {
    "inc": "包含",
    "exc": "不包含",
    "Preferred": "優先投遞",
    "NonPreferred": "優先不投遞",
    "other": "其他",
    "labels": {
      "trafficAttribute": "流量屬性",
      "total": "{{total}}個",
      "warningAddDomain": "輸入的自訂版位可能不是 RMax space id",
      "customGeofence": "經緯度鎖定",
      "customKeyword": "關鍵字",
      "contentcat": "文章分類",
      "keywordDescription": "文字詞彙",
      "languageDescription": "請選擇關鍵字搜尋語系",
      "tranditionalChinese": "繁體中文",
      "vietnamese": "越南語",
      "latitude": "緯度",
      "longitude": "經度",
      "radius": "半徑距離",
      "minDecimalPlacesError": "必須至少精確到小數點後 {{count}} 位",
      "maxDecimalPlacesError": "只支援到小數點後 {{count}} 位",
      "simulcastMismatch": "同播不符",
      "searchResult": "總計 {{articleCount}} 篇文章於近 7 日內顯示本關鍵字詞",
      "updateEveryHour": "※ 每小時更新 ※",
      "singleSelectTip": "僅限單選",
      "peopleNumberTip": "{{value}} 人",
      "country": "國家",
      "geography": "國家",
      "adx": "廣告交換平台",
      "keyword": "關鍵字",
      "unicornkeywords": "關鍵字",
      "keyword1": "關鍵字 - 第 1 組 字詞",
      "keyword2": "關鍵字 - 第 2 組 字詞",
      "searchKeyword": "搜尋關鍵字",
      "unicornkeyword1": "第 1 組 字詞",
      "unicornkeyword2": "第 2 組 字詞",
      "unicornlanguage": "關鍵字語系",
      "and": "與",
      "space": "版位",
      "adspace": "版位",
      "ages": "年齡",
      "age": "年齡",
      "os": "作業系統",
      "articleCategory": "文章分類",
      "tenmaxCategory": "網站分類",
      "adcat": "網站分類",
      "carrier": "電信商",
      "contentlang": "網頁語系",
      "dealId": "指定交易 ID",
      "testMode": "測試模式",
      "segment": "再行銷受眾",
      "gender": "性別",
      "device": "裝置類型",
      "tenmaxAudience": "TenMax 受眾群",
      "domain": "網域",
      "finishEditing": "編輯完成",
      "spaceType": "版位類型",
      "outDoorDevice": "自訂機台",
      "publisher": "發佈商",
      "edit": "編輯條件設定",
      "incHaveValue": "限制流量 │希望廣告只投遞到以下流量",
      "incNoValue": "限制流量（無）",
      "excHaveValue": "排除指定流量 │ 廣告均不會出現在下列條件範圍中",
      "excNoValue": "排除指定流量（無）",
      "preferHaveValue": "優先投遞 │其中希望廣告優先投遞至",
      "preferNoValue": "優先投遞（無）",
      "nonpreferHaveValue": "不優先投遞 │也希望廣告不優先投遞至",
      "nonpreferNoValue": "不優先投遞（無）",
      "instl": "允許蓋板流量",
      "adFormat": "廣告格式",
      "agencySegment": "{{name}}的受眾包",
      "consumer_profile": "消費者輪廓",
      "bill_payment_audience": "代繳帳單受眾",
      "consumer_profile-age": "消費者輪廓-年齡",
      "consumer_profile-gender": "消費者輪廓-性別",
      "location_audience": "地點受眾",
      "offline_store_consumption": "線下超商消費受物眾",
      "offline_store_active_users": "線下超商活躍用戶",
      "purchase_power_audience": "消費力受眾",
      "preorder_products": "預購商品",
      "gaming_audience": "遊戲受眾",
      "others": "其他",
      "custom_segment": "客製化條件受眾",
      "gender_male": "性別 (男)",
      "gender_female": "性別 (女)",
      "age_1": "年齡 (0~17)",
      "age_2": "年齡 (18~24)",
      "age_3": "年齡 (25~34)",
      "age_4": "年齡 (35~44)",
      "age_5": "年齡 (45~54)",
      "age_6": "年齡 (55~64)",
      "age_7": "年齡 (65+)",
      "work_area": "工作地點受眾",
      "home_area": "住家地點受眾",
      "hospital_area": "醫院地區",
      "school_area": "學校地區",
      "business_area": "商業地區",
      "tech_area": "科學園區",
      "travel_area": "旅遊景點",
      "low_spend": "低消費力",
      "mid_spend": "中消費力",
      "high_spend": "高消費力",
      "high_activity": "高活躍度",
      "low_activity": "低活躍度",
      "discount": "折扣活動參與",
      "health_food": "保健品受眾",
      "forzen_food": "冷凍食品受眾",
      "snack": "零食",
      "makeup": "美妝",
      "goods": "居家生活",
      "coffee": "咖啡忠實受眾",
      "alcohol": "烈酒受眾",
      "beer": "啤酒受眾",
      "drinks": "飲料受眾",
      "fried_food": "炸物",
      "instant_noodles": "泡麵",
      "fresh_food": "生鮮食品",
      "oral_care": "口腔商品",
      "facial_care": "臉部保養",
      "threeC": "3C用品",
      "gaming": "遊戲儲值",
      "parking": "停車費",
      "bill": "水電瓦斯費",
      "donation": "捐款受眾",
      "i_threeC": "家電3C",
      "i_fancy_food": "高級美食",
      "i_makeup": "美妝產品",
      "i_health_food": "保健食品",
      "customOutdoorDevice": "自訂機台",
      "systemRecommendOutdoorDevice": "系統推薦",
      "geofence": "重要捷運站",
      "simulcastGroup": "同播版位",
      "storeNum": "門市資訊",
      "expandAllStores": "全部展開",
      "collapseAllStores": "全部收合",
      "unknownMunicipality": "未知縣市",
      "weatherCode": "天氣現象",
      "temperature": "氣溫限制",
      "probabilityOfPrecipitation": "降雨機率",
      "uvIndex": "紫外線指數",
      "relativeHumidity": "相對濕度",
      "options": {
        "uvIndex": {
          "low": "低量級",
          "moderate": "中量級",
          "high": "高量級",
          "veryHigh": "過量級",
          "extreme": "危險級"
        },
        "weatherCode": {
          "sunny": "晴天",
          "cloudy": "多雲",
          "rainy": "下雨",
          "snowy": "下雪"
        }
      },
      "settingSearchResult": "將有機會顯示廣告在包含 {{name}} 的 <2>{{result}}</2> 篇文章內。",
      "adxCanNotNull": "請至少選擇一個平台",
      "geograthyCanNotNull": "請至少選擇一個國家",
      "general": "一般",
      "searchKeywordsTitle": "搜尋關鍵字",
      "searchKeywords": "關鍵字",
      "searchKeywordsDes": "請輸入你要鎖定的關鍵字",
      "placement": "廣告刊登位置",
      "relatedKeywordsTitle": "相關關鍵字",
      "audienceDefinition": "受眾定義",
      "cityGroup": "地理分區",
      "administrativeArea": "行政區",
      "outdoorPlaceCategories": "區域特性",
      "deviceCharacteristic": "機台資訊",
      "interests": "興趣"
    },
    "titles": { "outdoorDeviceProperty": "機台特性" },
    "addSpace": "自訂版位",
    "addSpaceTip": "請以 \",\" 分隔版位 ID 與名稱、Enter 鍵換行後填寫其他版位",
    "placeholders": {
      "addSpace": "範例：版位ID,版位名稱\nff73b7afb2804c15,版位名字1\nfeda87ba37f94366\nfe7c4bea7b39473c,版位名字2",
      "addDomain": "tenmax.io\ngoogle.com",
      "addOutdoorDevice": "範例：機台名稱\n台北市_XXXXX1_XX門市_門口第1台\n台北市_XXXXX1_XX門市_門口第2台\n台北市_XXXXX1_XX門市_門口第3台",
      "addOutdoorStore": "範例：門市名稱\n台北市_XXXXX1_XX門市\n台北市_XXXXX2_XX門市\n台北市_XXXXX3_XX門市",
      "addPublisher": "範例：發布商ID,發布商名稱\nff73b7afb2804c15,發布商名字1\nfeda87ba37f94366\nfe7c4bea7b39473c,發布商名字2",
      "categoryTip": "選取一個屬性即可查看分類",
      "searchSpace": "搜尋 版位 …",
      "searchAdx": "搜尋 廣告交換平台 …",
      "searchCountryCity": "搜尋 國家 、 區域 或 城市 …",
      "searchCountryProvince": "搜尋 國家 、 區域 或 省份 …",
      "searchCarrier": "搜尋 電信商 …",
      "searchContentLang": "搜尋 網頁語系 …",
      "searchContentCat": "搜尋 文章分類 …",
      "searchOs": "搜尋 作業系統 …",
      "searchAges": "搜尋 年齡區間 …",
      "searchGenders": "搜尋 性別 …",
      "searchDevice": "搜尋 裝置類型 …",
      "searchTenmaxSegments": "搜尋 TenMax 受眾群 …",
      "searchDomains": "搜尋 網域 …",
      "searchAdCat": "搜尋 網站分類 …",
      "searchAgencySegment": "搜尋 經銷商受眾 …",
      "searchSegment": "搜尋 再行銷受眾 …",
      "searchGojekSegment": "搜尋 Gojek 受眾 …",
      "searchSpaceType": "搜尋 版位類型 …",
      "searchAdFormat": "搜尋廣告格式",
      "searchOutdoorDevice": "搜尋 機台 ...",
      "searchRecommendOutdoorDevice": "搜尋 系統推薦機台 ...",
      "searchGeofence": "搜尋 重要捷運站 ...",
      "searchKeywords": "請使用 \",\" 區隔關鍵字組。如：3c, smart phone",
      "searchPlacement": "搜尋廣告刊登位置"
    },
    "addDomain": "新增指定網域",
    "addDomainTip": "請以 Enter 鍵換行後填寫多個網域位址",
    "addOutdoorDevice": "客製化自訂機台",
    "addOutdoorDeviceTip": "請以Enter 鍵換行後填寫多個機台名稱",
    "addOutdoorStore": "客製化自訂門市",
    "addOutdoorStoreTip": "請以Enter 鍵換行後填寫多個門市名稱",
    "addPublisher": "自訂發布商",
    "addPublisherTip": "請以 \",\" 分隔發布商 ID 與名稱、Enter 鍵換行後填寫其他發布商",
    "addDealId": "輸入一組指定交易ID後，可使用 Enter 鍵新增不同交易ID …",
    "buttons": {
      "addDomain": "加入",
      "cancelAddDomain": "取消",
      "search": "搜尋",
      "clear": "清除",
      "addDevice": "加入機台",
      "removeDevice": "取消加入機台",
      "addStore": "加入門市",
      "removeStore": "取消加入門市"
    },
    "classificationTotal": "共 {{total}} 個選項",
    "hints": {
      "inc": "未指定限制條件時，廣告預設將投遞至所有符合活動規範的可用流量。",
      "ageGroups": "覆蓋年齡區間: {{groups}}",
      "storeCount": "門市數量：{{count}}",
      "deviceCount": "機台數量：{{count}}",
      "overBindingLimit": "已達投遞上限"
    },
    "title": {
      "you": {
        "need": "限制投遞流量方向",
        "dont": { "need": "排除投遞流量方向" }
      },
      "other": { "need": "其他條件" },
      "fixOutdoorLimitationSection": "固定機台選項",
      "weatherSection": "天氣鎖定",
      "mapSection": "地圖模式"
    },
    "hint": {
      "weatherSection": "天氣鎖定會與門市設定交集，決定哪些適合的門市可以投遞廣告"
    },
    "allow": { "inst": "允許蓋板流量" },
    "move": { "to": "移動至" },
    "include": "限制流量",
    "exclude": "排除指定流量",
    "preferred": "優先投遞",
    "nonPreferred": "不優先投遞",
    "general": "一般目標設定",
    "warning": {
      "sameTypeWarning": "已有相同流量屬性於{{type}}，請確認是否仍要覆蓋項目？"
    },
    "genders": { "male": "男性", "female": "女性", "unlimited": "全部" },
    "carries": { "chunghwa": "中華電信", "taiwanMobile": "台灣大哥大" },
    "locations": {
      "xiangshanStation": "象山捷運站",
      "daanStation": "大安捷運站",
      "nanjingFuxingStation": "南京復興捷運站",
      "songshanStation": "松山捷運站",
      "yonganMarketStation": "永安市場捷運站",
      "shilinStation": "士林捷運站",
      "tamsuiStation": "淡水捷運站",
      "taipeiNangangExhibitionCenterStation": "南港展覽館捷運站",
      "taipeiMainStation": "台北車站",
      "wanfangHospitalStation": "萬芳醫院捷運站",
      "ximenStation": "西門捷運站",
      "minquanWestRoadStation": "民權西路捷運站",
      "luzhouStation": "蘆洲捷運站",
      "fuJenUniversityStation": "輔大捷運站",
      "shanbStation": "機場捷運山鼻站"
    },
    "contentCategory": {
      "iab1": "藝術與娛樂",
      "iab1_1": "圖書與文學",
      "iab1_2": "粉絲/八卦",
      "iab1_3": "美術",
      "iab1_4": "幽默",
      "iab1_5": "電影",
      "iab1_6": "音樂",
      "iab1_7": "電視",
      "iab2": "汽車",
      "iab2_1": "汽車配件",
      "iab2_2": "汽車修理",
      "iab2_3": "買賣汽車",
      "iab2_4": "汽車文化",
      "iab2_5": "認證二手",
      "iab2_6": "敞篷車",
      "iab2_7": "跑車",
      "iab2_8": "跨界休旅車",
      "iab2_9": "柴油車",
      "iab2_10": "電動車",
      "iab2_11": "掀背車",
      "iab2_12": "油電混合",
      "iab2_13": "豪華車",
      "iab2_14": "麵包車",
      "iab2_15": "摩托車",
      "iab2_16": "越野車",
      "iab2_17": "高性能汽車",
      "iab2_18": "客貨兩用車",
      "iab2_19": "道路援助",
      "iab2_20": "轎車",
      "iab2_21": "卡車及配件",
      "iab2_22": "老爺車",
      "iab2_23": "旅行車",
      "iab3": "商業",
      "iab3_1": "廣告",
      "iab3_2": "農業",
      "iab3_3": "生技/生醫",
      "iab3_4": "商用軟體",
      "iab3_5": "建設",
      "iab3_6": "林業",
      "iab3_7": "政府",
      "iab3_8": "環保",
      "iab3_9": "人力資源",
      "iab3_10": "物流",
      "iab3_11": "行銷",
      "iab3_12": "金屬",
      "iab4": "職涯",
      "iab4_1": "職涯規劃",
      "iab4_2": "學院",
      "iab4_3": "助學金",
      "iab4_4": "招聘會",
      "iab4_5": "職位搜尋",
      "iab4_6": "履歷寫作/諮詢",
      "iab4_7": "護理",
      "iab4_8": "獎學金",
      "iab4_9": "遠距離辦公",
      "iab4_10": "美國軍事",
      "iab4_11": "職業建議",
      "iab5": "教育",
      "iab5_1": "國小教育",
      "iab5_2": "成人教育",
      "iab5_3": "藝術史",
      "iab5_4": "學院行政",
      "iab5_5": "大學生活",
      "iab5_6": "遠距離學習",
      "iab5_7": "英語作為第二語言",
      "iab5_8": "語言學習",
      "iab5_9": "研究所",
      "iab5_10": "自學",
      "iab5_11": "作業/學習技巧",
      "iab5_12": "幼稚園教育家",
      "iab5_13": "私立學校",
      "iab5_14": "特殊教育",
      "iab5_15": "學習商務",
      "iab6": "家庭與教養",
      "iab6_1": "收養",
      "iab6_2": "嬰兒及幼兒",
      "iab6_3": "托兒所/學前學校",
      "iab6_4": "家庭上網",
      "iab6_5": "幼稚園兒童教養",
      "iab6_6": "青少年教養",
      "iab6_7": "懷孕",
      "iab6_8": "特殊需求兒童",
      "iab6_9": "老人護理",
      "iab7": "保健與健身",
      "iab7_1": "運動",
      "iab7_2": "ADD",
      "iab7_3": "愛滋",
      "iab7_4": "過敏",
      "iab7_5": "替代醫學",
      "iab7_6": "關節炎",
      "iab7_7": "哮喘",
      "iab7_8": "自閉症 / PDD",
      "iab7_9": "躁鬱症",
      "iab7_10": "腦腫瘤",
      "iab7_11": "癌症",
      "iab7_12": "膽固醇",
      "iab7_13": "慢性疲勞症",
      "iab7_14": "慢性疼痛",
      "iab7_15": "感冒與流感",
      "iab7_16": "耳聾",
      "iab7_17": "牙科保健",
      "iab7_18": "抑鬱症",
      "iab7_19": "皮膚科",
      "iab7_20": "糖尿病",
      "iab7_21": "癲癇",
      "iab7_22": "GERD / 反酸",
      "iab7_23": "頭痛 / 偏頭痛",
      "iab7_24": "心臟病",
      "iab7_25": "中藥健康",
      "iab7_26": "整體治療",
      "iab7_27": "IBS / 克羅恩病",
      "iab7_28": "亂倫/濫用支持",
      "iab7_29": "尿失禁",
      "iab7_30": "不孕不育",
      "iab7_31": "男性健康",
      "iab7_32": "營養",
      "iab7_33": "骨科",
      "iab7_34": "恐慌 / 焦慮症",
      "iab7_35": "兒科",
      "iab7_36": "物理療法",
      "iab7_37": "心理/精神科",
      "iab7_38": "老人健康",
      "iab7_39": "性行為",
      "iab7_40": "睡眠障礙",
      "iab7_41": "戒菸",
      "iab7_42": "物質濫用",
      "iab7_43": "甲狀腺疾病",
      "iab7_44": "減肥",
      "iab7_45": "女性健康",
      "iab8": "食品與飲料",
      "iab8_1": "美式菜餚",
      "iab8_2": "燒烤和燒烤",
      "iab8_3": "印第安 / 克里奧爾菜",
      "iab8_4": "中國菜",
      "iab8_5": "雞尾酒/啤酒",
      "iab8_6": "咖啡 / 茶",
      "iab8_7": "料理專用",
      "iab8_8": "甜點和烘焙",
      "iab8_9": "外出用餐",
      "iab8_10": "食物過敏",
      "iab8_11": "法國菜",
      "iab8_12": "健康 / 低脂肪烹飪",
      "iab8_13": "義大利美食",
      "iab8_14": "日本料理",
      "iab8_15": "墨西哥菜",
      "iab8_16": "素食",
      "iab8_17": "素食主義者",
      "iab8_18": "葡萄酒",
      "iab9": "興趣嗜好",
      "iab9_1": "藝術 / 技術",
      "iab9_2": "工藝品",
      "iab9_3": "珠寶手作",
      "iab9_4": "賞鳥",
      "iab9_5": "棋類 / 拼圖",
      "iab9_6": "手作蠟燭肥皂",
      "iab9_7": "紙牌遊戲",
      "iab9_8": "國際象棋",
      "iab9_9": "雪茄",
      "iab9_10": "收集",
      "iab9_11": "漫畫書",
      "iab9_12": "繪圖/草圖",
      "iab9_13": "自由寫作",
      "iab9_14": "家譜",
      "iab9_15": "出版",
      "iab9_16": "吉他",
      "iab9_17": "生活影音記錄",
      "iab9_18": "投資/專利",
      "iab9_19": "飾品製作",
      "iab9_20": "魔術 / 幻象",
      "iab9_21": "刺繡",
      "iab9_22": "繪畫",
      "iab9_23": "攝影",
      "iab9_24": "電台",
      "iab9_25": "角色扮演",
      "iab9_26": "科幻",
      "iab9_27": "拼貼",
      "iab9_28": "編劇",
      "iab9_29": "郵票錢幣",
      "iab9_30": "影音 / 電動",
      "iab9_31": "木工",
      "iab10": "居家與園藝",
      "iab10_1": "家電",
      "iab10_2": "娛樂",
      "iab10_3": "環境安全",
      "iab10_4": "園藝",
      "iab10_5": "家居維修",
      "iab10_6": "家庭影院",
      "iab10_7": "室內裝飾",
      "iab10_8": "園林綠化",
      "iab10_9": "改造與建設",
      "iab11": "法律，政府與政治",
      "iab11_1": "移民",
      "iab11_2": "法律問題",
      "iab11_3": "美國政府資源",
      "iab11_4": "政治",
      "iab11_5": "評論",
      "iab12": "新聞",
      "iab12_1": "國際新聞",
      "iab12_2": "國內新聞",
      "iab12_3": "本地新聞",
      "iab13": "個人理財",
      "iab13_1": "初階投資",
      "iab13_2": "信用 / 債務及貸款",
      "iab13_3": "財經新聞",
      "iab13_4": "財務規劃",
      "iab13_5": "對沖基金",
      "iab13_6": "保險",
      "iab13_7": "投資",
      "iab13_8": "共同基金",
      "iab13_9": "選擇權",
      "iab13_10": "退休規劃",
      "iab13_11": "股票",
      "iab13_12": "稅收籌劃",
      "iab14": "社會",
      "iab14_1": "約會",
      "iab14_2": "離婚支持",
      "iab14_3": "同性戀生活",
      "iab14_4": "婚姻",
      "iab14_5": "老年生活",
      "iab14_6": "青少年",
      "iab14_7": "婚禮",
      "iab14_8": "民族",
      "iab15": "科學",
      "iab15_1": "占星術",
      "iab15_2": "生物學",
      "iab15_3": "化學",
      "iab15_4": "地質學",
      "iab15_5": "超自然現象",
      "iab15_6": "物理",
      "iab15_7": "空間 / 天文",
      "iab15_8": "地理",
      "iab15_9": "植物學",
      "iab15_10": "天氣",
      "iab16": "寵物",
      "iab16_1": "水族館",
      "iab16_2": "鳥",
      "iab16_3": "貓",
      "iab16_4": "狗",
      "iab16_5": "大型動物",
      "iab16_6": "爬行動物",
      "iab16_7": "獸醫",
      "iab17": "體育",
      "iab17_1": "賽車",
      "iab17_2": "棒球",
      "iab17_3": "自行車",
      "iab17_4": "健美",
      "iab17_5": "拳擊",
      "iab17_6": "獨木舟 / 皮划艇",
      "iab17_7": "啦啦隊",
      "iab17_8": "爬山",
      "iab17_9": "板球",
      "iab17_10": "花樣滑冰",
      "iab17_11": "釣魚",
      "iab17_12": "足球",
      "iab17_13": "淡水釣魚",
      "iab17_14": "遊戲和魚",
      "iab17_15": "高爾夫",
      "iab17_16": "賽馬",
      "iab17_17": "馬",
      "iab17_18": "打獵/射擊",
      "iab17_19": "直排輪",
      "iab17_20": "武術",
      "iab17_21": "越野自行車",
      "iab17_22": "NASCAR賽車",
      "iab17_23": "奧運會",
      "iab17_24": "漆彈",
      "iab17_25": "摩托車",
      "iab17_26": "專業籃球",
      "iab17_27": "專業冰球",
      "iab17_28": "牛仔競技",
      "iab17_29": "橄欖球",
      "iab17_30": "跑步 / 慢跑",
      "iab17_31": "帆船",
      "iab17_32": "鹹水釣魚",
      "iab17_33": "水肺潛水",
      "iab17_34": "滑板",
      "iab17_35": "滑雪",
      "iab17_36": "滑雪板",
      "iab17_37": "衝浪",
      "iab17_38": "游泳",
      "iab17_39": "乒乓球 / 乒乓",
      "iab17_40": "網球",
      "iab17_41": "排球",
      "iab17_42": "散步",
      "iab17_43": "滑水 / 滑水",
      "iab17_44": "世界足球",
      "iab18": "風格時尚",
      "iab18_1": "美容",
      "iab18_2": "人體藝術",
      "iab18_3": "時尚",
      "iab18_4": "珠寶",
      "iab18_5": "服裝",
      "iab18_6": "配件",
      "iab19": "技術和電腦",
      "iab19_1": "3-D圖形",
      "iab19_2": "動畫",
      "iab19_3": "防毒軟體",
      "iab19_4": "C / C ++",
      "iab19_5": "相機及攝影機",
      "iab19_6": "手機",
      "iab19_7": "電腦認證",
      "iab19_8": "網際網路",
      "iab19_9": "電腦外部設備",
      "iab19_10": "電腦評測",
      "iab19_11": "數據中心",
      "iab19_12": "數據庫",
      "iab19_13": "桌面出版",
      "iab19_14": "電腦影音",
      "iab19_15": "電子郵件",
      "iab19_16": "圖形軟體",
      "iab19_17": "家用影音 / DVD",
      "iab19_18": "互聯網科技",
      "iab19_19": "Java",
      "iab19_20": "JavaScript",
      "iab19_21": "Mac技術支援",
      "iab19_22": "MP3 / MIDI",
      "iab19_23": "網路會議",
      "iab19_24": "網頁入門",
      "iab19_25": "網路安全",
      "iab19_26": "掌上電腦 / 掌上電腦",
      "iab19_27": "電腦技術支援",
      "iab19_28": "可攜式",
      "iab19_29": "娛樂",
      "iab19_30": "共享軟體 / 免費軟體",
      "iab19_31": "Unix",
      "iab19_32": "Visual Basic",
      "iab19_33": "網頁剪貼藝術",
      "iab19_34": "網頁設計/ HTML",
      "iab19_35": "網路搜尋",
      "iab19_36": "Windows",
      "iab20": "旅遊",
      "iab20_1": "探險旅遊",
      "iab20_2": "非洲",
      "iab20_3": "航空旅行",
      "iab20_4": "澳洲和紐西蘭",
      "iab20_5": "招待所",
      "iab20_6": "平價旅遊",
      "iab20_7": "商務旅遊",
      "iab20_8": "通過美國區域設置",
      "iab20_9": "露營",
      "iab20_10": "加拿大",
      "iab20_11": "加勒比海",
      "iab20_12": "遊輪",
      "iab20_13": "東歐",
      "iab20_14": "歐洲",
      "iab20_15": "法國",
      "iab20_16": "希臘",
      "iab20_17": "蜜月 / 度假地",
      "iab20_18": "酒店",
      "iab20_19": "意大利",
      "iab20_20": "日本",
      "iab20_21": "墨西哥和中美洲",
      "iab20_22": "國家公園",
      "iab20_23": "南美",
      "iab20_24": "溫泉",
      "iab20_25": "主題公園",
      "iab20_26": "親子旅行",
      "iab20_27": "英國",
      "iab21": "房地產",
      "iab21_1": "公寓",
      "iab21_2": "建築師",
      "iab21_3": "購買 / 出售公寓",
      "iab22": "購物",
      "iab22_1": "競賽和贈品",
      "iab22_2": "優惠券",
      "iab22_3": "比價",
      "iab22_4": "搜尋引擎",
      "iab23": "宗教與靈性",
      "iab23_1": "替代宗教",
      "iab23_2": "無神論 / 不可知論",
      "iab23_3": "佛教",
      "iab23_4": "天主教",
      "iab23_5": "基督教",
      "iab23_6": "印度教",
      "iab23_7": "伊斯蘭教",
      "iab23_8": "猶太教",
      "iab23_9": "後期聖徒",
      "iab23_10": "異教徒/巫術",
      "iab24": "未分類",
      "iab25": "非標準內容",
      "iab25_1": "未經協調的 UGC",
      "iab25_2": "極端圖形 / 顯性暴力",
      "iab25_3": "色情",
      "iab25_4": "褻瀆內容",
      "iab25_5": "仇恨的內容",
      "iab25_6": "正在建置中",
      "iab25_7": "誘因",
      "iab26": "非法內容",
      "iab26_1": "非法內容",
      "iab26_2": "名單中",
      "iab26_3": "間諜軟件 / 惡意軟件",
      "iab26_4": "侵犯版權",
      "countHint": "所選文章分類中，近7日內總計顯示 {{count}} 篇文章。"
    },
    "errors": {
      "invalidSpaceName": "<1>版位名稱驗證失敗</1>\n請確認名稱與原始資料一致，且僅包含符號 <2>[</2>、<2>]</2> 與 <2>_</2>。若含有其他異常字元或空格，將無法成功加入。",
      "invalidStoreName": "<1>門市名稱驗證失敗</1>\n請確認名稱與原始資料一致，且僅包含符號 <2>[</2>、<2>]</2> 與 <2>_</2>。若含有其他異常字元或空格，將無法成功加入。"
    }
  },
  "adFormat": { "instl": "蓋板" },
  "rtbCampaignSetupStep": {
    "labels": {
      "fixOutdoorDeviceSection": "固定機台的選項",
      "fixOutdoorStoreSection": "固定門市的選項"
    },
    "hints": {
      "fixOutdoorDeviceSection": "系統將固定當前機台清單並開放下載",
      "fixOutdoorStoreSection": "系統將固定當前門市清單並開放下載"
    }
  },
  "campaign": {
    "buttons": {
      "downloadFixOutdoorStoreData": "下載門市資訊檔案",
      "downloadFixOutdoorDeviceData": "下載機台資訊檔案",
      "importOutdoorStore": "匯入門市資訊檔案",
      "importOutdoorDevice": "匯入機台資訊檔案",
      "cancelCreate": "取消建立",
      "saveDraft": "儲存草稿",
      "cancelEdit": "取消編輯",
      "adTypeDisplayTitle": "展示型廣告",
      "adTypeVideoTitle": "影音廣告",
      "adTypeComboTitle": "影+圖廣告",
      "adTypeSandboxOutdoorTitle": "研發測試用戶外廣告",
      "adTypeSandboxMovableOutdoorTitle": "研發測試用移動式戶外廣告",
      "adTypePicShortTitle": "PIC 戶外 15 秒廣告",
      "adTypePicLongTitle": "PIC 戶外 30 秒廣告",
      "adTypePicExtendedTitle": "PIC 戶外 60 秒廣告",
      "adTypePicBroadTitle": "PIC 戶外 60+ 秒廣告",
      "adTypeHwacomShortTitle": "華電聯網 15 秒廣告",
      "adTypeHwacomLongTitle": "華電聯網 30 秒廣告",
      "adTypeHwacomExtendedTitle": "華電聯網 60 秒廣告",
      "adTypeHwacomBroadTitle": "華電聯網 60+ 秒廣告",
      "adTypeFridgeBroadTitle": "冰櫃戶外 60+ 秒廣告",
      "adTypeFridgeLongTitle": "冰櫃戶外 30 秒廣告",
      "adTypeFridgeExtendedTitle": "冰櫃戶外 60 秒廣告",
      "adTypePmpPicTitle": "PMP PIC 戶外廣告",
      "adTypePmpFridgeTitle": "PMP 冰櫃戶外廣告",
      "adTypeThirdPartyTitle": "AdNeon",
      "adTypeThirdPartyBottomTitle": "行動置底廣告",
      "adTypeThirdPartyRectangleTitle": "中矩形廣告",
      "adTypeOutdoorLineMessageTitle": "Outdoor Line Message 廣告",
      "adTypeLineMessageTitle": "Line Message 廣告",
      "adTypeDisplayDesc": "Image│HTML5│Native│Dynamic",
      "adTypeVideoDesc": "In-Stream│Out-Stream",
      "adTypeComboDesc": "影+圖",
      "adTypeSandboxOutdoorDesc": "研發測試用戶外影音廣告",
      "adTypeSandboxMovableOutdoorDesc": "研發測試用移動式戶外影音廣告",
      "adTypePicShortDesc": "PIC 戶外 15 秒廣告",
      "adTypePicLongDesc": "PIC 戶外 30 秒廣告",
      "adTypePicExtendedDesc": "PIC 戶外 60 秒廣告",
      "adTypePicBroadDesc": "PIC 戶外 60+ 秒廣告",
      "adTypeHwacomShortDesc": "華電聯網 15 秒廣告",
      "adTypeHwacomLongDesc": "華電聯網 30 秒廣告",
      "adTypeHwacomExtendedDesc": "華電聯網 60 秒廣告",
      "adTypeHwacomBroadDesc": "華電聯網 60+ 秒廣告",
      "adTypeFridgeBroadDesc": "冰櫃戶外 60+ 秒廣告",
      "adTypeFridgeLongDesc": "冰櫃戶外 30 秒廣告",
      "adTypeFridgeExtendedDesc": "冰櫃戶外 60 秒廣告",
      "adTypeOutdoorLineMessageDesc": "Outdoor Line Message 廣告",
      "adTypeLineMessageDesc": "Line Message 廣告",
      "adTypePmpPicDesc": "PMP PIC 戶外廣告",
      "adTypePmpFridgeDesc": "PMP 冰櫃戶外廣告",
      "adTypeThirdPartyDesc": "AdNeon",
      "adTypeThirdPartyBottomDesc": "行動置底",
      "adTypeThirdPartyRectangleDesc": "中矩形",
      "adTypeCTVTitle": "數位電視廣告",
      "adTypeCTVDesc": "聯網電視│聯網設備│機上盒",
      "adTypeMessageTitle": "簡訊廣告",
      "adTypeMessageDesc": "簡訊",
      "completeAndCheck": "完成並檢查",
      "send": "送出",
      "back": "返回上一步",
      "saveAndBindCreative": "送出並新增素材"
    },
    "labels": {
      "adType": "廣告活動類型",
      "noSupportedAdType": "目前沒有可用的廣告活動類型，請聯絡系統管理員開啟相對應的功能",
      "pmpSelect": "選擇 PMP 訂單",
      "campaignSetting": "廣告活動設定",
      "summary": "資訊總覽",
      "standard": "標準投遞",
      "accelerated": "密集投遞",
      "deliverType": "投遞速率",
      "orderPrice": "- 合約價格",
      "orderPriceChange": "管理者調整合約價格\n從 {{from}} 改成 {{to}}",
      "adTypePageTitle": "選擇廣告活動類型",
      "createCampaignTitle": "新增廣告活動",
      "editCampaignTitle": "編輯廣告活動",
      "splitCampaignTitle": "切割廣告活動",
      "copyCampaignTitle": "複製廣告活動",
      "editCampaignDraftTitle": "編輯草稿",
      "summaryCampaignTitle": "廣告活動總覽",
      "videoObjective": "觀看目標",
      "videoObjectiveDefault": "預設",
      "videoObjectiveProgress": "秒數",
      "videoObjectiveMetric": "事件",
      "rs": "動態競價",
      "dcpm": "動態 CPM",
      "fcpc": "固定式 CPC",
      "fcpm": "固定式 CPM",
      "fbcpm": "每則訊息費用",
      "fcpv": "固定式 CPV",
      "fvcpm": "固定式 vCPM",
      "facpm": "固定式 aCPM",
      "fwcpm": "固定式 wCPM",
      "rb": "包版",
      "cpc": "CPC",
      "cpm": "CPM",
      "cpv": "CPV",
      "vcpm": "vCPM",
      "fixed_viewable_impression": "可視曝光",
      "firstquartile": "觀看 25% 影片內容",
      "midpoint": "觀看 50% 影片內容",
      "complete": "觀看 100% 影片內容",
      "thirdquartile": "觀看 75% 影片內容",
      "sec": "秒",
      "targetClicks": "目標 {{value}} 點擊數",
      "targetKImpressions": "目標 {{value}} 千次曝光",
      "targetKPublisherImpressions": "目標 {{value}} 千次人流",
      "targetViews": "目標 {{value}} 觀看數",
      "targetMessages": "目標 {{value}} 次訊息",
      "tags": "標籤",
      "agencyProfit": "經銷商利潤",
      "budgetPercentage": "預算比例",
      "creativeDeliverType": { "optimize": "優化投遞", "average": "平均投遞" },
      "outdoorDeliverType": {
        "optimize": "機台最佳化",
        "average": "機台平均投遞"
      },
      "convTrackEventclick": "點擊後轉換",
      "convTrackEventview": "觀看後轉換",
      "convTrackEvent": "轉換追蹤模式",
      "hour": "時",
      "day": "天",
      "week": "週",
      "group": { "rs": "CPC動態競價", "fcpc": "固定式 CPC" }
    },
    "descriptions": {
      "notWithinOrderDayRange": "超出訂單走期",
      "overDailyBudget": "在走期內，<1>提前花完</1>預算",
      "underDailyBudget": "在走期內，<1>無法花完</1>預算",
      "meetDailyBudget": "在走期內，<1>預算分配完畢</1>",
      "lengthError": "字數必須少於 255",
      "messageLengthError": "簡訊內容字數不能超過 134 字元",
      "messageClickUrlMacroError": "簡訊內容必須且只能包含一個導外網址",
      "clickUrlFieldEmpty": "※ 必須設定導外網址內容",
      "smallerThanBudgetZero": "預算不可低於 0",
      "smallerThanDailyMnBudgetSum": "每日最低金額是 {{dmin}}，天數x每日最低金額不可低於 {{min}}",
      "smallerThanCampaignBudgetMinimum": "預算不可低於廣告活動預算最小值 {{min}}",
      "smallerThanBudgetMinimum": "預算不可低於 {{min}}",
      "smallerThanBudgetMinimumDetail": "預算不可低於 {{min}}, 目前分配到的預算為{{budget}}",
      "smallerThanRTBBudgetMinimum": "此設定會導致RTB分配到的預算低於RTB最低預算，建議必須大於{{min}}",
      "smallerThanSpents": "不可低於已花費預算{{min}}",
      "smallerThanExpectSpents": "不可低於預期花費{{min}}",
      "smallerThanExpectSpentsDetail": "不可低於預期花費{{min}}, 目前分配到的預算為{{budget}}",
      "smallerThanRTBExpectSpents": "此設定會導致RTB分配到的預算低於RTB預期花費，建議必須大於{{min}}",
      "percentSmallerThanLowerbound": "不可低於總預算{{min}}%",
      "percentBiggerThanUpperbound": "不可高於總預算{{max}}%",
      "overed": "已超過",
      "overBudget": "{{wording}} <1>總共可支配預算</1><2>：{{currency}} {{overBudget}}</2>",
      "remainBudget": "剩餘可支配預算 <1>{{currency}}{{remainBudget}}</1>",
      "percentBudgetHint": "分配到的預算 <1>{{currency}}{{budget}}</1>",
      "orderPriceTips": "金額請高於 <1> {{price}} </1> 元以上",
      "comboObjectiveDefault": "以觀看 2 秒影片內容為認定標準",
      "videoObjectiveDefault": "以觀看 100% 影片內容為認定標準",
      "videoObjectiveProgress": "只適用 影+圖 類型素材",
      "videoObjective25Event": "觀看率 25% 認定只適用於 In-Stream、影+圖 和 Out-Stream 等類型素材",
      "videoObjective50100Event": "觀看率 50% 或100% 只適用於 In-Stream 和 影+圖 類型素材",
      "videoObjectiveAllEvent": "適用於 In-Stream、影+圖 及 In-Stream 類型素材",
      "adTypeChangeAlert": "如果切換類型，剛剛編輯的內容將會重置，確定要切換嗎？",
      "campaignSchedulingDay": "總計 <1>{{days}} 日</1>",
      "campaignSchedulingHour": "總計 <1>{{hours}} 小時</1>",
      "priceMinimum": "金額請高於 {{min}} 以上",
      "bidPriceRange": "金額請高於 <1>{{min}}</1> 以上，且不可超過合約價格 <3>{{orderPrice}}</3>",
      "moreThanDays": "請選擇不超出{{days}}天的時間區間",
      "moreThanHours": "請選擇不超出7天或{{hours}}小時的時間區間",
      "createBeforeNow": "無法選擇已過去的時間為開始時間",
      "startDayBeforeOrder": "開始時間必須大於訂單開始時間",
      "endDayBeforeNow": "無法選擇已過去的時間為結束時間",
      "invalidValue": "此選項已不再可用",
      "budgetPercentageHoverHint": "※ 投遞如果進行超過一半，將無法修改",
      "cannotEditBudgetPercentHint": "※ 投遞已進行超過一半，無法修改預算比例",
      "budgetPercentageRangeHint": "只能往下調整初始數值({{init}})的50%，現可修改的範圍為{{min}}% ~ {{max}}%",
      "initBudgetPercentageRangeHint": "可設定的範圍為{{min}}% ~ {{max}}%",
      "minL1ObjectBudget": "您的廣告群組預算必須至少為 {{budget}}，才能涵蓋此廣告群組中的所有廣告活動。"
    },
    "prefixs": {
      "videoObjectiveProgress": "觸發時間(秒)",
      "videoObjectiveMetric": "觸發事件"
    },
    "strategyAndTracking": {
      "conversionTracking": "轉換追蹤",
      "newThirdPartyTracking": "新增第三方追蹤",
      "thirdPartyTracking": "第三方追蹤",
      "thirdPartyTrackingType": "代碼型態",
      "thirdPartyTrackingTypePixel": "像素代碼或網址",
      "thirdPartyTrackingTypeJs": "JavaScript 程式碼網址",
      "thirdPartyTrackingCode": "追蹤碼",
      "thirdPartyTrackingPreview": "解析結果",
      "videoProgressTracking": "再行銷追蹤",
      "videoProgressTrackingCode": "再行銷追蹤代碼",
      "videoProgressTrackingCodeOffset": "觸發時間 (秒)",
      "noURL": "無法解析",
      "asiaMaxOnlyHint": "*注意: 加上 JS 類型的第三方 tracker 後，將只能投遞 asiamax 流量",
      "viewableImpressionTrigger": "可視曝光",
      "impressionTrigger": "曝光",
      "trigger": "觸發類型"
    },
    "name": "廣告活動名稱",
    "placeholders": {
      "tags": "輸入活動標籤文字後，可使用 Enter 鍵新增不同標籤 …"
    },
    "errors": {
      "movableOutdoorAreaDerivationFailed": "無法從以下座標推導行政區：{{coordinates}}，請確認座標有效並重試。"
    }
  },
  "campaignInfo": {
    "labels": {
      "title": "廣告基本資訊 與 計價模式",
      "order": "訂單",
      "campaignName": "廣告活動名稱",
      "dayRange": "走期",
      "deliverDate": "投遞時間",
      "message": "簡訊內容",
      "priceModel": "計價模式",
      "totalBudget": "活動總預算",
      "dailyBudgetPlan": "預算分配",
      "schedule": "全走期平均分配",
      "daily": "每日指定預算",
      "cannotModifyHint": "※ 活動建立後，將無法修改！",
      "cannotModifyPriceModelHint": "※ 活動建立後，將無法修改計價模式！",
      "dateCannotModifyHint": "※ 廣告活動開始執行後，將無法修改開始日期。",
      "optimizeTitle": "智慧出價模式",
      "optimizeCap": "{{optimize}} 出價上限金額",
      "creativeDeliverType": "素材投遞方式",
      "outdoorDeliverType": "機台投遞方式",
      "optimize": "智慧出價模式",
      "minimizeHint": "金額請高於 {{optimizeMinimum}}元以上",
      "frequencySessionTitle": "廣告投遞頻率 與 投遞時段限制",
      "sessionCapping": "一受眾指定天數內次數",
      "daypart": "指定投遞時間區段",
      "rbPriceModelHint": "需要指定廣告版位",
      "isOutOfOutdoorBk": "是否排除 outdoor BK 計算",
      "orderPriceEnable": "手動設定合約價格",
      "allowOverrun": "允許超跑",
      "lifeHint": "在廣告全走期內，一位受眾觀看本廣告的最多次數",
      "bLifeHint": "在廣告全走期內，一位受眾觀看到本廣告各項素材的次數",
      "sessionHint": "在所設時間區段內，一位受眾觀看到本廣告的最多次數",
      "bSessionHint": "在所設時間區段內，一位受眾觀看到本廣告各項素材的次數",
      "messageHint": "剩餘 {{number}} 個字元",
      "enableMonitor": "允許監控異常狀態",
      "autoBudgetOptimize": "自動優化預算",
      "autoBudgetOptimizeHint": "開啟此功能後，系統將會依據廣告成效自動調整預算分配比例",
      "group": { "priceModel": "RTB計價模式" },
      "CBOBudgetHint": "CBO 活動群組控制活動的預算，用戶無需設置預算。",
      "backToEditRtbCampaignGroup": "單擊此處返回以修改廣告群組預算。"
    },
    "hints": {
      "acceleratedDeliverType": "注意：啟用後，系統將在流量符合時『不間斷集中投遞』，極可能導致預算在短時間內大幅提前用罄。請務必謹慎評估並密切監控花費進度。"
    }
  },
  "stepSideBar": {
    "labels": {
      "basic": "基本資訊",
      "targeting": "優化目標",
      "strategyAndTracking": "各類追蹤模式",
      "adLogo": "廣告 Logo",
      "creativeChooseAdvertiser": "選擇廣告主",
      "creativeSetUp": "設定素材",
      "creativeSummary": "資訊總覽",
      "creativeBasic": "基本資訊",
      "creativeLimitation": "優化目標",
      "campaignSettingSummary": "活動設定",
      "creativeSettingSummary": "素材設定"
    }
  },
  "campaignSummary": {
    "labels": {
      "adTypeDisplay": "展示型廣告",
      "adTypePicShort": "PIC 戶外 15 秒廣告",
      "adTypePicLong": "PIC 戶外 30 秒廣告",
      "adTypePicExtended": "PIC 戶外 60 秒廣告",
      "adTypePicBroad": "PIC 戶外 60+ 秒廣告",
      "adTypeFridgeBroad": "冰櫃戶外 60+ 秒廣告",
      "adTypeFridgeLong": "冰櫃戶外 30 秒廣告",
      "adTypeFridgeExtended": "冰櫃戶外 60 秒廣告",
      "adTypeVideo": "影音廣告",
      "adTypeThirdParty": "AdNeon",
      "adTypeThirdPartyBottom": "行動置底廣告",
      "adTypeThirdPartyRectangle": "中矩形廣告",
      "adTypeMessage": "簡訊廣告",
      "adTypeSandboxOutdoor": "研究測試用戶外廣告",
      "adTypeSandboxMovableOutdoor": "研發測試用移動式戶外廣告",
      "adTypeOutdoorLineMessage": "Outdoor Line Message 廣告",
      "adTypeLineMessage": "Line Message 廣告",
      "orderName": "訂單",
      "campaignName": "廣告活動名稱",
      "schedule": "走期",
      "deliverDate": "投遞時間",
      "message": "簡訊內容",
      "pricingModel": "計價模式",
      "orderPrice": "{{model}} 合約價格",
      "campaignBudget": "活動總預算",
      "budgetDistribution": "預算分配",
      "budgetScheduleDistribution": "全走期平均分配",
      "budgetDailyDistribution": "{{currency}}{{budget}}/日",
      "optimizeModel": "智慧出價模式",
      "optimizePriceCap": "{{model}}投遞上限",
      "creativeDeliveryType": "素材投遞方式",
      "creativeOptimizeDelivery": "優化投遞",
      "creativeUniformDelivery": "平均投遞",
      "budgetPercentage": "預算比例",
      "autoBudgetOptimize": "自動優化預算",
      "videoAdViewObjective": "觀看目標",
      "videoAdViewObjectiveMetric": "事件：{{metric}}",
      "videoAdViewObjectiveProgress": "秒數：{{offset}}秒",
      "videoAdViewObjectiveDefault": "預設",
      "fixOutdoorSpace": "是否固定門市選項",
      "conversionTracking": "轉換追蹤",
      "trackingCodes": "連結",
      "videoProgressTrackingCode": "追蹤碼",
      "videoProgressTrackingOffset": "觸發時間",
      "dayPart": "指定投遞時間區段",
      "deliverType": "投遞速率",
      "standard": "標準",
      "accelerated": "密集",
      "tags": "標籤",
      "uniqueUserTitle": "預估每週觸及人數",
      "impressionTitle": "預估曝光數",
      "uniqueUserInformation": "依現行目標鎖定設定估算出的每週廣告受眾規模總和，實際觸及人數也將因您的預算設定而有所不同。",
      "estimateDesc": "預估每週觸及數和預估曝光數跟實際廣告受眾規模可能不盡相同，其預估依據為您對限制流量或排除指定流量中的設定：",
      "limitationNotEstimateDesc": "暫無提供排除指定流量或限制流量中包含再行銷受眾、TenMax受眾群、關鍵字等條件的預估觸及人數和預估曝光數",
      "impressionInformation": "預期您的廣告在未來一週內的曝光數，實際曝光數也將因預算設定而有所不同。",
      "rbNotEstimateDesc": "計價模式為包版時，將無法提供預估觸及人數和預估曝光數",
      "estimateLowHint": "優化目標設定太過嚴格囉！",
      "convTrackEventClick": "點擊後轉換",
      "convTrackEventView": "觀看後轉換",
      "convTrackEvent": "轉換追蹤模式",
      "autoBid": "自動調整",
      "enableMonitor": "允許監控異常狀態",
      "group": { "pricingModel": "RTB計價模式" },
      "adTypeOneForAllDisplay": "One For All 展示型廣告",
      "startDate": "開始時間",
      "endDate": "結束時間",
      "storeDeliverable": "會投放的門市",
      "deviceDeliverable": "會投放的機台",
      "storeWeatherNonDeliverable": "天氣篩選的門市",
      "deviceWeatherNonDeliverable": "天氣篩選的機台",
      "storeChangeNonDeliverable": "門市異動",
      "deviceChangeNonDeliverable": "機台異動",
      "deviceOverBindingLimitNonDeliverable": "超過鎖定上限的機台",
      "storeOverBindingLimitNonDeliverable": "超過鎖定上限的門市"
    },
    "titles": {
      "generalInformation": "廣告基本資訊 與 計價模式",
      "optimizeSetting": "智慧出價模式設定",
      "advanceSetting": "廣告投遞頻率與投遞時段限制",
      "inc": "限制流量",
      "exc": "排除指定流量",
      "preferred": "優先投遞",
      "nonPreferred": "不優先投遞",
      "other": "其他",
      "adType": "廣告活動類型",
      "basicSetting": "基本資訊",
      "targetSetting": "優化目標",
      "trackingSetting": "各類追蹤",
      "conversionTracking": "使用轉換追蹤",
      "trackingCodes": "追蹤碼連結",
      "videoProgressTrackingCode": "再行銷追蹤",
      "checkYourSettings": "檢查你的設定",
      "adLogo": "廣告 Logo",
      "storeDeliverability": "可以投遞門市/總設定門市",
      "deviceDeliverability": "可以投遞機台/總設定機台"
    }
  },
  "summary": { "titles": { "noData": "無", "generalInfo": "一般資訊" } },
  "daypart": {
    "labels": {
      "monday": "週一",
      "tuesday": "週二",
      "wednesday": "週三",
      "thursday": "週四",
      "friday": "週五",
      "saturday": "週六",
      "sunday": "週日",
      "optionsPlaceholder": "請選擇投遞時段 …",
      "am": "上午",
      "pm": "下午",
      "hourUnit": "小時",
      "allDay": "全日不限時段",
      "afternoon": "午後：12 - 17 時",
      "evening": "晚間：18 - 23 時",
      "morning": "晨間：6 - 11 時",
      "weekday": "週間：週一至週五",
      "weekend": "週末時段",
      "conversionOptimize": "高轉換率優化時段",
      "midnightDisabled": "排除半夜時段",
      "mobileOptimize": "手機高使用率時段",
      "pcOptimize": "電腦高使用率時段"
    },
    "segments": {
      "h00": "00:00 - 05:59",
      "h06": "06:00 - 11:59",
      "h12": "12:00 - 17:59",
      "h18": "18:00 - 23:59"
    }
  },
  "errorPage": {
    "labels": {
      "403": "抱歉，您似乎沒有對應的權限，<1/>\n也許您可以 <3>嘗試以其他角色身份登入</3>，或者...",
      "404": "Oops ! 找不到任何資料，<1/>\n也許您可以 <3>瀏覽其他頁面</3>，或者...",
      "back": "返回",
      "contact": "聯絡我們"
    }
  },
  "orderDetail": {
    "labels": {
      "orderNumber": "訂單編號",
      "orderType": "訂單類型",
      "externalId": "外部訂單編號",
      "externalType": "外部訂單類別",
      "dateRange": "走期",
      "remainDays": "剩餘天數",
      "today": "今天",
      "totalBudget": "總預算",
      "alreadySpent": "已花費",
      "remainBudget": "剩餘可支配預算",
      "progress": "訂單執行中",
      "agencyProfit": "經銷商利潤",
      "impres": "曝光數",
      "viewable": "可視曝光數",
      "clicks": "點擊數",
      "ctr": "點擊率",
      "adView": "觀看數",
      "viewRate": "觀看率",
      "originBudget": "{{budget}} (原預算)",
      "changeBudget": "{{budget}} (審核中)",
      "originProfit": "{{profit}} % (原利潤)",
      "changeProfit": "{{profit}} % (審核中)",
      "days": "{{days}}天",
      "settleWait": "訂單結算中，請稍候 …",
      "settledNoNeedSettle": "已結算的訂單不需要再結算",
      "settleSuccess": "結算成功",
      "unsettleSuccess": "取消結算成功",
      "creator": "建立者",
      "creatorEmail": "電子信箱",
      "monitor": "訂單監控",
      "channelMargin": "{{channel}} 經銷商利潤",
      "title": "訂單與活動列表",
      "name": "訂單名稱：{{name}}",
      "hasRunningCampaignCannotSettle": "有未開始或正在執行/暫停中的廣告活動無法結算",
      "finished": "已結束",
      "notstart": "未開始",
      "isEndCannotCreate": "已結束的訂單無法建立廣告活動",
      "orderStateCannotCreate": "未核准 / 結算中 / 已結算 的訂單無法建立廣告活動",
      "lessThanBudgetMinimum": "剩餘可支配預算低於最小投遞金額 {{budget}}",
      "report": "廣告成效",
      "generalReport": "一般廣告",
      "videoReport": "影音廣告",
      "downloadRtbReport": "下載 RTB 報表",
      "downloadOutdoorReport": "下載 Outdoor 報表",
      "editOrder": "編輯訂單",
      "waitingForReview": "審核中",
      "reject": "駁回",
      "settle": "結算中",
      "settled": "已結算",
      "approve": "核准",
      "status": "狀態",
      "approveSuccess": "核准成功",
      "rejectSuccess": "駁回成功",
      "modifyReason": "異動理由",
      "orderPrice": "CPM合約價格",
      "creativeDuration": "預估素材播放秒數",
      "dayPart": "指定投遞時間區段",
      "messageCampaignStartTimeError": "簡訊廣告最晚設定時間不能超過訂單結束當天"
    },
    "errors": {
      "budgetExceedStoredValueError": "儲值額度不足，預算不可大於 {{amount}}"
    },
    "buttons": { "settle": "結算", "unsettle": "取消結算" },
    "tabs": {
      "campaign": "廣告活動",
      "campaignControl": "預算分配群組",
      "record": "紀錄"
    }
  },
  "orderForm": {
    "errors": {
      "budgetExceedStoredValueError": "儲值額度不足，預算不可大於 {{max}}",
      "endDateError": "無法選擇已過去的日期為結束日期",
      "finalReport": {
        "receivers": "內含不合法的電子郵件： {{invalidEmails}}"
      },
      "projectNamePatternError": "Onelink campaign name 必須是不含符號或空白的 CamelCase 英數字串"
    },
    "labels": {
      "advertiser": "廣告主",
      "name": "訂單名稱",
      "externalId": "外部訂單編號",
      "dateRange": "走期",
      "dateCannotModifyHint": "※ 訂單開始執行後，將無法修改開始日期。",
      "totaldates": "總計 {{num}} 日",
      "budget": "預算",
      "orderMargin": "經銷商利潤",
      "remark": "其他說明事項",
      "createTitle": "新增訂單",
      "modifyReason": "訂單變更說明",
      "modifyMargin": "變更利潤",
      "modifyCancel": "取消變更",
      "modifyBudget": "變更預算",
      "editTitle": "編輯訂單",
      "externalType": "外部訂單類型",
      "campaignMinDateError": "訂單開始時間不得晚於任一廣告活動的開始時間",
      "campaignMaxDateError": "訂單結束時間不得早於任一廣告活動的結束時間",
      "monitor": "訂單監控",
      "creditHint": "目前信用額度已達上限{{credit}}，待管理者處理",
      "orderPrice": "CPM合約價格",
      "creativeDuration": "素材秒數",
      "daypart": "指定投遞時間區段",
      "basic": "基本資訊設定",
      "outdoor": "戶外廣告設定",
      "finalReport": {
        "projectName": "One Link 廣告活動名稱",
        "projectType": "廣告主類型",
        "receivers": "收件人",
        "sendOutDate": "發送日期",
        "advertiserName": "廣告主名稱",
        "targetType": "目標類型",
        "targetValue": "目標次數",
        "targetImpressions": "目標曝光次數"
      }
    },
    "placeholders": { "finalReport": { "receivers": "收件人電子信箱位址" } },
    "titles": { "finalReport": "結案報告" },
    "hints": { "finalReport": { "projectName": "※ 此專案名稱已被使用" } }
  },
  "orderList": {
    "headers": {
      "orderNumber": "訂單名稱與ID",
      "advertiser": "廣告主",
      "targetBudget": "預算",
      "spent": "已花費",
      "remainingDay": "剩餘天數",
      "progress": "投遞進度",
      "state": "狀態",
      "endDate": "結束日期",
      "externalId": "PA外部編號",
      "noDataAvailable": "無訂單"
    },
    "labels": {
      "copyYahooOrderNameSuccess": "已複製訂單編號與名稱",
      "editHint": "編輯訂單",
      "copyYahooOrderNameHint": "複製 Verizon 訂單名稱",
      "reportHint": "檢視報表",
      "creatorInformation": "訂單建立者資訊",
      "creator": "建立者",
      "creatorEmail": "電子信箱",
      "createDateTime": "訂單建立時間",
      "stateFilterMenuTitle": "選擇訂單狀態",
      "progressNormal": "正常 {{count}}",
      "progressNotStart": "未開始 {{count}}",
      "progressBehind": "落後 {{count}}",
      "progressSeverelyBehind": "嚴重落後 {{count}}",
      "progressOver": "超跑 {{count}}",
      "progressAhead": "超跑 {{count}}",
      "filterList": "篩選條件",
      "stateFilter": "訂單狀態",
      "tagFilter": "標籤",
      "tagFilterMenuTitle": "選擇標籤",
      "stateTag": "訂單狀態",
      "tagTag": "標籤",
      "remainBudget": "預算剩餘"
    },
    "placeholders": { "searchbar": "搜尋 訂單名稱、 ID 或 外部編號 …" }
  },
  "campaignList": {
    "headers": {
      "nameColumn": "名稱",
      "stateColumn": "廣告狀態",
      "typeColumn": "廣告類型",
      "scheduleColumn": "走期",
      "progressColumn": "投遞進度",
      "budgetColumn": "預算與分配",
      "budgetDistributionColumn": "預算分配",
      "priceModel": "執行計畫",
      "limitationColumn": "優化目標",
      "trackingColumn": "各類追蹤",
      "campaignControlColumn": "預算分配群組",
      "tagsColumn": "自訂標籤",
      "impresColumn": "曝光數",
      "viewableColumn": "可視曝光數",
      "clicksColumn": "點擊數",
      "cpcColumn": "CPC",
      "ctrColumn": "點擊率",
      "vctrColumn": "可視點擊率",
      "convertColumn": "轉換數",
      "cpaColumn": "每次轉換費用",
      "cvrColumn": "轉換率",
      "viewColumn": "影片觀看次數",
      "viewRateColumn": "影片觀看率",
      "viewableViewRateColumn": "影片可視觀看率",
      "creativeColumn": "廣告素材",
      "uuCountColumn": "不重複使用者",
      "priceGroupColumn": "執行計畫",
      "deliveryColumn": "投遞狀態",
      "optimize": "最佳化與投遞",
      "resultsColumn": "成果",
      "spents": "已花費"
    },
    "labels": {
      "createCampaignBtn": "+ 廣告活動",
      "stateFilterMenuTitle": "選擇廣告活動狀態",
      "tagFilterMenuTitle": "選擇標籤",
      "adTypeThirdParty": "AdNeon",
      "adTypeThirdPartyRectangle": "中矩形",
      "adTypeThirdPartyBottom": "行動置底",
      "adTypeVideo": "影音型",
      "adTypeDisplay": "展示型",
      "adTypePicShort": "PIC 戶外 15 秒廣告",
      "adTypePicLong": "PIC 戶外 30 秒廣告",
      "adTypePicExtended": "PIC 戶外 60 秒廣告",
      "adTypePicBroad": "PIC 戶外 60+ 秒廣告",
      "adTypeHwacomShort": "華電聯網 15 秒廣告",
      "adTypeHwacomLong": "華電聯網 30 秒廣告",
      "adTypeHwacomExtended": "華電聯網 60 秒廣告",
      "adTypeHwacomBroad": "華電聯網 60+ 秒廣告",
      "adTypeFridgeBroad": "冰櫃戶外 60+ 秒廣告",
      "adTypeFridgeLong": "冰櫃戶外 30 秒廣告",
      "adTypeFridgeExtended": "冰櫃戶外 60 秒廣告",
      "adTypePmpPic": "PMP PIC 戶外廣告",
      "adTypePmpFridge": "PMP 冰櫃戶外廣告",
      "adTypeCombo": "影＋圖",
      "adTypeCTV": "數位電視",
      "adTypeKeyword": "關鍵字",
      "adTypeEmpty": "未分類",
      "adTypeMessage": "簡訊廣告",
      "adTypeSandboxOutdoor": "研發測試用戶外影音",
      "adTypeSandboxMovableOutdoor": "研發測試用移動式戶外廣告",
      "adTypeOutdoorLineMessage": "Outdoor Line Message",
      "adTypeLineMessage": "Line Message",
      "activateState": "放送中",
      "deactivateState": "已停用",
      "deleteState": "已刪除",
      "pendingReviewState": "待審核",
      "withIssues": "待修正",
      "stoppingState": "暫停中",
      "pmpInactiveState": "PMP 已停用",
      "pmpEndState": "PMP 已結束",
      "pmpExpiredState": "失效",
      "pmpExpiredHint": "本廣告活動因為未能及時在訂單執行前完成素材審查而失效",
      "draftStateHint": "草稿尚未發佈",
      "schedule": "{{start}}<1/>至<3/>{{end}}",
      "messageCampaignSchedule": "{{start}}",
      "budget": "預算",
      "distribute": "分配",
      "budgetSchedule": "全走期平均分配",
      "budgetDailyDistribution": "{{currency}} {{budget}} / 日",
      "bidPriceDes": "投遞上限 {{currency}} {{price}}",
      "conversionTracking": "轉換追縱",
      "viewTrackingCodes": "第三方追蹤",
      "videoProgressTrackingCode": "再行銷追蹤",
      "campaignCount": "廣告活動 {{count}}",
      "campaignBudget": "預算總計 {{number}}",
      "emptyContent": "無",
      "creativeAmount": "廣告素材 {{count}}",
      "pmpChangedState": "PMP 變更",
      "pmpChangedHint": "PMP 檢視變更",
      "limitation": "優化目標",
      "addLimitation": "新增目標",
      "removeLimitation": "移除目標",
      "summaryCampaign": "廣告活動總覽頁",
      "deliverStandard": "標準",
      "deliverAsap": "密集",
      "deliverType": "投遞速率",
      "noData": "目前無廣告活動，可由 + 廣告活動 開始新增哦！",
      "noCreativesState": "無素材",
      "budgetRemainState": "預算剩餘",
      "partialStoreChange": "部分門市異動",
      "allStoreChange": "全部門市異動",
      "allWeatherFiltered": "全部天氣不符",
      "partialWeatherFiltered": "部分天氣不符",
      "endState": "已結束",
      "notStartState": "未開始",
      "editHint": "編輯廣告活動",
      "cloneHint": "複製廣告活動",
      "splitHint": "切割廣告活動",
      "reportHint": "檢視報表",
      "creativeEditHint": "管理廣告素材",
      "creativeViewHint": "查看廣告素材",
      "priceModel": "計價模式",
      "campaignControlName": "名稱",
      "optimize": "智慧出價模式",
      "priceCap": "投遞上限",
      "autoBid": "自動調整",
      "filterList": "篩選條件",
      "tagFilter": "標籤",
      "tagTag": "標籤",
      "bidPriceChange": "出價上限\n從 {{from}} 改成 {{to}}",
      "deliveringStoreRatio": "投遞中門市 / 原設定門市",
      "deliveringDeviceRatio": "投遞中機台 / 原設定機台",
      "notDelivering": "不投遞",
      "weatherMismatch": "天氣不符",
      "storeChange": "門市異動",
      "deviceChange": "機台異動",
      "limitationDetail": "優化目標細節",
      "edit": "編輯",
      "creative": "素材",
      "batchEdit": "批次編輯",
      "bindCreative": "綁定素材",
      "deactivateCreative": "停用",
      "activeCreative": "啟用",
      "activeCampaign": "啟用",
      "activeSuccess": "啟用成功",
      "activeFailed": "啟用失敗",
      "deactiveSuccess": "停用成功",
      "deactiveFailed": "停用失敗",
      "deleteSuccess": "刪除成功",
      "deactivateCampaign": "停用",
      "selected": "已選取",
      "canSplitMinimum": "廣告活動預算小於最小可分割金額: {{budget}}",
      "adTypeNotSupportCopy": "此廣告類型尚不支援複製功能",
      "adTypeNotSupportSplit": "此廣告類型尚不支援分割功能",
      "batchEditMultiTypeError": "無法批次編輯不同類型的廣告活動",
      "unknowTypeBatchEditError": "未分類廣告類型無法批次管理",
      "batchEditDraftError": "草稿無法批次管理",
      "cannotDelete": "無法刪除有綁定素材的廣告活動",
      "cannotEditMessageCampaign": "無法編輯當天排程的廣告活動或已經開始的廣告活動。",
      "cannotDeleteMessageCampaign": "無法刪除當天排程的廣告活動或已經開始的廣告活動。",
      "cannotActiveMessageCampaign": "無法啟用當天排程的廣告活動或已經開始的廣告活動。",
      "cannotDeactiveMessageCampaign": "無法停用當天排程的廣告活動或已經開始的廣告活動。",
      "deleteCampaign": "刪除",
      "deleteDraft": "刪除草稿",
      "deleteCampaignModalTitle": "刪除廣告活動",
      "deleteCampaignModalContent": "確定要刪除選擇的廣告活動？\n此動作將無法被還原",
      "deleteDraftModalTitle": "刪除草稿",
      "deleteDraftModalContent": "確定要刪除選擇的草稿？\n此動作將無法被還原",
      "mixDeleteModalTitle": "刪除廣告活動和草稿",
      "mixDeleteModalContent": "確定要刪除選擇的廣告活動和草稿？\n此動作將無法被還原",
      "rtbPriceCap": "RTB投遞上限",
      "manageBidWeightModalTitle": "管理投遞權重",
      "updateBidWeightSuccess": "更新投遞權重成功",
      "updateAdminBidPriceSuccess": "修改出價設定成功",
      "adTypeOneForAllDisplay": "One For All 展示型廣告",
      "canCopyNeedMore": "{{parent}} 還需要 {{budget}} 的預算來複製此廣告活動。",
      "minBudgetRequiredHint": "若需要重新啟用已停用的廣告活動，您必須在廣告活動群組補足需要的預算：{{margin}}",
      "hasRejectedAd": "一個或多個廣告素材已被拒絕。詳情見廣告列表。",
      "duplicate": "複製",
      "allStoreOverBindingLimit": "全部超過鎖定上限",
      "epaperNotActivatableHint": "所選活動中有活動鎖定的機台已被 10 個活動綁滿，請先編輯活動移除超過上限的版位後再啟用。",
      "partialStoreOverBindingLimit": "部分超過鎖定上限"
    },
    "hints": { "manageAdminBidPrice": "修改出價設定" },
    "tabs": {
      "basic": "基本",
      "performance": "一般成效資訊",
      "message_performance": "一般成效資訊",
      "auditLog": "操作歷程紀錄",
      "videoPerformance": "影音成效資訊",
      "rtb_video_performance": "影音成效資訊"
    },
    "placeholders": { "searchbar": "搜尋廣告活動名稱與編號..." }
  },
  "messageCampaignList": {
    "labels": {
      "scheduledState": "排隊中",
      "pendingState": "等待結果",
      "abnormalState": "異常"
    }
  },
  "l2ObjectList": {
    "labels": {
      "objectTypeFilterMenuTitle": "選擇物件類別",
      "objectTypeFilter": "物件類別",
      "objectTypeTag": "類別",
      "ordinaryCampaign_rtb": "廣告活動",
      "draft": "草稿",
      "editDraft": "編輯草稿",
      "statusFilter": "廣告狀態",
      "statusFilterMenuTitle": "選擇廣告狀態",
      "statusTag": "廣告狀態",
      "deliveryFilter": "投遞狀態",
      "deliveryFilterMenuTitle": "選擇投遞狀態",
      "deliveryTag": "投遞狀態"
    }
  },
  "order": {
    "status": {
      "notapprove": "待核准",
      "reject": "駁回",
      "approvenotstart": "核准",
      "approvestart": "核准",
      "approve": "核准",
      "stop": "已結束",
      "delete": "刪除",
      "invalid": "作廢",
      "changepending": "訂單變更，待審核",
      "settle": "訂單結算中",
      "settled": "訂單已結算",
      "active": "啟用",
      "deactive": "停用"
    },
    "finalReport": {
      "targetType": {
        "impression": "曝光數",
        "click": "點擊數",
        "conversion": "轉換數",
        "view": "影片觀看次數"
      }
    }
  },
  "creativeOverviewStateContent": {
    "buttons": {
      "bind": "綁定素材",
      "new": "新增素材",
      "actionTips": "不允許變更有效狀態為“處理中”的廣告素材",
      "pmpDeactiveTips": "PMP 廣告活動不允許將所有素材停用",
      "active": "啟用",
      "deactive": "停用",
      "singleActiveBindTips": "已有啟用中的素材，請先停用後再綁定",
      "singleActiveActivateTips": "一次只能啟用一個素材，請先停用目前啟用中的素材",
      "singleActiveCreateTips": "已有啟用中的素材，請先停用後再新增",
      "epaperSpaceQuotaFullTips": "此活動鎖定的機台已被 10 個活動綁滿，請先編輯活動移除超過上限的版位。",
      "epaperSpaceQuotaFullTipsWithCampaigns": "活動 {{names}} 鎖定的機台已被 10 個活動綁滿，請先移除這些活動超過上限的版位，或重新選取活動。"
    },
    "tags": { "selectedTip": "已選取{{count}}" },
    "tooltip": { "notAllowUnkown": "不支援的廣告類型" }
  },
  "campaignCreativeList": {
    "headers": {
      "creativeName": "素材名稱",
      "creativePreview": "圖片預覽",
      "creativeStatus": "狀態",
      "ctr": "點擊率",
      "vctr": "可視點擊率",
      "vtr": "觀看率",
      "imps": "曝光數",
      "clicks": "點擊",
      "vimps": "可視曝光數",
      "view": "觀看",
      "typeAndSize": "類型與尺寸",
      "approvalStatus": "送審狀態",
      "effectiveStatus": "Delivery",
      "creativeLayout": "版型",
      "noDataAvailable": "無素材",
      "results": "成果",
      "uu": "不重複使用者"
    },
    "labels": {
      "copyImaxShortcutSuccess": "已複製短網址",
      "emptyShortcutUrl": "此素材無有效短網址",
      "editHint": "編輯素材",
      "copyShortcutHint": "複製短網址",
      "reportHint": "檢視報表",
      "cannotEditCustomCreativeHint": "廣告在自家廣告平台編輯後，此廣告將不能被編輯",
      "noData": "目前無綁定廣告素材",
      "noDataWithoutAddPermission": "目前沒有任何資料"
    }
  },
  "creativeList": {
    "labels": {
      "demoPageHint": "前往展示頁面",
      "beforeStartTime": "未開始",
      "afterEndTime": "已結束",
      "none": "無",
      "notBindYet": "未綁定",
      "reviewSuccess": "送審成功",
      "reviewFailed": "送審失敗",
      "noData": "目前無廣告素材，可由 + 素材 開始新增哦！",
      "newCreative": "+ 素材",
      "bindEnable": "啟用 {{count}}",
      "bindDisable": "停用 {{count}}",
      "selected": "已選取",
      "unlimited": "不限",
      "bindingCampaign": "綁定使用狀態",
      "enableBindState": "啟用",
      "disableBindState": "停用",
      "copyCreative": "複製",
      "nameIdSummary": "素材 {{count}}",
      "updateYahooIdsSuccess": "更新 Verizon 廣告 ID 成功",
      "yahooIdEditTitle": "編輯 Verizon 廣告 ID",
      "enableStartTime": "開始時間",
      "enableEndTime": "結束時間",
      "yahooIdBind": "已綁定的 Verizon廣告 ID",
      "updateBindStateSuccess": "更新綁定使用狀態成功",
      "cloneCreativeSuccess": "複製素材已制作",
      "deleteCreativeSuccess": "素材已刪除",
      "cannotDeleteHint": "無法刪除曾綁定的素材",
      "cannotCloneHint": "無法複製處理中的素材",
      "editHint": "編輯素材",
      "cloneHint": "複製素材",
      "editYahooIdHint": "編輯 Verizon 廣告 ID",
      "deleteHint": "刪除素材",
      "previewHint": "預覽素材上刊圖",
      "cannotUnBindSomeCreative": "以下素材因被綁定在 PMP 廣告活動上且該廣告活動無其他可投遞素材，故無法停用：{{ creatives }}",
      "deleteModalTitle": "刪除素材",
      "deleteModalContent": "確定要刪除選擇的素材？",
      "skippable": "可略",
      "nonSkippable": "不可略",
      "skipOffset": "{{offset}}秒",
      "inStream": "In-Stream (Pre-Roll)",
      "outStream": "Out-Stream",
      "approvalDefault1": "圖像",
      "approvalDefault2": "HTML5",
      "approvalDefault3": "原生",
      "approvalDefault4": "影片",
      "approvalDefault8": "AdNeon",
      "approvalDefault10": "影 + 圖",
      "approvalDefault11": "EdiMax 戶外",
      "approvalDefault26": "PIC 戶外 15 秒",
      "approvalDefault27": "PIC 戶外 30 秒",
      "approvalDefault12": "RTB原生",
      "approvalDefault13": "One For All 展示型",
      "approvalDefault14": "One For All 展示型",
      "approvalDefault15": "One For All 展示型",
      "approvalDefault23": "數位電視",
      "approvalDefault28": "原生",
      "approvalCtv": "CTV",
      "approvalDesktop": "Desktop",
      "approvalMobile": "Mobile",
      "creativeCount": "素材 {{count}}",
      "approvalDefault16": "One For All - 影片廣告",
      "archivedActionHint": "素材已封存，無法使用此功能",
      "archivedNotice": "此廣告素材已超過儲存期限且沒有在使用，將無法在編輯與綁定",
      "noMatchData": "沒有符合條件的素材"
    },
    "placeholders": { "searchbar": "搜尋 素材名稱 與 ID …" },
    "headers": {
      "bannerId": "素材名稱與 ID",
      "bindingCampaign": "使用狀態",
      "approvalStatus": "素材格式與送審狀態",
      "preview": "素材預覽",
      "adTitle": "廣告標題",
      "adDesc": "廣告描述",
      "bannerUrl": "連結網址",
      "sponsor": "贊助商",
      "limitations": "優化目標",
      "streamingSetting": "廣告版位位置",
      "oneForAllClickUrl": "Click URL",
      "rtbClickUrl": "RTB連結網址",
      "ppsLayoutId": "版型 ID",
      "message": "Message",
      "shortMessage": "Short Message",
      "skipSetting": "略過廣告設定",
      "outdoorType": "戶外廣告類型",
      "duration": "素材播放長度",
      "status": "狀態",
      "delivery": "投遞狀態",
      "adneonLayout": "版型"
    },
    "filter": {
      "statusFilter": "狀態",
      "statusFilterMenuTitle": "選擇素材狀態",
      "statusTag": "狀態"
    },
    "status": { "active": "啟用中", "all": "全部", "archived": "已封存" }
  },
  "bindCreativeStateContent": {
    "placeholders": { "searchbar": "搜尋 素材名稱 或 ID …" },
    "buttons": {
      "newToOld": "新至舊",
      "oldToNew": "舊至新",
      "native": "原生廣告",
      "selected": "已選取",
      "allSelected": "全選"
    },
    "labels": {
      "title": "綁定素材",
      "image": "RTB 圖像式廣告",
      "html5": "HTML 廣告",
      "native": "原生廣告",
      "video": "影片廣告",
      "dynamic": "動態廣告",
      "flash": "Flash 廣告",
      "third_party": "AdNeon 廣告",
      "combo": "影+圖廣告",
      "edimax": "EdiMax 戶外廣告",
      "pic_short": "PIC 戶外 15 秒廣告",
      "pic_long": "PIC 戶外 30 秒廣告",
      "pic_extended": "PIC 戶外 60 秒廣告",
      "pic_broad": "PIC 戶外 60+ 秒廣告",
      "hwacom_short": "華電聯網 15 秒廣告",
      "hwacom_long": "華電聯網 30 秒廣告",
      "hwacom_extended": "華電聯網 60 秒廣告",
      "hwacom_broad": "華電聯網 60+ 秒廣告",
      "fridge_braod": "冰櫃戶外 60+ 秒廣告",
      "fridge_long": "冰櫃戶外 30 秒廣告",
      "fridge_extended": "冰櫃戶外 60 秒廣告",
      "one_for_all": "One For All - Display",
      "one_for_all_display": "One For All - Display",
      "one_for_all_display_ios": "One For All - Display",
      "one_for_all_display_android": "One For All - Display",
      "ctv": "數位電視廣告",
      "custom_bottom": "手刻置底廣告",
      "custom_rectangle": "手刻中矩形廣告",
      "sandbox_outdoor": "研發測試用戶外廣告",
      "outdoor_line_message": "Outdoor Line Message 廣告",
      "line_message": "Line Message 廣告",
      "one_for_all_video": "One For All - 影片廣告",
      "one_for_all_video_ios": "One For All - 影片廣告",
      "one_for_all_video_android": "One For All - 影片廣告",
      "singleCreativeTips": "電子紙渠道一次只能綁定一個素材，請取消多選的素材"
    }
  },
  "creativeCard": { "labels": { "createTime": "{{time}} 建立" } },
  "batchEditCampaignTitle": {
    "title": "同步調整{{num}}個項目",
    "labels": { "subTitle": "廣告活動名稱" }
  },
  "batchEditCampaignSummary": {
    "labels": { "checkYourSettings": "檢查你的設定" },
    "titles": { "trackingSummary": "各類追蹤" }
  },
  "creativeSummmaryStateContent": { "title": "綁定素材" },
  "creative": {
    "approval": { "no": { "record": "暫無送審紀錄" } },
    "list": { "filter": { "all": "全選" } },
    "change": { "confirmation": "素材綁定變更總覽" },
    "binding": { "status": "素材綁定狀態" },
    "compositeSetting": {
      "invalidHint": "素材播放尺寸設定有誤，請系統管理員查看銷售渠道設定"
    },
    "status": {
      "enable": "啟用",
      "disable": "停用",
      "waitingActivate": "啟用中",
      "waitingDeactivate": "停用中",
      "default": "啟用中",
      "processing": "處理中",
      "processingFailed": "處理失敗",
      "archived": "已封存"
    }
  },
  "creativeOverviewState": {
    "labels": {
      "activeSuccess": "素材已啟用",
      "activeFailed": "素材啟用發生錯誤",
      "deactiveSuccess": "素材已停用",
      "deactiveFailed": "素材停用發生錯誤"
    }
  },
  "creativeSummaryState": {
    "labels": { "modifySuccess": "素材綁定變更已完成" }
  },
  "orderHome": {
    "labels": { "title": "訂單與廣告", "advertiserListTitle": "廣告主" }
  },
  "recentGroupDropdown": {
    "labels": {
      "useRecently": "最近使用",
      "otherAdvertiserId": "其他廣告主",
      "otherMerchantId": "其他商家",
      "otherAgencyId": "其他經銷商",
      "otherRestaurantId": "其他餐廳",
      "otherBeaconConnectionId": "其他官方帳號"
    }
  },
  "groupOptionsSelection": {
    "labels": {
      "selectAllAdvertiserId": "全部廣告主",
      "selectAllMerchantId": "全部商家",
      "selectAllAgencyId": "全部經銷商",
      "selectAllRestaurantId": "全部餐廳",
      "selectAllBeaconConnectionId": "全部官方帳號",
      "pleaseChooseAdvertiserId": "請選取 廣告主 ...",
      "pleaseChooseMerchantd": "請選取商家 ...",
      "pleaseChooseAgencyId": "請選取 經銷商 ...",
      "pleaseChooseRestaurantId": "請選取 餐廳 ...",
      "pleaseChooseBeaconConnectionId": "請選取 官方帳號 ...",
      "searchAdvertiserId": "搜尋 廣告主名稱 …",
      "searchMerchantId": "搜尋商家名稱 …",
      "searchAgencyId": "搜尋 經銷商名稱 …",
      "searchRestaurantId": "搜尋 餐廳名稱 …",
      "searchBeaconConnectionId": "搜尋 官方帳號名稱 …"
    }
  },
  "orders": { "labels": { "newOrder": "+ 訂單" } },
  "modifyCreativeActivationStateContent": {
    "labels": {
      "chooseActivate": "選取要啟用的素材",
      "chooseDeactivate": "選取要停用的素材"
    }
  },
  "downloadReportPanel": {
    "labels": {
      "cpmClosingReport": "CPM 結案報告",
      "cpcClosingReport": "CPC 結案報告",
      "normal": "走期自訂報表",
      "closing": "結案報告",
      "downloadReport": "報表下載",
      "downloadOutdoorReport": "Outdoor 報表下載",
      "dateRange": "訂單走期",
      "reportType": "報表類型",
      "advance": "自訂欄位報表",
      "dataContent": "資料內容",
      "quickSelect": "快選",
      "videoAdViewObjective": "影片觀看",
      "cpmOption": "CPM計價",
      "cpcOption": "CPC計價",
      "cpaOption": "CPA計價",
      "videoOption": "影音廣告",
      "outdoorOption": "戶外廣告",
      "outdoorDeviceOption": "戶外機台廣告資訊",
      "outdoorDeviceBeaconOption": "戶外機台廣告資訊(Line Simple Beacon)",
      "lineMessageOption": "Line Message 報表",
      "rawDataOption": "原生資料",
      "reset": "恢復初始",
      "firstQuartile": "觀看 25%",
      "midPoint": "觀看 50%",
      "thirdQuartile": "觀看 75%",
      "complete": "觀看 100%",
      "audienceData": "受眾資料",
      "gender": "性別",
      "age": "年齡",
      "interest": "興趣",
      "impress": "曝光數",
      "viewable": "可視曝光數",
      "uu": "不重複使用者",
      "click": "點擊數",
      "ctr": "點擊率",
      "viewableCtr": "可視點擊率",
      "adView": "觀看數",
      "viewRate": "觀看率",
      "viewableViewRate": "可視觀看率",
      "convs": "轉換數",
      "spent": "已花費",
      "cpm": "CPM",
      "cpc": "CPC",
      "cpv": "CPV",
      "cpa": "CPA",
      "groupBy": "分組依據",
      "groupByCreative": "素材",
      "groupByCampaign": "廣告活動",
      "groupByL1Object": "廣告活動群組",
      "audienceDataHint": "受眾資料為整個訂單走期間的累計數據，不受自訂日期區間影響。",
      "beaconEvents": "Beacon 數據",
      "ePublisherImpres": "人流數",
      "acpm": "aCPM",
      "acpmOption": "aCPM計價",
      "country": "城市",
      "domain": "網域",
      "deliveryBrief": "投遞數據簡要報表",
      "reportDateRange": "選擇報表區間",
      "format": "格式",
      "uniqueUserCount": "不重複使用者數",
      "averageViewRate": "平均觀看率",
      "averageCtr": "平均點擊率"
    },
    "buttons": { "download": "下載" },
    "placeholders": { "reportType": "選擇報表類型" },
    "errors": {
      "fieldRequired": "{{field}}：{{checkedDependentFields}}需要此欄位的資訊",
      "dateRangeOutOfOrderPeriod": "時段需要在訂單走期內（{{start}} ~ {{end}}）"
    }
  },
  "limitationOptions": {
    "labels": {
      "gender": { "1": "男性", "2": "女性" },
      "spaceType": { "1": "網頁", "2": "手機應用程式" },
      "carrier": {
        "chunghwa": "中華電信",
        "taiwan_mobile": "台灣大哥大",
        "far_eastone": "遠傳電信",
        "taiwan_star": "台灣之星",
        "asia_pacific": "亞太電信",
        "viettel": "Viettel",
        "mobifone": "MobiFone",
        "vinaphone": "Vinaphone",
        "vietnamobile": "Vietnamobile"
      },
      "contentlang": {
        "zh": "中文",
        "en": "英文語系",
        "vi": "越南文",
        "th": "泰文",
        "es": "西班牙文",
        "ja": "日文",
        "mg": "馬來文",
        "ko": "韓文",
        "id": "印尼文"
      },
      "device": {
        "2": "電腦",
        "3": "聯網電視",
        "4": "手機",
        "5": "平板",
        "6": "聯網設備",
        "7": "數位視訊轉換盒",
        "smartphone": "智慧型手機",
        "tablet": "平板"
      }
    }
  },
  "tenmaxCategory": {
    "labels": {
      "others": "Others",
      "3c": "3C",
      "telecom": "電信",
      "home_appliance": "家電",
      "mobile_app": "手機軟體",
      "computer_software": "電腦軟體",
      "pharmacy": "保健 / 健康",
      "diet": "塑身",
      "medical_care": "醫療",
      "career": "工作與職涯",
      "e_commerce": "線上購物",
      "shopping": "實體通路購物",
      "aviation": "航空",
      "travel": "旅遊",
      "baby": "母嬰親子",
      "automobile": "汽機車",
      "automobile1": "汽車",
      "insurance": "保險",
      "real_estate": "房地產",
      "loan": "金融借貸服務",
      "investment": "投資",
      "investment_activities": "投資活動",
      "credit_card": "信用卡",
      "media": "網際社群",
      "social_media": "社群媒體",
      "dessert": "甜點",
      "restaurant": "餐廳 / 美食",
      "wine": "酒類",
      "home_decoration": "居家環境",
      "cook": "烹飪",
      "cleaning": "清潔用品",
      "beverage": "飲料",
      "snack": "零食",
      "fast_food": "速食",
      "science": "科學新知",
      "science_activity": "科學活動",
      "books": "圖文藝術",
      "graphic_art": "圖像藝術",
      "cosmetics": "彩妝保養",
      "women_clothing": "女性服飾",
      "men_clothing": "男性服飾",
      "luxary": "精品",
      "beauty": "美的服務",
      "accessory": "時尚配件",
      "surgery": "醫美",
      "news": "新聞",
      "government": "政黨政府",
      "government_communications": "政府宣傳",
      "politics": "社會議題",
      "regime": "政治",
      "pet": "寵物",
      "toy": "玩具模型",
      "music": "音樂",
      "movie": "電影",
      "outdoor_activities": "戶外活動",
      "drama": "戲劇節目",
      "game": "遊戲",
      "sport": "運動",
      "society": "社交",
      "sexuality": "情趣用品",
      "exhibition": "展覽",
      "immigration": "移民服務",
      "motobike": "機車",
      "saas": "SaaS服務",
      "social_issue": "社會議題",
      "social_welfare": "社會公益",
      "technology_art": "科技藝術",
      "iab1": "Arts & Entertainment",
      "iab19": "Computers & Electronics",
      "iab13": "Finance",
      "iab9_30": "Games",
      "iab10": "Home & Garden",
      "iab3": "Business & Industrial",
      "iab19_18": "Internet & Telecom",
      "iab14_1": "People & Society",
      "iab12": "News",
      "iab22": "Shopping",
      "iab11": "Law & Government",
      "iab17": "Sports",
      "iab1_1": "Books & Literature",
      "iab21": "Real Estate",
      "iab14": "Online Communities",
      "iab18": "Beauty & Fitness",
      "iab7": "Health",
      "iab2": "Autos & Vehicles",
      "iab4": "Jobs & Education",
      "iab9": "Hobbies & Leisure",
      "iab16": "Pets & Animals",
      "iab20": "Travel",
      "iab8": "Food & Drink",
      "iab19-12": "Reference",
      "iab15": "Science",
      "logistics": "運輸快遞",
      "education": "教育",
      "wedding": "婚禮",
      "daily_necessities": "日用品",
      "shoes": "鞋品",
      "women_talk": "女性話題",
      "energy": "能源"
    }
  },
  "creativeSetupFlow": {
    "labels": {
      "advertiser": "廣告主",
      "nextStep": "下一步",
      "name": "素材名稱",
      "title": "廣告標題",
      "desc": "廣告描述",
      "message": "廣告訊息",
      "shortMessage": "廣告訊息(短)",
      "landingPageUrl": "目標頁面網址",
      "sponsor": "贊助商",
      "sponsorLink": "贊助商連結網址",
      "videoPlacement": "廣告版位位置",
      "creativeType": "素材類型",
      "tenmaxCategory": "素材分類",
      "remainingCharacters": "可填寫 {{num}} 個字元",
      "openLinkHint": "開啟連結",
      "creativeBasicInfo": "素材基本資訊",
      "agencyId": "經銷商編號",
      "enableNativeBanner": "產生圖像式素材",
      "image": "圖片檔案",
      "enableStartTime": "設定開始時間",
      "enableEndTime": "設定結束時間",
      "outdoorHtml": "Html壓縮檔",
      "customLayout": "手刻版型",
      "bannerUrl": "連結網址",
      "rtbBannerUrl": "RTB連結網址",
      "analyzingHint": "分析中...",
      "sponsoredBy": "贊助",
      "imageCreativeTypeHint": "可使用 JPG，PNG 或 GIF 格式",
      "typeHint": "可使用 JPG 或 PNG 格式",
      "comboImagetypeHint": "可使用 JPG 或 PNG格式",
      "videoTypeHint": "僅可使用 MP4 影片格式",
      "videoDurationHint": "可使用最長 120 秒的影片",
      "sizeHint": "圖片比例須為 {{proportion}} ，尺吋至少等於 {{size}}",
      "storageHint": "檔案大小須小於 {{storage}}",
      "successHint": "上傳成功",
      "audioSuccessHint": "聲音上傳成功",
      "fileUploadSuccessHint": "檔案上傳成功",
      "videoSuccessHint": "影片上傳成功",
      "sizeErrorHint": "此圖大小為{{size1}}, 必須大於(等於){{size2}}",
      "proportionErrorHint": "此圖比例為{{proportion1}}, 必須為{{proportion2}}",
      "typeErrorHint": "圖片格式為{{type}}格式, 必須為 jpg 或 png",
      "imageCreativeTypeErrorHint": "圖片格式為{{type}}格式, 必須為 jpg 或 png 或 gif",
      "storageErrorHint": "此檔案大小為{{storage1}}，必須小於 {{storage2}}",
      "zipContentError": "壓縮檔必須包含index.html",
      "rectImg": "寬圖檔案",
      "squareImg": "方圖檔案",
      "dragdropHint": "拖放檔案 或 選取",
      "videoDurationError": "影片最長不可超過120 秒",
      "creatives": "素材庫",
      "creativeBinding": "素材預覽",
      "createSuccess": "建立成功",
      "updateSuccess": "更新成功",
      "createCreative": "新增素材",
      "editCreative": "編輯素材",
      "creativeId": "素材 ID",
      "cancelUpdate": "取消更改",
      "updateManually": "手動更改",
      "bannerSize": "素材尺寸",
      "maxCardsCount": "產品卡片最多呈現張數",
      "autoAnimationSeconds": "自動輪播秒數",
      "autoAnimationSeconds_postText": "後自動輪播",
      "showAdvanceSetting": "展開",
      "closeAdvanceSetting": "收合",
      "displaySize": "廣告尺寸",
      "layoutId": "版型 ID",
      "subLayout": "子版型",
      "adServingUrl": "第三方影片",
      "videoDuration": "影片長度",
      "skippableSetting": "略過廣告設定",
      "imageSizeErrorHint": "不支援圖片尺寸{{size}}, 請點選尺吋說明按鈕查看支援的尺寸",
      "imagePreview": "圖片預覽",
      "htmlSnippet": "AdNeon 代碼",
      "outdoorType": "戶外廣告類型",
      "imageSizeHint": "圖片尺吋須為 {{size}}",
      "outdoorDuration": "素材播放長度",
      "creativeSize": "素材尺寸",
      "lineBeaconServiceType": "Line 狀態",
      "lineBeaconHardwareId": "Hardware ID",
      "lineBotChannelSecret": "Channel Secret",
      "lineBotChannelAccessToken": "Channel Access Token",
      "orderName": "訂單名稱",
      "orderBudget": "訂單預算",
      "orderSchedule": "訂單預期走期",
      "sizeErrorHint2": "此圖大小為{{size1}}, 必須等於{{size2}}",
      "audioTypeHint": "可使用 MP3 格式",
      "audio": "聲音檔案",
      "outdoorAudioSwitch": "使用聲音檔案",
      "videoSizeHint": "影片尺吋須為 {{size}}",
      "videoSizeErrorHint2": "此影片大小為{{size1}}, 必須等於{{size2}}",
      "callToAction": "行動呼籲",
      "deepLink": "深度連結 (選填)",
      "layout": "版位類型",
      "imageMultipleSizeErrorHint": "不支援部分圖片檔案的尺吋，請點選尺吋說明按鈕查看支援的尺吋",
      "storageMultipleErrorHint": "部分檔案的大小超過 {{storage}}",
      "imageMultipleTypeErrorHint": "部分圖片的格式不是 jpg、png 或 gif",
      "images": "圖片檔案",
      "oneForAllRectImg": "寬圖檔案 (選填)",
      "outdoorVideoSizeErrorHint": "不支援影片尺寸{{size}}, 請點選素材資訊提醒按鈕查看支援的尺寸",
      "outdoorImageSizeErrorHint": "不支援圖片尺寸{{size}}, 請點選素材資訊提醒按鈕查看支援的尺寸",
      "videoCodecHint": "此渠道支援的影片編碼：{{codecs}}"
    },
    "placeholders": {
      "chooseAdvertiser": "選擇廣告主",
      "landingPageUrlHint": "填寫連結網址後自動載入"
    },
    "titles": { "advancedSetting": "進階設定" }
  },
  "formValidate": {
    "labels": {
      "remainingCharacters": "可填寫 {{num}} 個字元",
      "needUrl": "請輸入包含 http:// 的網址",
      "maximumError": "值必須小於或等於 {{max}}",
      "minimumError": "值必須大於或等於 {{min}}",
      "emptyError": "這裡還是空白的哦！",
      "integerError": "必須為整數",
      "maximumLengthError": "長度必須小於或等於{{max}}",
      "invalidValueError": "此選項已不再可用",
      "validWordsError": "必須是純文字或標點符號",
      "invalidEmail": "請填寫格式包含 @ 和 . 的電子郵件",
      "emailRequired": "請填寫電子郵件"
    }
  },
  "creativeType": {
    "image": "RTB 圖像式廣告",
    "html": "HTML 廣告",
    "html5": "HTML 廣告",
    "native": "原生廣告",
    "video": "影片廣告",
    "dynamic": "動態廣告",
    "flash": "Flash 廣告",
    "thirdParty": "第三方廣告",
    "combo": "影+圖廣告",
    "edimax": "EdiMax 戶外廣告",
    "picShort": "PIC 戶外 15 秒廣告",
    "picLong": "PIC 戶外 30 秒廣告",
    "picExtended": "PIC 戶外 60 秒廣告",
    "picBroad": "PIC 戶外 60+ 秒廣告",
    "hwacomShort": "華電聯網 15 秒廣告",
    "hwacomLong": "華電聯網 30 秒廣告",
    "hwacomExtended": "華電聯網 60 秒廣告",
    "hwacomBroad": "華電聯網 60+ 秒廣告",
    "fridgeBroad": "冰櫃戶外 60+ 秒廣告",
    "fridgeLong": "冰櫃戶外 30 秒廣告",
    "fridgeExtended": "冰櫃戶外 60 秒廣告",
    "imageAds": "RTB 圖像式廣告",
    "htmlAds": "HTML 廣告",
    "nativeAds": "原生廣告",
    "videoAds": "影片廣告",
    "dynamicAds": "動態廣告",
    "flashAds": "Flash 廣告",
    "thirdPartyAds": "AdNeon 廣告",
    "comboAds": "影+圖廣告",
    "picShortAds": "PIC 戶外 15 秒廣告",
    "picLongAds": "PIC 戶外 30 秒廣告",
    "picExtendedAds": "PIC 戶外 60 秒廣告",
    "picBroadAds": "PIC 戶外 60+ 秒廣告",
    "fridgeBroadAds": "冰櫃戶外 60+ 秒廣告",
    "fridgeLongAds": "冰櫃戶外 30 秒廣告",
    "fridgeExtendedAds": "冰櫃戶外 60 秒廣告",
    "oneForAllDisplay": "One For All - Display 廣告",
    "oneForAllDisplayIos": "One For All - Display 廣告 (iOS)",
    "oneForAllDisplayAndroid": "One For All - Display 廣告 (Android)",
    "custom": "客製化廣告",
    "ctv": "數位電視廣告",
    "customBottom": "手刻置底廣告",
    "customRectangle": "手刻中矩形廣告",
    "sandboxOutdoor": "研發測試用戶外廣告",
    "outdoorLineMessage": "Outdoor Line Message 廣告",
    "lineMessage": "Line Message 廣告",
    "oneForAllVideo": "One For All - 影片廣告",
    "oneForAllVideoIos": "One For All - 影片廣告 (iOS)",
    "oneForAllVideoAndroid": "One For All - 影片廣告 (Android)"
  },
  "yahooIDInput": {
    "labels": { "title": "請輸入 Verizon 廣告 ID" },
    "placeholders": {
      "tags": "輸入 Verizon 廣告 ID 後，可使用 Enter 鍵新增不同廣告 ID …"
    }
  },
  "creativeBindStatusPage": {
    "headers": {
      "id": "廣告活動 ID",
      "name": "廣告活動名稱",
      "effectiveStatus": "活動投遞狀態",
      "bindState": "素材綁定狀態"
    },
    "labels": {
      "noData": "尚未綁定任何廣告活動",
      "active": "啟用",
      "inactive": "停用"
    }
  },
  "creativeBindingStatusPage": { "title": "廣告綁定素材資訊" },
  "creativesHome": {
    "labels": {
      "title": "素材",
      "agencyListTitle": "經銷商",
      "advertiserListTitle": "廣告主"
    },
    "titles": { "createCreativeErrorModal": "部分素材建立失敗" }
  },
  "creativeReview": {
    "labels": {
      "pending": "待審",
      "approved": "核准",
      "denied": "拒絕",
      "fixed": "已修正",
      "new": "待送審",
      "reviewHint": "素材送審",
      "incompleted": "未完成",
      "deleted": "已刪除",
      "stateTitle": "狀態：",
      "stateUpdateTime": "最後更新時間：",
      "tenmaxCategoryChange": "TenmaxCategory 已被 SSP 更改",
      "tenmaxCategoryFrom": "將從：",
      "tenmaxCategoryTo": "改成：",
      "categoryChangeHint": "此素材會以更正後的素材分類開始投遞。",
      "banAttribute800": "不適合女性時尚網站",
      "banAttribute810": "廣告圖片不適合女性時尚網站",
      "banAttribute811": "廣告圖片內有文字",
      "banAttribute812": "廣告圖片內有廣告商 Logo",
      "banAttribute813": "廣告圖片內出現明顯廣告商品",
      "banAttribute820": "廣告標題不適合女性時尚網站",
      "banAttribute821": "廣告標題明顯商業化",
      "banAttribute822": "廣告標題包含色情、暴力、恐怖等負面字眼",
      "banAttribute700": "廣告內含成人內容",
      "partialBanTitle": "部分流量拒絕原因：",
      "partialBanHint": "此素材仍會投遞至符合規範的廣告空間。",
      "missingReviewDataHint": "此素材缺少送審必須的資訊，請重新編輯此素材並補上欠缺資訊"
    },
    "lables": {
      "titkokWaitingForCreate": "打包您的受眾可能需要24小時，請稍候再檢查狀態。"
    }
  },
  "report": {
    "labels": {
      "reportType": "報表類型",
      "reportGran": "走期",
      "performanceType": "一般廣告",
      "videoType": "影音廣告",
      "messageType": "簡訊廣告",
      "outdoorType": "戶外廣告",
      "lineMessageType": "Line Message",
      "month": "月",
      "day": "天",
      "hour": "時",
      "+0800": "UTC+8",
      "+0700": "UTC+7",
      "+0900": "UTC+9",
      "reconciliationTitle": "經銷商對帳報表",
      "performanceTitle": "廣告成效",
      "beaconMessageTitle": "Beacon 廣告成效",
      "filterCondition": "篩選條件",
      "agencyId": "經銷商",
      "advertiserId": "廣告主",
      "adsOrderId": "訂單",
      "campaignId": "廣告活動",
      "creativeId": "素材",
      "creativeType": "素材分類",
      "creativeSize": "素材尺寸",
      "isSelfBuy": "自有流量",
      "deviceType": "裝置類型",
      "salesChannel": "銷售渠道",
      "dimentSelectArea": "報表篩選條件",
      "reportChartArea": "圖表",
      "download": "報表下載",
      "adType": "廣告活動類型",
      "useAppsflyerConversion": "顯示 Appsflyer 轉換資料",
      "withoutPerformance": "目前的選項沒有成效資料",
      "mrt": "重要捷運站",
      "l3ChannelId": "廣告",
      "l2ChannelId": "廣告活動",
      "l2ObjectId": "廣告活動",
      "l1ObjectId": "廣告活動群組"
    },
    "buttons": { "search": "查詢" },
    "titles": { "salesChannelReconciliation": "銷售渠道對帳報表" },
    "hints": {
      "salesChannelReconciliation": "每日數據會隨原始投遞資料變動，每月 2 日後可查閱前 1 個月的最終數據"
    }
  },
  "reportTable": {
    "labels": {
      "dayDimension": "日期",
      "agencyIdDimension": "經銷商",
      "advertiserIdDimension": "廣告主",
      "adsOrderIdDimension": "訂單",
      "campaignIdDimension": "廣告活動",
      "adTypeDimension": "廣告活動類型",
      "creativeIdDimension": "素材",
      "creativeTypeDimension": "素材分類",
      "creativeSizeDimension": "素材尺寸",
      "isSelfBuyDimension": "自有流量",
      "deviceTypeDimension": "裝置類型",
      "salesChannelDimension": "銷售渠道",
      "mrtDimension": "重要捷運站",
      "adsOrderIdLinkHint": "檢視訂單詳情",
      "campaignIdLinkHint": "檢視廣告活動詳情",
      "l2ObjectIdLinkHint": "檢視廣告活動詳情",
      "creativeIdLinkHint": "檢視素材詳情",
      "alertModalContent": "由於 Self Serving 建立/編輯的廣告素材無法對回平台的素材分類，因此切換至素材分類的維度時數據總和可能會不一致",
      "alertModalTitle": "切換報表檢視維度",
      "l3ChannelIdDimension": "廣告",
      "l2ChannelIdDimension": "廣告活動",
      "l2ObjectIdDimension": "廣告活動",
      "l1ObjectIdDimension": "廣告群組",
      "l1ObjectIdLinkHint": "瀏覽廣告活動群組詳細資訊",
      "l2ChannelIdLinkHint": "瀏覽廣告活動詳細資訊",
      "l3ChannelIdLinkHint": "瀏覽廣告詳細資訊"
    },
    "placeholders": {
      "searchDate": "搜尋 日期 ...",
      "searchName": "搜尋 名稱 ..."
    },
    "headers": {
      "name": "名稱",
      "date": "日期",
      "impres": "曝光數",
      "clicks": "點擊數",
      "ctr": "點擊率",
      "messageCTR": "可視點擊率",
      "viewable": "可視曝光數",
      "vctr": "可視點擊率",
      "cpm": "CPM",
      "acpm": "aCPM",
      "cpc": "CPC",
      "cpa": "每次轉換費用",
      "convs": "轉換數",
      "conv_1": "1天內轉換數",
      "conv_7": "7天內轉換數",
      "cvr": "轉換率",
      "mediaCost": "媒體花費 ({{currency}})",
      "mediaSpent": "媒體費用 ({{currency}})",
      "agcProfit": "經銷商獲利 ({{currency}})",
      "sysProfit": "系統獲利 ({{currency}})",
      "dataCost": "資料花費 ({{currency}})",
      "spent": "已花費 ({{currency}})",
      "adView": "觀看數",
      "viewRate": "觀看率",
      "viewableViewRate": "可視觀看率",
      "cpv": "CPV",
      "skipCount": "略過次數",
      "firstQuartile": "觀看比例 (25%)",
      "midpoint": "觀看比例 (50%)",
      "thirdQuartile": "觀看比例 (75%)",
      "complete": "觀看比例 (100%)",
      "tags": "自訂標籤",
      "messageSend": "一般曝光數",
      "messageArrived": "可視曝光數",
      "ePublisherImpres": "人流",
      "beaconEvents": "Beacon 數據",
      "beacon": "Beacon 發送次數",
      "messageCount": "Beacon 訊息則數",
      "uu": "不重複使用者"
    },
    "footers": { "total": "總計" }
  },
  "deviceType": {
    "computer": "電腦",
    "tablet": "平板",
    "phone": "手機",
    "unknown": "未知的裝置"
  },
  "advertiserHome": {
    "labels": { "title": "廣告主", "agencyOptionsTitle": "經銷商" }
  },
  "advertiserList": {
    "headers": {
      "id": "廣告主名稱與 ID",
      "category": "預設素材分類",
      "website": "官方網站"
    },
    "labels": {
      "nodata": "目前無廣告主，可由 + 廣告主 開始新增哦！",
      "newAdvertiser": "+ 廣告主",
      "editHint": "編輯廣告主"
    },
    "placeholders": { "searchbar": "搜尋 廣告主名稱 與 ID …" }
  },
  "advertiserForm": {
    "labels": {
      "createTitle": "新增廣告主",
      "editTitle": "編輯廣告主",
      "name": "廣告主名稱",
      "website": "官方網站",
      "category": "預設素材分類",
      "note": "其他說明事項",
      "id": "廣告主編號",
      "publisher": "發佈商"
    }
  },
  "advertiserDetail": {
    "labels": {
      "title": "廣告主與成員列表",
      "name": "廣告主名稱：{{name}}",
      "id": "廣告主編號",
      "website": "官方網站",
      "publisher": "發佈商",
      "category": "預設素材分類",
      "note": "其他說明事項",
      "advertiserSegmentSource": "其他廣告主受眾",
      "editAdvertiser": "編輯廣告主",
      "segmentSource": "其他廣告主受眾來源"
    },
    "tabs": {
      "member": "成員",
      "advertiserMemberList": "成員",
      "beaconConnectionList": "Beacon 連線方式"
    }
  },
  "advertiserMemberList": {
    "labels": {
      "nodata": "目前無成員，可由 + 成員 開始新增哦！",
      "newAdvertiserMember": "+ 成員",
      "deleteModalTitle": "刪除角色權限",
      "deleteModalContent": "確定要刪除所選角色權限？",
      "deleteAccountMemberSuccess": "刪除角色權限成功",
      "createAccountMemberSuccess": "新增角色權限成功",
      "editAccountMemberSuccess": "更新角色權限成功",
      "editHint": "編輯成員",
      "deleteHint": "刪除權限",
      "newAccount": "+ 帳號"
    },
    "placeholders": { "searchbar": "搜尋 成員名稱 或 電子信箱 …" },
    "permissions": {
      "ROLE_ADV_ADMIN": "廣告主 - 廣告管理師",
      "ROLE_ADV_REPORT": "廣告主 - 廣告委託人",
      "ROLE_ADV_SALES": "廣告主 - 廣告業務"
    },
    "headers": {
      "emailColumn": "電子郵件",
      "nameIdColumn": "名稱",
      "statusColumn": "狀態",
      "permissionColumn": "權限"
    }
  },
  "advertiserMemberForm": {
    "labels": {
      "email": "電子郵件",
      "role": "權限",
      "role_adv_admin": "廣告主│廣告管理師 - 管理該廣告主廣告",
      "role_adv_report": "廣告主│廣告委託人 - 瀏覽該廣告主廣告成效",
      "role_adv_sales": "廣告主│廣告業務 - 瀏覽該廣告主廣告資訊與成效",
      "createMember": "新增廣告主成員",
      "editMember": "編輯廣告主成員"
    }
  },
  "adLogoForm": {
    "labels": {
      "title": "廣告 Logo",
      "logoType": "Logo 種類",
      "logoLink": "連結",
      "logoUpload": "上傳",
      "typeErrorHint": "圖片格式為{{type}}格式, 必須為 jpg 或 png",
      "sizeErrorHint": "此圖大小為{{size1}}, 必須等於{{size2}}",
      "default": "預設",
      "custom": "自訂",
      "null": "無",
      "sizeHint": "圖片大小請等於 50 x 50",
      "logoPreview": "廣告 Logo 預覽",
      "logoHint": "廣告 Logo 只在 圖像式廣告 以及 原生廣告 中顯示"
    }
  },
  "adDeclarationForm": { "labels": { "title": "上傳廣告聲明書" } },
  "segmentHome": {
    "labels": {
      "title": "再行銷受眾",
      "agencyListTitle": "經銷商",
      "advertiserListTitle": "廣告主"
    }
  },
  "segmentList": {
    "placeholders": { "searchbar": "搜尋 再行銷受眾名稱 或 ID …" },
    "labels": {
      "newSegment": "+ 再行銷受眾",
      "nodata": "目前無再行銷受眾，可由 + 再行銷受眾 開始新增哦！",
      "chooseAgency": "請先選取經銷商",
      "duration": "{{days}}天",
      "deleteModalTitle": "刪除再行銷受眾",
      "deleteModalContent": "確定要刪除選擇的再行銷受眾以及其底下所有子再行銷受眾？",
      "editHint": "編輯再行銷受眾",
      "deleteHint": "刪除再行銷受眾",
      "deleteSuccess": "刪除再行銷受眾成功"
    },
    "headers": {
      "nameIdColumn": "再行銷受眾名稱",
      "durationColumn": "生命週期",
      "segmentCountColumn": "受眾數",
      "subSegmentAmountColumn": "子再行銷受眾個數"
    }
  },
  "segmentForm": {
    "labels": {
      "createTitle": "新增再行銷受眾",
      "editTitle": "編輯再行銷受眾",
      "advertiser": "廣告主",
      "name": "再行銷受眾名稱",
      "duration": "生命週期",
      "durationUnit": "天",
      "durationLimit": "可設定時間長度為 30天 - 365天"
    }
  },
  "segmentDetail": {
    "labels": {
      "dmpId": "再行銷受眾代碼",
      "duration": "生命週期",
      "segmentCount": "受眾數",
      "name": "再行銷受眾名稱: {{name}}",
      "title": "再行銷受眾資訊",
      "editSegment": "編輯再行銷受眾",
      "code": "代碼",
      "import": "匯入受眾",
      "reset": "重設受眾",
      "export": "匯出受眾",
      "importSuccess": "匯入受眾成功",
      "resetSuccess": "重設受眾成功",
      "exportSuccess": "匯出受眾成功",
      "fileSizeErrorModalTitle": "檔案過大",
      "fileSizeErrorModalContent": "匯入受眾，檔案大小必須小於 {{bytes}} bytes",
      "importCookies": "Cookie",
      "importDeviceIds": "行動裝置 ID"
    }
  },
  "segmentCode": {
    "labels": {
      "id": "再行銷受眾代碼",
      "code": "再行銷受眾蒐集程式碼",
      "codeHint": "須由網站管理者將本追蹤碼置入欲取得受眾資訊等目的之網站footer後，本追蹤碼方能產生效用。",
      "codeType": "代碼類型",
      "jsCode": "JS 追蹤碼",
      "imageCode": "圖像追蹤碼"
    }
  },
  "codePage": {
    "labels": {
      "privacy": "隱私權說明",
      "privacyStatement": "本追蹤代碼主要用於追蹤使用者的行爲，協助把事件轉發到第三方廣告或分析平台 (e.g. Facebook, AdWords, Google Analytics)，或是追蹤轉換成效等用途。請詳閱 TenMax 的<1>隱私權條款</1>，當程式碼置入\n網站中即視同於同意此條款。",
      "copyCodeSuccess": "複製代碼成功"
    }
  },
  "subSegmentList": {
    "labels": {
      "newSegment": "+ 子再行銷受眾",
      "nodata": "目前無子再行銷受眾，可由 + 子再行銷受眾 開始新增哦！",
      "deleteModalTitle": "刪除子再行銷受眾",
      "deleteModalContent": "確定要刪除選擇的子再行銷受眾？",
      "editHint": "編輯子再行銷受眾",
      "exportHint": "匯出子再行銷受眾",
      "deleteHint": "刪除子再行銷受眾",
      "deleteSuccess": "刪除再行銷受眾成功"
    },
    "headers": {
      "nameIdColumn": "子再行銷受眾名稱",
      "dmpSegmentIdColumn": "子再行銷受眾代碼",
      "segmentCountColumn": "受眾數",
      "ruleContentColumn": "網站條件"
    },
    "placeholders": { "searchbar": "搜尋 子再行銷受眾名稱 或 ID …" }
  },
  "segmentRuleComparator": {
    "labels": {
      "contains": "包含",
      "equals": "等於",
      "starts_with": "起始於",
      "ends_with": "結束於",
      "does_not_equal": "不等於",
      "does_not_contain": "不包含",
      "does_not_start_with": "非起始於",
      "does_not_end_with": "非結束於",
      "regex": "正規表示"
    }
  },
  "subSegmentForm": {
    "labels": {
      "createTitle": "新增子再行銷受眾",
      "editTitle": "編輯子再行銷受眾",
      "name": "子再行銷受眾名稱",
      "ruleContent": "進階篩選-網址條件",
      "filterRules": "篩選條件",
      "ruleContentEmptyError": "請加入至少一個有效的網站條件"
    }
  },
  "conversionHome": {
    "labels": {
      "title": "轉換追蹤",
      "agencyListTitle": "經銷商",
      "advertiserListTitle": "廣告主"
    }
  },
  "conversionForm": {
    "labels": {
      "createTitle": "新增轉換追蹤",
      "editTitle": "編輯轉換追蹤",
      "advertiser": "廣告主",
      "name": "轉換追蹤名稱",
      "type": "種類"
    }
  },
  "conversionList": {
    "labels": {
      "newConversion": "+ 轉換追蹤",
      "nodata": "目前無轉換追蹤，可由 + 轉換追蹤 開始新增哦！",
      "chooseAgency": "請先選取經銷商",
      "editHint": "編輯轉換追蹤",
      "codeHint": "轉換追蹤代碼"
    },
    "placeholders": { "searchbar": "搜尋 轉換追蹤名稱 或 ID …" },
    "headers": { "nameIdColumn": "轉換追蹤名稱", "typeColumn": "種類" }
  },
  "conversionType": {
    "labels": {
      "purchase": "已購買",
      "cart": "購物車",
      "signUp": "註冊",
      "lead": "導向",
      "viewOfAKeyPage": "觀看",
      "others": "其他"
    }
  },
  "conversionCode": {
    "labels": {
      "id": "轉換追蹤代碼",
      "code": "轉換追蹤程式碼",
      "codeHint": "請複製追蹤程式碼，並將追蹤程式碼黏貼於網站內 <body> 標籤後方，以確保事件蒐集資訊可準確傳送至伺服器內。"
    }
  },
  "accountActorList": {
    "labels": {
      "deletePermissionContent": "確定要刪除此帳號的權限？",
      "actionHint": { "edit": "編輯帳號權限", "delete": "刪除帳號權限" }
    }
  },
  "accountDetail": {
    "labels": {
      "name": "帳號名稱：{{name}}",
      "resendActivationEmail": "重送認證信"
    }
  },
  "loginPage": {
    "labels": {
      "loginError": "帳號或密碼不正確",
      "emailTitle": "電子信箱",
      "passwordTitle": "密碼",
      "forgotPassword": "忘記密碼?",
      "privacyPolicy": "隱私權政策",
      "confirmPasswordTitle": "確認密碼"
    }
  },
  "prompt": {
    "labels": {
      "title": "即將離開編修頁面",
      "message": "編修的內容尚未儲存哦！ 請問您確定要離開嗎？"
    }
  },
  "daypick": {
    "labels": {
      "add1Day": "1 天",
      "add7Days": "7 天",
      "add1Month": "1 個月",
      "thisWeek": "本週",
      "thisMonth": "本月",
      "endOfNextMonth": "下個月底",
      "endOfNext3Months": "下 3 個月底",
      "today": "今天",
      "yesterday": "昨天",
      "last7Days": "過去 7 天",
      "last30Days": "過去 30 天",
      "lastWeek": "上週",
      "lastMonth": "上個月"
    }
  },
  "advertiserDetailModal": {
    "titles": { "addOtherAdvertiserSegments": "增加其他廣告主受眾資料來源" }
  },
  "videoForm": {
    "labels": {
      "inStream": "In-Stream (Pre-Roll)",
      "outStream": "Out-Stream",
      "unlimitStream": "不限",
      "nonSkippable": "不可略",
      "skippable": "可略",
      "videoSource": "選擇影片來源",
      "tenMaxVideo": "TenMax",
      "3rdVideo": "3rd Party",
      "tenMaxVideoInput": "影片檔案",
      "3rdVideoInput": "Ad Serving URL",
      "3rdVideoDuration": "影片長度"
    }
  },
  "advertiserSegmentSource": {
    "labels": {
      "addSourceBtn": "增加來源",
      "advertiserSegmentSource": "受眾來源",
      "title": "其他廣告主受眾資料"
    },
    "placeholders": {
      "agencies": "請選擇經銷商",
      "advertisers": "請選擇廣告主"
    }
  },
  "thirdPartyVideoPreview": { "labels": { "thirdParty": "Third Party" } },
  "videoCreativePreivew": { "labels": { "generating": "預覽圖產生中" } },
  "videoCreativeDetail": { "labels": { "generating": "影片產生中" } },
  "creativeChooseAdvertiser": {
    "title": { "warning": "警告" },
    "labels": {
      "advertiserChangeAlert": "如果更換廣告主，剛剛編輯的內容將會重置，確定要切換嗎？"
    }
  },
  "nativeForm": {
    "labels": {
      "nativeBannerTitle": "廣告樣式",
      "enableNativeBanner": "投遞至圖像式廣告流量",
      "cannotModifyHint": "※ 素材建立後，將無法修改！"
    }
  },
  "nativeBanner": {
    "labels": {
      "sponsoredBy": "{{sponsor}} 贊助",
      "learnMore": "瞭解詳情",
      "recommendation": "熱門推薦"
    }
  },
  "nativeCreativeDetail": {
    "labels": { "toggleBanner": "圖像素材", "toggleNative": "原生素材" }
  },
  "ppsCreativeDetail": {
    "labels": { "toggleMobile": "手機版", "toggleDesktop": "電腦版" }
  },
  "nativeMediaSummary": {
    "titles": { "native": "原生素材", "nativeBanner": "圖像素材" }
  },
  "imageCreativeSizeHint": {
    "labels": {
      "sizeInstruction": "尺吋說明",
      "recommendTitle": "推薦使用圖片尺寸",
      "otherSizeTitle": "其他支援圖片尺寸"
    }
  },
  "ppsForm": {
    "labels": {
      "macroInstruction": "代碼中必須包含必要的追蹤巨集",
      "htmlSnippet": "廣告代碼",
      "normalBannerUrlHint": "會按照 Ad Tag 裡面設定的導外連結，如果需要調整，請聯絡 Ad Tag 服務商",
      "layoutId": "版型 ID",
      "subLayout": "子版型",
      "noCorrespondingLayoutId": "不支援的版型 ID: {{layoutId}}",
      "layoutIdNotFound": "找不到版型 ID",
      "autoGenImage": "自動產生",
      "cannotFindPreveiwImage": "找不到對應的預覽圖片",
      "needPPSCreativeID": "請先輸入有效的 AdNeon 代碼"
    }
  },
  "macro": {
    "titles": {
      "clickMacroDesc": "系統將自動檢查是否包含必要的追蹤巨集, 您的廣告代碼中必須至少包含以下其中一種巨集",
      "viewableMacroDesc": "AdNeon 素材的廣告代碼中必須包含以下巨集"
    },
    "headers": {
      "clickMacro": "點擊追蹤巨集",
      "desc": "描述",
      "viewableMacro": "可視曝光追蹤巨集"
    },
    "unescapedClickURL": "未轉譯的點擊追踪網址",
    "escapedClickURL": "轉譯的點擊網址",
    "doubledEscapedClickURL": "兩次轉譯的點擊網址",
    "vastUrl": "針對影片觀看事件，需提供 VAST 格式的 URL",
    "dspViewableURL": "DSP可視曝光追蹤巨集",
    "sspViewableURL": "SSP可視曝光追蹤巨集",
    "adxViewableURL": "ADX可視曝光追蹤巨集",
    "bannerUrl": {
      "clickId": "此次點擊的追蹤ID巨集",
      "idfa": "點擊廣告IOS裝置的追蹤ID巨集",
      "androidId": "點擊廣告AOS裝置的追蹤ID巨集",
      "campaignId": "點擊廣告的廣告ID巨集",
      "bannerId": "點擊廣告的素材ID巨集"
    },
    "hint": {
      "appsflyer": "*注意：此規則只適用於Appsflyer的網址，如果其他有類似需求，請洽窗口"
    }
  },
  "ppsFormValidate": {
    "labels": {
      "macroError": "AdNeon 代碼缺少必要的巨集",
      "codeSizeToLarge": "AdNeon 代碼太過肥大，請減少內容"
    }
  },
  "html5Form": {
    "labels": {
      "recommended": "推薦",
      "bannerSize": "素材尺寸",
      "htmlZip": "Html壓縮檔",
      "typeHint": "僅可使用 zip 格式",
      "fileHint": "※ 請將素材網頁的相關檔案壓縮成zip檔再上傳，<1>點擊這裡</1>下載範例檔案",
      "typeErrorHint": "檔案格式為{{type}}格式, 必須為zip"
    }
  },
  "outdoorForm": {
    "labels": {
      "outdoorType1": "影片",
      "outdoorType2": "圖 + 音",
      "outdoorType3": "影 + 圖",
      "outdoorType4": "HTML",
      "outdoorType2Epaper": "圖片",
      "duration15": "15 秒",
      "duration30": "30 秒",
      "duration0": "不限制",
      "videoProportionHint": "影片比例須為 {{proportion}}",
      "videoProportionErrorHint": "此影片比例必須為 {{proportion}}",
      "videoSizeHint": "影片尺吋須為 {{size}}",
      "videoSizeBoxingHint": "影片尺寸限制請查看素材資訊提醒",
      "imageSizeBoxingHint": "圖片尺寸限制請查看素材資訊提醒",
      "orderName": "訂單名稱",
      "orderBudget": "訂單預算",
      "orderSchedule": "訂單預期走期",
      "selfCheckDocument": "自檢表",
      "outdoorType6": "圖片"
    },
    "hints": {
      "orderName": "{{channelName}} 審核人員會根據資訊來決定是否審核通過，再請詳實填寫",
      "orderBudget": "{{channelName}} 審核人員會根據資訊來決定是否審核通過，再請詳實填寫",
      "orderSchedule": "檔期設定會於素材審查階段顯示供審核人員參考，不影響正式的走期設定",
      "selfCheckFileType": "僅可使用 doc / docx / pdf 格式",
      "selfCheckFileExample": "<1>點擊這裡</1>下載範例檔案",
      "nonExpressPassCategory": "不適用快速通關，請上傳自檢表"
    },
    "errors": { "selfCheckDocumentRequired": "請上傳自檢表供素材審查" }
  },
  "streamingStatus": {
    "title": "直撥素材調整",
    "labels": {
      "create": "+ 直撥素材調整",
      "edit": "編輯直撥素材調整",
      "noData": "直撥素材調整"
    }
  },
  "streamingStatusList": {
    "headers": { "crid": "Creative id", "isLive": "是否直播中" },
    "hints": { "edit": "編輯直撥素材狀態" }
  },
  "streamingStatusForm": {
    "labels": {
      "createTitle": "新增直撥素材狀態",
      "editTitle": "編輯直撥素材狀態",
      "crid": "Creative id",
      "isLive": "是否直播中"
    }
  },
  "beaconFields": {
    "labels": {
      "beaconConnection": "官方帳號",
      "webhookType": "Webhook 類型",
      "hardwareId": "Hardware ID",
      "channelSecret": "Channel Secret",
      "channelAccessToken": "Channel Access Token",
      "beaconConfigSwitch": "Beacon 推播通知",
      "generateWebhook": "產出 Webhook URL",
      "generateBeaconAPIUrl": "產出 Beacon API URL",
      "tenmaxSupport": "TenMax Support",
      "tenmax": "TenMax Support",
      "advertiserSelfServe": "廣告主自有 webhook",
      "beaconType": "Beacon Type",
      "frequencyCap": {
        "every": "每",
        "send": "發送",
        "cappingCount": "次",
        "cappingCounts": "次"
      },
      "frequencyCapSwitch": "發送限制",
      "language": "使用者語系",
      "lineUserLanguage": {
        "all": "不限",
        "zh_hant": "繁體中文",
        "zh_hans": "簡體中文",
        "en": "英文",
        "ja": "日文",
        "th": "泰文"
      }
    },
    "buttons": {
      "generateWebhook": "點擊後複製 Webhook URL",
      "generateBeaconAPIUrl": "點擊後複製 Beacon API URL"
    },
    "hints": {
      "generateWebhookSuccess": "Webhook url 已被複製到剪貼簿",
      "generateBeaconUrlSuccess": "Beacon API url 已被複製到剪貼簿"
    }
  },
  "comboForm": {
    "labels": {
      "videoHint": "影片長度不可超過{{sec}}秒且高度不可超過{{height}}",
      "videoDurationErrorHint": "此影片長度為{{sec1}}秒，不可超過{{sec2}}秒",
      "videoHeightErrorHint": "此影片高度為{{height1}}，不可超過{{height2}}"
    }
  },
  "doctor": {
    "labels": { "campaignId": "廣告活動ID", "creativeId": "素材ID" }
  },
  "doctors": {
    "labels": {
      "campaignIdPlaceholder": "請輸入廣告活動ID",
      "creativeIdPlaceholder": "請輸入素材ID",
      "noCreative": "此廣告活動沒有綁定任何素材",
      "title": "排查廣告活動投遞限制"
    }
  },
  "doctorChart": {
    "labels": { "remain": "剩餘版位", "filtered": "被過濾版位" }
  },
  "doctorTable": {
    "labels": {
      "filterConditionTitle": "過濾條件",
      "tenmaxCategory": "素材分類",
      "interstitial": "蓋板設定",
      "creativeTitle": "素材"
    },
    "headers": { "domain": "網域", "spaceCount": "版位數量" },
    "placeholders": {
      "filterCondition": "請選擇過濾條件",
      "searchbar": "搜尋 網域 或 版位…"
    },
    "tabs": { "filtered": "被過濾流量資訊", "remained": "剩餘流量資訊" }
  },
  "doctorTableRowExtender": {
    "labels": {
      "banCategoryReasonTitle": "版位禁止分類：",
      "intersitialCampaign": "版位為蓋板版位，此廣告活動不允許投遞到蓋板版位",
      "intersitialCreative": "版位為蓋板版位，此素材不允許投遞到蓋板版位",
      "reasonTitle": "無法投遞原因"
    },
    "placeholders": {
      "spaceList": "搜尋版位以查看詳細資訊",
      "banReason": "選擇版位以查看原因"
    }
  },
  "campaignControlList": {
    "headers": { "name": "群組名稱", "campaignInfos": "廣告活動數量" },
    "placeholders": { "searchbar": "搜尋預算分配群組..." },
    "labels": {
      "newCampaignControl": "+ 預算分配群組",
      "noData": "目前無預算分配群組，可由 + 預算分配群組 開始新增哦！",
      "editHint": "編輯預算分配群組",
      "deleteHint": "刪除預算分配群組",
      "deleteModalTitle": "刪除預算分配群組",
      "deleteModalContent": "確定要刪除選擇的預算分配群組？",
      "managementModalTitle": "管理廣告活動",
      "campaignEditHint": "管理廣告活動"
    }
  },
  "campaignControlForm": {
    "labels": {
      "createTitle": "建立預算分配群組",
      "editTitle": "編輯預算分配群組",
      "name": "名稱",
      "campaigns": "廣告活動"
    },
    "placeholders": { "campaigns": "請選擇欲管理的廣告活動" }
  },
  "changePasswords": {
    "title": { "change": "變更密碼" },
    "message": { "reload": "密碼更新完成，需重新登入。" }
  },
  "campaignControlCampaignList": {
    "headers": { "name": "廣告活動名稱" },
    "labels": { "deleteHint": "將廣告活動從此群組移除" },
    "placeholders": { "searchbar": "搜尋廣告活動" }
  },
  "sudo": {
    "placeholders": { "searchbar": "搜尋 電子郵箱 或 名稱" },
    "label": { "platformAccounts": "平台帳號", "oemAccounts": "白牌帳號" },
    "message": { "success": "變身成功" }
  },
  "errorBoundary": { "labels": { "title": "發生未知的錯誤" } },
  "bidPriceSetting": {
    "labels": {
      "display": "展示型廣告出價設定",
      "video": "影音型廣告出價設定",
      "combo": "影+圖廣告出價設定",
      "thirdParty": "3rd Party(未分類)廣告出價設定",
      "thirdPartyBottom": "3rd Party(置底)廣告出價設定",
      "thirdPartyRectangle": "3rd Party(中矩形)廣告出價設定",
      "oneForAllDisplay": "One For All 展示型廣告出價設定",
      "ctv": "數位電視廣告出價設定",
      "keyword": "關鍵字廣告出價設定",
      "message": "簡訊廣告出價設定",
      "picShort": "PIC  戶外廣告 15 秒廣告出價設定",
      "picLong": "PIC  戶外廣告 30 秒廣告出價設定",
      "picExtended": "PIC  戶外廣告 60 秒廣告出價設定",
      "picBroad": "PIC  戶外廣告 60+ 秒廣告出價設定",
      "hwacomShort": "華電聯網 15 秒廣告出價設定",
      "hwacomLong": "華電聯網 30 秒廣告出價設定",
      "hwacomExtended": "華電聯網 60 秒廣告出價設定",
      "hwacomBroad": "華電聯網 60+ 秒廣告出價設定",
      "fridgeBroad": "冰櫃戶外廣告 60+ 秒廣告出價設定",
      "fridgeLong": "冰櫃戶外廣告 30 秒廣告出價設定",
      "fridgeExtended": "冰櫃戶外廣告 60 秒廣告出價設定",
      "sandboxOutdoor": "研發測試用戶外廣告出價設定",
      "sandboxMovableOutdoor": "研發測試用移動式戶外廣告出價設定",
      "outdoorLineMessage": "Outdoor Line Message 廣告出價設定",
      "lineMessage": "Line Message 廣告出價設定",
      "autoBidCapSetting": "自動投遞上限設定",
      "bidFloorSetting": "最低投遞金額設定"
    },
    "optimize": {
      "cpc": "點擊",
      "cpm": "曝光",
      "cpv": "影片瀏覽",
      "vcpm": "可視曝光",
      "acpm": "人流數",
      "wcpm": "螢幕比例曝光",
      "bcpm": "每則訊息費用",
      "dcpm": "動態 CPM"
    }
  },
  "agencyForm": {
    "placeholders": { "tags": "輸入ID後，可使用 Enter 鍵新增不同網站主 …" },
    "labels": {
      "sysMarginMaximumError": "系統利潤與媒體獎勵金比例總和必須小於{{value}}",
      "smallerThanAgcMarginError": "剩餘利潤不可小於經銷商預設利潤 {{value}}",
      "smallerThanOrderProfitError": "剩餘利潤不可小於經銷商利潤上限 {{value}}",
      "orderDefaultProfitBiggerThanMaxProfit": "經銷商預設利潤不可大於經銷商利潤上限",
      "clickToAddEffectDate": "點擊加入生效日期",
      "rebateRateMaximumError": "媒體獎勵金不可大於系統利潤：{{margin}}"
    }
  },
  "agencyList": { "labels": { "editHint": "編輯經銷商" } },
  "productGroupList": {
    "labels": {
      "title": "產品群組管理",
      "space": "版位",
      "domain": "網域",
      "deleteHint": "刪除產品群組",
      "noData": "目前無產品群組，可由 + 產品群組 開始新增哦！",
      "campaignModalTitle": "廣告活動資訊",
      "showCampaignHint": "顯示使用此產品群組的廣告活動資訊",
      "create": "建立產品群組",
      "editHint": "編輯產品群組",
      "deleteModalTitle": "刪除產品群組",
      "deleteModalContent": "確定要刪除此產品群組？"
    },
    "headers": { "id": "名稱", "description": "敘述", "agencys": "經銷商" },
    "placeholders": { "searchbar": "搜尋產品群組" }
  },
  "campaignUseProductGroup": {
    "headers": { "id": "廣告活動ID", "name": "廣告活動名稱" }
  },
  "productGroupForm": {
    "labels": {
      "groupName": "群組名稱",
      "groupType": "類型",
      "adspace": "版位",
      "domain": "網域",
      "agencyIds": "能使用此群組的經銷商",
      "description": "敘述",
      "customDomain": "自訂網域",
      "customSpace": "自訂版位",
      "customSpaceName": "名稱",
      "customSpaceId": "ID",
      "createTitle": "建立產品群組",
      "editTitle": "編輯產品群組",
      "single": "單一",
      "multiple": "多個",
      "adFormat": "廣告樣式",
      "channel": "投遞渠道",
      "attributes": "屬性",
      "selectAllSpace": "全選",
      "conditionSpace": "依條件自動更新版位",
      "selectAllDevice": "全選",
      "conditionDevice": "依條件自動更新機台",
      "selectAllStore": "全選",
      "conditionStore": "依條件自動更新門市"
    },
    "buttons": {
      "customSpace": "+ 自訂版位",
      "customDomain": "+ 自訂網域",
      "filterSpace": "篩選版位",
      "filterDevice": "篩選機台",
      "filterStore": "篩選門市",
      "editFilters": "編輯條件",
      "editAdspace": "編輯版位",
      "editDomain": "編輯網域",
      "finishEdit": "編輯完成"
    },
    "placeholders": {
      "customDomain": "輸入網域後，可使用 Enter 鍵新增 …",
      "addDomain": "範例: www.example.com"
    },
    "addDomain": "自訂網域",
    "title": {
      "generalSection": "一般",
      "filterSection": "條件",
      "selectAdspaceSection": "版位",
      "selectDomainSection": "網域",
      "selectStoreSection": "門市",
      "selectDeviceSection": "機台"
    },
    "titles": { "other": "其他" },
    "hints": {
      "conditionSpace": "選擇【依條件自動更新版位】後，系統會依據設定的條件，自動更新廣告版位的屬性。當廣告版位屬性異動時，系統將自動同步調整，並更新廣告投放的版位，確保廣告投放與實際版位屬性相符。",
      "conditionDevice": "選擇【依條件自動更新機台】後，系統會依據設定的條件，自動更新廣告機台的屬性。當廣告機台屬性異動時，系統將自動同步調整，並更新廣告投放的機台，確保廣告投放與實際機台屬性相符。",
      "conditionStore": "選擇【依條件自動更新門市】後，系統會依據設定的條件，自動更新廣告門市的屬性。當廣告門市屬性異動時，系統將自動同步調整，並更新廣告投放的門市，確保廣告投放與實際門市屬性相符。",
      "autoUpdate": "依條件自動更新"
    }
  },
  "productGroup": {
    "placeholders": { "search": "搜尋" },
    "labels": { "autoUpdate": "(版位依條件更新)" },
    "space": {
      "attributes": {
        "store": { "postfix": "{{value}}分店" },
        "titles": {
          "storeNum": "門市資訊",
          "cityGroup": "地理分區",
          "administrativeArea": "行政區",
          "outdoorPlaceCategories": "區域特性",
          "weather": "氣象資訊",
          "deviceCharacteristic": "機台資訊"
        }
      }
    }
  },
  "outdoorMonitor": {
    "labels": {
      "dayRange": "走期",
      "agency": "經銷商",
      "total": "預計總共流量秒數",
      "remain": "預計剩餘流量秒數",
      "proposal": "提案訂單使用流量秒數",
      "formal": "正式訂單使用流量秒數",
      "day": "天",
      "hour": "時",
      "title": "戶外廣告流量監控"
    },
    "placeholders": { "agencies": "請選擇經銷商", "searchbar": "搜尋 訂單 …" }
  },
  "creditList": {
    "labels": {
      "title": "信用額度",
      "noData": "目前無信用額度資訊",
      "pay": "入帳",
      "payConfirm": "即將入帳 {{name}} {{date}} 帳單，您確定嗎？"
    },
    "headers": {
      "agency_id": "經銷商",
      "used_credit": "已用額度",
      "creditLimit": "總信用額度"
    },
    "placeholders": { "searchbar": "搜尋信用額度資訊 …" }
  },
  "creditDetail": {
    "labels": {
      "totalCredit": "總信用額度",
      "remainCredit": "剩餘信用額度",
      "billUnpaid": "應付帳款",
      "billSpent": "已花費",
      "paymentAt": "上次付款：{{amount}} 於 {{at}}",
      "noLastPaid": "沒有付款資訊",
      "title": "信用額度",
      "pay": "入帳"
    }
  },
  "creditLog": {
    "labels": {
      "approveAddOrderBudget": "增加訂單預算 {{orderNumber}}",
      "approveReduceOrderBudget": "減少訂單預算 {{orderNumber}}",
      "addCreditLimit": "增加信用額度上限",
      "reduceCreditLimit": "減少信用額度上限",
      "orderSettleAddOrderBudget": "結算訂單 {{orderNumber}}",
      "orderSettleReduceOrderBudget": "結算訂單 {{orderNumber}}",
      "approveNewOrder": "新增訂單 {{orderNumber}}",
      "paidBill": "管理者入帳 {{dateId}}",
      "noData": "沒有信用額度資訊"
    },
    "headers": {
      "ctime": "日期",
      "note": "說明",
      "paid": "入帳",
      "unpaid": "應付額",
      "updatedCredit": "信用餘額"
    }
  },
  "creditPayModal": {
    "labels": {
      "agency": "經銷商",
      "currency": "幣別",
      "period": "帳單週期",
      "payment": "金額",
      "credit": "恢復信用額度",
      "noData": "沒有未付帳單"
    }
  },
  "currencyRateList": {
    "labels": {
      "title": "匯率設定",
      "NTD": "台幣 NTD",
      "MYR": "馬幣 MYR",
      "JPY": "日幣 JPY",
      "VND": "越南盾 VND",
      "EUR": "歐元 EUR",
      "IDR": "印尼盾 IDR",
      "noData": "目前無該幣別匯率資料，可由 新增匯率 開始新增哦！",
      "create": "新增匯率",
      "oneDollarEqual": "1美元兌換"
    },
    "headers": { "ctime": "日期", "rate": "匯率", "createdBy": "建立者" }
  },
  "l1Object": {
    "labels": {
      "noData": "目前無廣告群組，可由 + 廣告群組 開始新增哦！",
      "create": "+ 廣告群組",
      "createTitle": "建立廣告群組",
      "editTitle": "編輯廣告群組",
      "deleteTitle": "刪除廣告群組",
      "name": "群組名稱",
      "l1ObjectId": "群組名稱",
      "channel": "群組頻道",
      "budget": "預算",
      "autoOptimise": "廣告活動預算自動優化",
      "channel_all": "ALL",
      "channel_rtb": "RTB",
      "channel_pic": "PIC Outdoor",
      "channel_fridge": "WI Fridge",
      "channel_message": "Message",
      "channel_matsukiyo": "Retail Beacon Network",
      "channel_hwacom": "華電聯網",
      "detailTitle": "廣告群組與廣告活動",
      "deleteModalContent": "確定要刪除選擇的廣告群組？",
      "state": "群組狀態",
      "budgetBalance": "可用預算",
      "outdoorDeviceReport": "機台投遞成效",
      "objectiveLabel": "行銷目標",
      "objective": {
        "awareness": "品牌認知",
        "traffic": "流量",
        "sales": "銷售",
        "unspecified": "未指定"
      },
      "cannotDeleteTitle": "無法刪除已建立廣告活動的廣告群組",
      "message_cannotDeleteTitle": "無法刪除有當天排程的廣告活動或已經開始的廣告活動的廣告群組。",
      "bidStrategyLabel": "出價策略",
      "bidStrategy": {
        "lowest_cost_without_cap": "自動投遞",
        "lowest_cost_with_bid_cap": "出價上限",
        "cost_cap": "成本上限"
      },
      "viewableImpressReport": "結案報告使用可視曝光",
      "downloadReport": "下載 RTB 報表",
      "delivery": "投遞狀態",
      "impres": "曝光數",
      "viewable": "可視曝光數",
      "clicks": "點擊數",
      "cpc": "CPC",
      "ctr": "點擊率",
      "vctr": "可視點擊率",
      "convs": "轉換數",
      "cpa": "每次轉換費用",
      "cvr": "轉換率",
      "cboTimeLimit": "需要等待 {{time}} 分鐘才能再次切換",
      "campaignBudgetDisableHint": "僅在“廣告預算優化”開啟時可用。",
      "results": "成果",
      "uu": "不重複使用者",
      "spent": "已花費",
      "view": "影片觀看次數",
      "viewRate": "影片觀看率",
      "viewableViewRate": "影片可視觀看率",
      "videoPlayActions": "影片觀看次數",
      "videoWatched2s": "影片觀看 2 秒次數",
      "videoWatched6s": "影片觀看 6 秒次數",
      "videoViewsP25": "影片觀看 25% 次數",
      "videoViewsP50": "影片觀看 50% 次數",
      "videoViewsP75": "影片觀看 75% 次數",
      "videoViewsP100": "影片觀看 100% 次數",
      "profileVisits": "付費主頁訪問數",
      "likes": "付費點讚數",
      "comments": "付費評論數",
      "shares": "付費分享數",
      "follows": "付費關注數",
      "clicksOnMusicDisc": "音樂點擊數",
      "rtbCboLimitation": "廣告群組的所有廣告活動必須具有相同的優化目標和出價策略才能啟用此功能。",
      "rtbCboDailyBudgetHint": "廣告群組底下包含了有使用每日預算的廣告活動，因此 CBO 無法開啟",
      "cboRtbCampaignLengthLimit": "廣告群組必須至少有一個廣告活動才能關閉 CBO",
      "cboRtbCampaignBudgetLimit": "廣告群組底下包含了預算少於每日最小預算x天數的廣告活動: {{campaignIds}}"
    },
    "placeholders": { "searchbar": "搜尋廣告群組活動名稱與編號..." },
    "hints": { "editRtbCampaignBudgets": "編輯 RTB 廣告活動預算" }
  },
  "adSetSetupFlow": {
    "mainStep": {
      "fieldset": { "optimizationTitle": "最佳化與投遞" },
      "field": {
        "optimizationGoal": "廣告投遞最佳化",
        "bidStrategy": "出價策略",
        "bidControl": "出價上限",
        "orderPrice": "合約價格",
        "billingEvent": "計費標準",
        "frequencyControl": "曝光頻率上限",
        "useFrequencyControl": "使用頻次控制"
      },
      "labels": {
        "impression": "曝光",
        "frequencyControl": "每 {{interval_days}} {{unit}} {{event}} {{max_frequency}} 次",
        "frequencyCap": { "event": "次{{event}} 每", "unit": "{{unit}}" }
      },
      "errors": {
        "emptyMaxFrequency": "曝光頻率上限不可為空",
        "emptyIntervalDays": "間隔天數不可為空",
        "maxFrequencyOutofRange": "曝光頻率數值必須介於 {{min}} ~ {{max}}",
        "intervalDaysOutofRange": "間隔天數必須介於 {{min}} ~ {{max}}"
      }
    }
  },
  "optimizationGoal": {
    "impressions": "曝光次數",
    "clicks": "點擊次數",
    "video_views": "影片觀看次數",
    "reach": "觸及人數",
    "sales": "銷售轉換行為",
    "landing_page_views": "目標頁面瀏覽次數",
    "fixed_viewable_impression": "可視曝光次數",
    "video_views_reach": "影片觀看觸及人數",
    "acpm": "人流次數",
    "wcpm": "螢幕比例曝光次數",
    "unspecified": "未指定"
  },
  "l1ObjectList": {
    "labels": {
      "l1ObjectCount": "廣告群組 {{count}}",
      "drafts": "{{count}} 份草稿",
      "cbo": "CBO",
      "non-cbo": "非 CBO",
      "activeState": "放送中",
      "deactivateState": "已停用",
      "deleteState": "已刪除",
      "notStartState": "未開始",
      "endState": "已結束",
      "statusFilter": "群組狀態",
      "statusFilterMenuTitle": "選擇群組狀態",
      "statusTag": "群組狀態",
      "deliveryFilter": "投遞狀態",
      "deliveryFilterMenuTitle": "選擇投遞狀態",
      "deliveryTag": "投遞狀態",
      "delivery": {
        "notStart": "未開始",
        "noCreatives": "無素材",
        "normal": "正常",
        "behind": "落後",
        "severelyBehind": "嚴重落後",
        "ahead": "超跑",
        "inactive": "已停用",
        "end": "已結束",
        "active": "放送中",
        "scheduled": "排隊中",
        "abandon": "已刪除",
        "abnormal": "異常",
        "pmpChanged": "PMP 變更"
      },
      "remainBudget": "預算剩餘",
      "undistributedBudget": "預算未分配",
      "orderStateCannotCreate": "未核准 / 結算中 / 已結算 的訂單無法建立廣告活動群組",
      "isEndCannotCreate": "已結束的訂單無法建立廣告活動群組",
      "noChannelAllowed": "沒有任何批准的投遞渠道無法建立廣告活動群組"
    }
  },
  "goSegmentForm": {
    "errors": { "uploadTypeErrorHint": "檔案格式為{{type}}格式, 必須為csv" },
    "titles": { "create": "建立受眾" },
    "hints": { "fileType": "僅可使用 csv 格式" }
  },
  "l2ObjectOptimize": {
    "labels": {
      "lowest_cost_without_cap": "RTB 會盡可能花費你全部的預算，並使用最低成本出價策略取得最多的{{optimization}}。如果你希望設定成本上限，請輸入期望數值。",
      "lowest_cost_with_bid_cap": "RTB 在競價中使用出價上限出價策略時，會盡可能取得最多的{{optimization}}，並保持出價金額不超過 {{bidControl}}。"
    }
  },
  "editLimitation": {
    "errors": {
      "repeat": "部分選項已經在其他流量中選取",
      "someSelectedOptionInvalid": "部分選擇的{{name}}是無效的。請刪除並重新選取",
      "tooManyKeywords": "不能超過 30 個關鍵字",
      "audienceLowestThreshold": "估算的受眾人數太少，請放寬受眾選擇條件",
      "requireIncludeLimitation": "至少需要選取一個限制流量的優化目標",
      "spaceOverBindingLimit": "有 {{count}} 個門市／機台在走期內已被 10 個活動綁滿（含暫停中的廣告群組），請移除後再送出"
    },
    "buttons": { "importTargeting": "匯入目標設定" }
  },
  "l1ObjectBudgetManagement": {
    "title": "{{num}} 廣告活動 的預算",
    "headers": {
      "id": "名稱",
      "status": "狀態",
      "spent": "已花費",
      "budget": "預算"
    },
    "hints": { "campaignBudget": "可用預算: {{total}}" }
  },
  "creativeBasicForm": {
    "labels": { "urlMacroInstruction": "素材連結支援的代碼" },
    "titles": {
      "clickMacroDesc": "系統支援以下這些Macro，會自動更換成相關的資料。請用\"&\"來串接不同的巨集"
    }
  },
  "authenticationManager": {
    "errors": { "noActor": "帳號沒有被給予任何角色，請聯絡管理員" }
  },
  "messageCampaignInfo": {
    "labels": { "insertShortUrl": "插入導外網址", "clickUrl": "導外網址" },
    "descriptions": {
      "invalidContent": "因為您輸入的 [{{texts}}] 為敏感字詞，建議少用 / 不使用這些字詞，否則無法通過審核，請調整簡訊文案後再送出，感謝！"
    }
  },
  "orderDetails": {
    "buttons": {
      "downloadFinalReport": "生成結案報告",
      "downloadOutdoorFinalReport": "生成 Outdoor 結案報告"
    }
  },
  "accountManager": {
    "errors": {
      "localeMeFailed": "獲取帳號資料失敗，如果持續此狀況，請聯絡系統管理員"
    }
  },
  "registerPage": {
    "titles": {
      "notice": "注意",
      "invalidLink": "無效的認證連結",
      "complete": "設定完成"
    },
    "messages": {
      "activated": "此認證連結已被使用且該帳號已被啟用。請使用設定的帳密登入系統。",
      "resendEmail": "請聯絡您的帳號管理員重送認證信。"
    },
    "labels": {
      "setPassword": "哈囉 {{name}},<3/>請設定您的密碼",
      "completeTitle": "設定完成！",
      "completeMessage": "密碼已成功設定，請登入開始使用 PMax3"
    }
  },
  "finalReportPage": {
    "titles": {
      "confirmation": "權限認證設定",
      "fail": "失敗",
      "common": {
        "adsPerformance": "Ads Performance",
        "overallAdsPerformance": "整體廣告投遞成效",
        "overallReport": {
          "platform": "Reporting By Platfrom",
          "l1Object": "廣告產品投遞成效"
        },
        "chart": {
          "platform": { "CTR": "每日平台曝光 v.s. 總點擊率 (%)" },
          "l1Object": {
            "CTR": "每日廣告產品曝光 v.s. 總點擊率 (%)",
            "VTR": "每日廣告產品曝光 v.s. 總觀看率 (%)"
          }
        },
        "deepDiveBy": {
          "platform": "Audience Deep Dive by Platform -",
          "l1Object": "Audience Deep Dive by Ad Product -",
          "order": "Audience Deep Dive by Order - {{name}}"
        },
        "table": {
          "platform": "依平台",
          "age_group": "依年齡",
          "gender": "依性別",
          "audience_segment": "By Audience Segment",
          "domain": "By Domain",
          "region": "By Region",
          "creative": "素材 (Top 5)",
          "service_area": "依地區 (Top 5)",
          "tenmax_segment": "TenMax 受眾群 (Top 6)",
          "traffic_category": "流量分類 (Top 5)"
        }
      },
      "outdoor": {
        "summaryInfo": "廣告訂單概要",
        "dailyInfo": "廣告每日曝光",
        "deliveryInfo": "投遞概要",
        "dailyInfoChart": "每日曝光數 & 人流數"
      }
    },
    "messages": {
      "login": "請登入後再使用 PMax3",
      "permission": "您沒有權限瀏覽報表資料",
      "exceeded": "資料取得超時，點選“確認”重新嘗試",
      "invalid": "無效的網址或報表不存在"
    },
    "labels": {
      "outdoor": {
        "advertiser": "廣告主",
        "industry": "產業",
        "period": "走期",
        "budget": "預算",
        "creativeDuration": "素材秒數",
        "cpm": "CPM 價格",
        "targetImpression": "目標曝光次數",
        "actualImpression": "實際曝光次數",
        "achievementRate": "達成率",
        "totalPlayHours": "總播放時數",
        "impres": "曝光數",
        "ePublisherImpres": "人流數",
        "storeCount": "門市數",
        "totalImpres": "總曝光數",
        "totalEPublisherImpres": "總人流次數",
        "thousandsUnit": "千",
        "district": "行政區",
        "impressionShareByCity": "縣市曝光佔比",
        "cityCounty": "縣市",
        "impressionShareByDistrict": "行政區曝光佔比",
        "store": "門市",
        "spent": "已花費",
        "totalPlayHoursValue": "約{{hours}}小時",
        "noData": "無投遞資料"
      },
      "common": {
        "header": { "confidential": "Confidential" },
        "settings": {
          "campaign_name": "廣告活動",
          "period": "走期",
          "budget": "預算",
          "order_name": "訂單"
        },
        "overall": {
          "actual": {
            "impression": "曝光數",
            "click": "點擊數",
            "conversion": "轉換數",
            "view": "觀看數"
          },
          "target": {
            "impression": "目標曝光數",
            "click": "目標點擊數",
            "conversion": "目標轉換數",
            "view": "目標觀看數"
          }
        },
        "adsImpact": {
          "sales": "Sales (IDR)",
          "transactions": "Transactions (Orders)",
          "items_sold": "Items Sold",
          "basket_size": "Basket Size",
          "lapse_users": "Lapse Users",
          "new_users": "New Users",
          "existing_users": "Existing Users",
          "totalSummary": "Total Summary",
          "averageDaily": "Average Daily"
        },
        "table": { "impressions": "曝光數", "convs": "轉換數" },
        "impressions": "曝光數",
        "clicks": "點擊數",
        "reach": "觸及人數",
        "convs": "轉換數",
        "views": "觀看數",
        "CTR": "CTR",
        "VTR": "VTR",
        "CPM": "CPM",
        "CPC": "CPC",
        "CPA": "CPA",
        "CPV": "CPV",
        "spend": "花費",
        "sales": "Sales",
        "transactions": "Transactions",
        "items_sold": "Items Sold",
        "users": "Users",
        "new_users": "New Users",
        "lapse_users": "Lapse Users",
        "existing_users": "Existing Users",
        "basket_size": "Basket Size",
        "unknown": "Unknown",
        "open_rtb": "Open RTB",
        "edimax": "EdiMax Outdoor",
        "pic": "PIC Outdoor",
        "platform": "平台",
        "age_group": "年齡",
        "gender": "性別",
        "audience_segment": "Audience Segment",
        "domain": "Domain",
        "region": "Region",
        "creative": "素材",
        "service_area": "地區",
        "l1Object": "廣告產品",
        "tenmax_segment": "TenMax 受眾群",
        "traffic_category": "流量分類",
        "benchmark": {
          "awareness": "Facebook Awareness",
          "traffic": "Facebook Traffic",
          "mixed": "Open RTB by Gojek"
        },
        "createdTime": "Created Time: {{createTime}}",
        "notes": {
          "title": "Notes:",
          "key": {
            "actual_impressions": "曝光數",
            "target_impressions": "目標曝光數",
            "impressions": "曝光數",
            "reach": "觸及人數",
            "clicks": "點擊數",
            "views": "觀看數",
            "CTR": "點擊率",
            "VTR": "VTR",
            "CPM": "CPM",
            "CPC": "CPC",
            "CPV": "CPV",
            "others": "其他",
            "sales": "Sales",
            "transactions": "Transactions",
            "items_sold": "Items Sold",
            "new_users": "New Users",
            "lapse_users": "Lapse Users",
            "existing_users": "Existing Users",
            "basket_size": "Basket Size",
            "service_area": "Service Area",
            "benchmarks": "Benchmarks"
          },
          "value": {
            "actual_impressions": "廣告投放曝光次數",
            "target_impressions": "訂單曝光次數目標",
            "impressions": "廣告投放曝光次數",
            "reach": "廣告不重複瀏覽人數",
            "clicks": "廣告點擊次數",
            "views": "廣告觀看次數",
            "CTR": "CTR(%). 廣告點擊次數除以廣告曝光次數",
            "VTR": "VTR(%). 廣告觀看次數除以廣告曝光次數",
            "CPM": "平均每千次曝光單價",
            "CPC": "平均點擊單價",
            "CPV": "平均觀看單價",
            "others": "各別報表細目與總計可能因資料類型區間略有不同",
            "sales": "Revenue (IDR) generated from transactions (orders) during campaign.",
            "transactions": "Total unique orders during campaign.",
            "items_sold": "Total items sold from transactions (orders) during campaign.",
            "new_users": "Users who have never made any purchase on Merchant / Brand.",
            "lapse_users": "Users who have not made any purchase in the last 60 days, then made purchase(s) during campaign period.",
            "existing_users": "Users who made purchase within the last 60 days.",
            "basket_size": "Average sales value per order.",
            "service_area": "Gojek area of operation; area classification is based of Gojek's grouping."
          }
        }
      },
      "tenmax": {
        "header": { "title": "嗨 {{advertiser}}，你的廣告成效如下!" }
      }
    }
  },
  "forgotPasswordPage": {
    "labels": {
      "hints": "請輸入您的信箱以重設密碼。密碼重設說明將會被寄送至此信箱。",
      "sentMailTitle": "重設密碼信件已送出！",
      "sentMailMessage": "請檢查收件匣，並點擊信中連結重設密碼。",
      "backToLogin": "回到登入頁面"
    }
  },
  "callToAction": {
    "learn_more": "了解詳情",
    "shop_now": "來去逛逛",
    "watch_more": "觀看更多",
    "buy_now": "立即購買"
  },
  "audienceInfo": {
    "labels": {
      "audienceSelection": "受眾選擇",
      "audienceEstimatedSize": "預估受眾大小",
      "audienceSizeTooSmall": "您的受眾範圍過於具體，可能無法順利投遞您的廣告。請嘗試使其涵蓋更廣泛的受眾。",
      "audienceEstimatedHint": "估算的受眾人數僅供參考，實際的受眾數以投遞當天撈取的數字為最新的資訊"
    },
    "buttons": { "estimate": "預估" }
  },
  "taInfoCard": {
    "labels": {
      "saveTargeting": "儲存目標設定以便下次快速匯入",
      "title": "儲存目標設定",
      "hint": "儲存目標設定，請選擇。",
      "new": "儲存為全新的目標設定",
      "replace": "取代原有的目標設定",
      "taName": "目標設定名稱",
      "toReplacedTAName": "目標設定: <1>{{name}}</1>"
    },
    "buttons": { "saveTargeting": "儲存目標設定" },
    "placeholders": { "taName": "輸入目標設定名稱" },
    "errors": { "taNameHasBeenUsed": "此名稱已被使用。" },
    "messages": {
      "createSuccess": "建立成功",
      "updateSuccess": "更新成功",
      "createFailed": "建立失敗",
      "updateFailed": "更新失敗"
    }
  },
  "savedTAManagement": {
    "labels": { "title": "匯入儲存的目標設定", "taOptions": "儲存的目標設定" },
    "buttons": { "import": "匯入", "delete": "刪除此目標設定" },
    "placeholders": { "taOptions": "請選擇" },
    "titles": {
      "import": "匯入儲存的目標設定",
      "delete": "刪除儲存的目標設定"
    },
    "messages": {
      "import": "您確定要用選取的目標設定取代目前的目標設定嗎？",
      "delete": "您確定要刪除此儲存的目標設定嗎？\n此操作無法還原。",
      "outdate": "由於平台版本更新，此儲存的目標設定已無法使用",
      "deleteSuccess": "刪除成功",
      "deleteFailed": "刪除失敗"
    }
  },
  "filterMenuTab": { "labels": { "filterList": "篩選條件" } },
  "draftCreateModal": {
    "buttons": {
      "goSummary": "總覽",
      "createDraft": "建立草稿",
      "addTarget": "新增其他廣告活動群組"
    },
    "titles": {
      "duplicate": "複製 {{number}} 個 {{l2Object}}",
      "target": "{{channel}} 廣告活動",
      "chooseTargetState": "選擇目標廣告活動群組"
    },
    "labels": {
      "order": "訂單",
      "l1Object": "廣告群組",
      "numberOfCopies": "複製數量",
      "includeBinding": "綁定素材"
    },
    "hints": {
      "cannotBindHint": "如果綁定素材不是從 PMAX 創建或是在其他廣告後台上編輯過，則不會被複製。",
      "l1ObjectNeedSameChannel": "只有同個頻道的廣告活動群組才能被選擇"
    }
  },
  "draftSummaryStateContent": {
    "labels": {
      "confirmationTitle": "廣告複製資訊總覽",
      "description": "來源廣告將被複製為草稿到以下廣告群組中",
      "hints": "所有關的資詢比如：廣告基本資訊、計價模式設定以及目標追蹤設定都會被複製。\n廣告活動的複製版本將會被儲存為草稿的形式，並在確認過後才進行正式投遞。\n若出價上限與您所選擇的廣告活動不同，將會依照您所選擇的廣告活動改變出價上限的設定。"
    },
    "confirmations": {
      "labels": {
        "order": "訂單",
        "l1Object": "廣告群組",
        "channel": "群組頻道",
        "creative": "素材",
        "copies": "複製數量",
        "status": "驗證狀態"
      }
    },
    "status": {
      "passed": "驗證通過",
      "error": {
        "endDate": "無法進行複製到走期已經結束的訂單",
        "delivery": "目的地廣告群組的投遞狀態呈現問題",
        "account": "Ad account 不同，無法進行複製"
      },
      "warning": {
        "bindings": "{{num}} 個廣告素材綁定不會被複製，因為來源廣告可能未被批准，或是在自助平台上進行了編輯，或是存在平台問題。"
      }
    }
  },
  "draftSourceDetails": {
    "labels": {
      "sourceDetails": "來源資訊",
      "orderName": "訂單名稱",
      "groupName": "廣告群組名稱",
      "channel": "群組頻道",
      "selectedOfCampaigns": "廣告選擇數量"
    }
  },
  "draftCamapignGroupOption": { "hints": { "selected": "已選擇" } },
  "draftSummaryState": { "labels": { "createSuccess": "草稿建立成功" } },
  "campaignSetupFlow": {
    "messages": {
      "updateDraftSuccess": "草稿儲存成功",
      "updateDraftFailed": "草稿儲存失敗",
      "publishBindingFailed": "RTB 廣告活動已成功建立，但廣告綁定建立失敗。稍後不要忘記新增廣告素材。",
      "publishL2L3Success": "RTB 廣告活動與廣告綁定建立成功。",
      "publishL2Success": "RTB 廣告活動建立成功。",
      "publishL2L3Failed": "RTB 廣告活動與廣告綁定建立失敗。"
    },
    "summaryStep": {
      "draftBindingTitle": "素材綁定",
      "labels": { "draftBinding": "素材" },
      "message": {
        "willDeliverImmediately": "由於活動計劃已啟動，因此廣告將在草稿發布後立即開始投放。"
      }
    }
  },
  "messageCampaignSetupFlow": {
    "descriptions": { "validatingContent": "正在驗證訊息內容中..." }
  },
  "orderType": { "enums": { "tenmax": "TenMax" } },
  "rtbCampaign": {
    "billingEvent": {
      "rs": {
        "reach": "曝光次數",
        "impressions": "曝光次數",
        "clicks": "點擊次數",
        "video_views": "影片瀏覽次數",
        "video_views_reach": "影片瀏覽次數",
        "sales": "點擊次數",
        "acpm": "曝光次數",
        "wcpm": "曝光次數"
      },
      "rb": {
        "reach": "曝光次數",
        "impressions": "曝光次數",
        "clicks": "點擊次數",
        "video_views": "影片瀏覽次數",
        "sales": "轉換行為次數"
      },
      "dcpm": "曝光次數",
      "fcpm": "曝光次數",
      "fcpv": "影片瀏覽次數",
      "fcpc": "點擊次數",
      "fvcpm": "曝光次數",
      "facpm": "曝光次數",
      "fwcpm": "曝光次數",
      "fbcpm": "每則訊息費用",
      "unspecified": "未指定"
    },
    "limitation": {
      "operationSet": { "preferred": "優先投遞", "include": "限制投遞" }
    }
  },
  "messageCampaign": {
    "billingEvent": {
      "unspecified": "未指定",
      "fixed_viewable_impression": "可視曝光次數"
    }
  },
  "orderDownloadReportPanel": {
    "labels": {
      "audienceData": "受眾資料",
      "country": "城市",
      "domain": "網域"
    }
  },
  "campaignDashboard": {
    "labels": {
      "future": "內",
      "ago": "前",
      "endsin": "結束於",
      "days": "天",
      "impres": "曝光數",
      "clicks": "點擊數",
      "ctr": "點擊率",
      "campaignCount": "廣告活動執行數",
      "spent": "已花費",
      "orderTotalBudget": "訂單總預算",
      "orderCount": "訂單執行數",
      "orderTotalSpent": "訂單總花費",
      "optimization": "出價模式",
      "bidStrategy": "出價策略",
      "bidCap": "出價上限",
      "adType": "活動類型",
      "campaignStatus": "活動狀態",
      "pleaseSearch": "請點擊查詢按鈕搜尋符合條件的廣告活動",
      "noData": "無符合條件的廣告活動",
      "adjustmentNeeded": "需要調整活動類型",
      "allCampaigns": "所有活動"
    },
    "titles": {
      "main": "廣告活動儀表板",
      "today": "今日成效",
      "yesterday": "昨日成效"
    },
    "buttons": { "search": "查詢", "download": "表單下載" },
    "placeholders": { "searchbar": "搜尋廣告活動..." },
    "headers": {
      "campaignId": "名稱",
      "adjustmentTags": "需要調整活動類型",
      "agencyName": "經銷商",
      "advertiserName": "廣告主",
      "orderName": "訂單",
      "executeRate": "投遞進度",
      "ctr": "點擊率",
      "bidPrice": "出價上限",
      "startDate": "開始日期",
      "endDate": "結束日期",
      "optimize": "出價模式與上限",
      "magnificationRatio": "權重",
      "orderId": "訂單編號",
      "campaignId_excel": "廣告活動編號",
      "campaignName": "活動名稱",
      "adType": "活動類型",
      "budget": "預算",
      "spent": "已花費",
      "optimize_excel": "出價模式"
    },
    "fileNames": {
      "filterInfo": { "1": "結束於{{days}}天內", "-1": "結束於{{days}}天前" },
      "allAdTypeInfo": "所有活動類型",
      "statusInfo": { "1": "放送中活動", "2": "已停用活動", "-1": "所有活動" }
    }
  },
  "adType": {
    "one_for_all_display": "One For All 展示型廣告",
    "display": "展示型廣告",
    "third_party_bottom": "行動置底廣告",
    "third_party_rectangle": "中矩形廣告",
    "video": "影音廣告",
    "combo": "影+圖廣告",
    "pic_short": "PIC 戶外 15 秒廣告",
    "pic_long": "PIC 戶外 30 秒廣告",
    "pic_extended": "PIC 戶外 60 秒廣告",
    "pic_broad": "PIC 戶外 60+ 秒廣告",
    "hwacom_short": "華電聯網 15 秒廣告",
    "hwacom_long": "華電聯網 30 秒廣告",
    "hwacom_extended": "華電聯網 60 秒廣告",
    "hwacom_broad": "華電聯網 60+ 秒廣告",
    "fridge_broad": "冰櫃戶外 60+ 秒廣告",
    "fridge_long": "冰櫃戶外 30 秒廣告",
    "fridge_extended": "冰櫃戶外 60 秒廣告",
    "pmp_fridge": "PMP 冰櫃戶外廣告",
    "outdoor_line_message": "Outdoor Line Message 廣告",
    "line_message": "Line Message 廣告",
    "unknown": "未知類型廣告",
    "third_party": "第三方廣告",
    "ctv": "數位電視廣告",
    "message": "簡訊廣告",
    "pmp_pic": "PMP PIC 戶外廣告",
    "sandbox_outdoor": "研發測試用戶外廣告",
    "sandbox_movable_outdoor": "研發測試用移動式戶外廣告"
  },
  "storedValueList": {
    "headers": {
      "adAgencyId": "經銷商 ID",
      "used": "已使用額度",
      "stored": "儲值總額度",
      "remain": "剩餘儲值額度"
    },
    "labels": { "title": "儲值額度", "noData": "無儲值額度資訊" },
    "placeholders": { "searchbar": "搜尋經銷商..." }
  },
  "storedValueDetail": {
    "labels": {
      "title": "儲值額度 - {{agencyName}}",
      "remainValue": "剩餘儲值額度",
      "totalValue": "儲值總額度",
      "usedValue": "已使用額度"
    },
    "buttons": { "addValue": "儲值", "editValue": "編輯額度" }
  },
  "storedValueLog": {
    "headers": {
      "createTime": "日期",
      "description": "說明",
      "comment": "備註",
      "amount": "儲值金額",
      "remain": "剩餘儲值額度"
    },
    "labels": { "noData": "尚無資料" }
  },
  "storedValueEditModal": {
    "labels": {
      "agency": "經銷商",
      "amount": "金額",
      "comment": "備註",
      "editConfirm": "確定要為{{agencyName}}變更儲值金額嗎？"
    },
    "buttons": { "stored": "儲存" },
    "titles": { "addValueTitle": "儲值", "editValueTitle": "編輯額度" }
  },
  "sourceList": {
    "title": "Source 列表",
    "buttons": { "create": "+ Source" },
    "headers": {
      "name": "名稱",
      "duration": "生命週期",
      "tags": "受眾標籤",
      "countries": "受眾國家"
    },
    "placeholders": {
      "searchbar": "搜尋 Source 名稱與編號...",
      "noData": "目前無 Source，可由 + Source 開始新增哦！"
    }
  },
  "source": {
    "labels": {
      "name": "名稱",
      "duration": "生命週期",
      "tags": "受眾標籤",
      "countries": "受眾國家"
    }
  },
  "sourceForm": {
    "titles": { "create": "建立 Source", "edit": "編輯 Source" },
    "hints": { "durationLimit": "可設定時間長度為 30天 - 365天" }
  },
  "sourceDetail": {
    "title": "受眾資訊",
    "titles": { "info": "受眾名稱：{{name}}" },
    "buttons": { "edit": "編輯 Source" }
  },
  "categoryList": {
    "buttons": { "create": "+ Category" },
    "placeholders": {
      "noData": "目前無 category，可由 + Category 開始新增哦！",
      "searchbar": "搜尋 Category 名稱與編號、受眾分類..."
    },
    "headers": {
      "name": "名稱",
      "tenmaxCategory": "受眾分類",
      "audienceCount": "受眾數"
    },
    "hints": {
      "importCookie": "匯入 cookie 受眾",
      "importDeviceId": "匯入裝置受眾",
      "export": "匯出受眾",
      "importSuccess": "匯入成功",
      "exportSuccess": "匯出成功"
    }
  },
  "categoryForm": {
    "titles": { "edit": "編輯 Category", "create": "建立 Category" }
  },
  "category": { "labels": { "name": "名稱", "tenmaxCategory": "受眾分類" } },
  "customLayoutList": {
    "title": "手刻版型",
    "tooltips": {
      "delete": "刪除手刻版型",
      "deleteDisabled": "無法刪除此手刻版型"
    },
    "alerts": {
      "delete": {
        "title": "刪除手刻版型",
        "message": "確認要刪除手刻版型: {{name}} ?"
      }
    },
    "placeholders": {
      "noData": "目前無資料，可由 + 手刻版型 開始新增哦！",
      "searchbar": "搜尋 手刻版型名稱 或 ID …"
    },
    "buttons": { "create": "+ 手刻版型", "preview": "預覽手刻版型" },
    "headers": {
      "name": "版型名稱",
      "previewUrl": "版型預覽",
      "layoutId": "版型ID",
      "device": "裝置類型",
      "type": "版型類型"
    }
  },
  "customLayoutSetupFlowPage": {
    "labels": {
      "upload": "上傳手刻版型",
      "setup": "設定 Macro",
      "preview": "預覽",
      "name": "版型名稱",
      "layoutId": "版型ID",
      "previewUrl": "預覽連結",
      "type": "版型類型",
      "device": "裝置類型",
      "template": "版型檔案",
      "desktop": "桌機",
      "mobile": "手機",
      "rectangleLayout": "手刻中矩形素材",
      "bottomLayout": "手刻置底素材"
    },
    "titles": { "create": "建立手刻版型" },
    "breadcrumbs": { "home": "手刻版型", "create": "新增" },
    "hints": { "templateContent": "zip 檔案需要包含 ad_tag.html" },
    "errors": { "zipContentError": "zip 檔案需要包含 ad_tag.html" },
    "buttons": { "configMacro": "設定 Macro" }
  },
  "fieldConfigPage": {
    "labels": {
      "fieldName": "欄位名稱",
      "fieldDescription": "欄位描述",
      "fieldType": "欄位類型",
      "fileSize": "檔案長寬",
      "fileStorage": "檔案大小",
      "fileRatio": "檔案比例",
      "fileType": "檔案類型",
      "videoDuration": "影片長度",
      "textMinLength": "最少字數",
      "textMaxLength": "最多字數"
    }
  },
  "formikConfigInputField": {
    "errors": {
      "fileSize": "此檔案長寬為 {{size1}}, 必須等於 {{size2}}",
      "fileRatio": "此檔案比例必須為 {{ratio}}",
      "fileType": "此檔案格式為 {{type}} 格式, 必須為 {{types}}",
      "fileStorage": "此檔案大小為 {{storage1}}，必須小於 {{storage2}}",
      "minLength": "字數需大於 {{min}}",
      "maxLength": "字數需少於 {{max}}",
      "videoDuration": "此影片長度為 {{duration1}} 秒，必須小於 {{duration2}} 秒"
    },
    "hints": {
      "fileSizeLimit": "此檔案長寬必須等於 {{limit}}",
      "fileRatioLimit": "此檔案比例必須為 {{limit}}",
      "fileStorageLimit": "此檔案大小必須小於 {{limit}} MB",
      "fileTypeLimit": "此檔案格式必須為 {{limit}}",
      "videoDurationLimit": "影片最長不可超過 {{limit}} 秒",
      "textMinLengthLimit": "字數需大於 {{limit}}",
      "textMaxLengthLimit": "字數需少於 {{limit}}"
    }
  },
  "macroFieldPlaceholder": {
    "hints": {
      "pleaseConfigMacro": "請設定 Macro 的名稱、描述、類型以及其他額外限制"
    }
  },
  "videoFormInput": {
    "errors": {
      "loadingVideo": "無法讀取影片，請提供編碼格式為 av1、H.265 或是 H.264 的影片"
    }
  },
  "customLayoutForm": { "labels": { "customLayout": "手刻版型" } },
  "fieldTypes": {
    "image": "圖片",
    "video": "影片",
    "url": "連結",
    "text": "純文字"
  },
  "messageSegments": { "title": "簡訊受眾" },
  "messageSegmentForm": {
    "titles": { "create": "建立簡訊受眾", "edit": "編輯簡訊受眾" },
    "fields": {
      "select": "選擇受眾",
      "description": "描述",
      "name": "受眾名稱",
      "advertiser": "廣告主"
    },
    "hints": {
      "selectHint": "產生的受眾概要",
      "emailCount": "信箱數量: {{count}}",
      "phoneCount": "電話數量: {{count}}",
      "gIdCount": "受眾數量: {{count}}"
    },
    "inventory": {
      "titile": "分類",
      "contentPlaceholder": "選擇一個分類以選擇受眾",
      "segmentCount": "{{total}} 受眾"
    },
    "buttons": { "segmentCountBtn": "顯示受眾概要所涵蓋的受眾數量" }
  },
  "messageSegmentList": {
    "buttons": { "create": "+ 簡訊受眾" },
    "placeholders": { "searchbar": "搜尋簡訊受眾名稱與編號..." },
    "labels": { "deleteModalContent": "確定要刪除此受眾？" },
    "hints": {
      "noData": "目前無簡訊受眾，可由 + 受眾 開始新增哦！",
      "edit": "編輯受眾"
    },
    "headers": {
      "id": "名稱",
      "description": "描述",
      "maxAliveDate": "失效日期"
    }
  },
  "picFormModel": {
    "hints": {
      "videoDuration": "影片長度應在 {{min}} 和 {{max}} 秒之間",
      "audioDuration": "音檔長度應在 {{min}} 和 {{max}} 秒之間",
      "videoDurationMin": "影片長度應至少 {{min}} 秒",
      "audioDurationMin": "音檔長度應至少 {{min}} 秒"
    }
  },
  "customOutdoorDevice": {
    "buttons": {
      "switchToList": "切換一般模式",
      "switchToMap": "開啟地圖模式",
      "previewRadius": "顯示範圍",
      "confirmRadius": "確定加入",
      "removeRadius": "移出範圍",
      "viewDevices": "檢視機台",
      "hideDevices": "隱藏機台"
    },
    "placeholder": { "searchGoogleMap": "搜尋 Google 地圖" },
    "popout": { "title": "機台名稱" },
    "cluster": {
      "added": "已加入",
      "filtered": "已篩選",
      "normal": "未加入",
      "full": "名額已滿"
    }
  },
  "pmp": {
    "pmpTypes": { "buyout": "包台", "sponsorship": "包版" },
    "labels": {
      "pmpType": "PMP 模式",
      "budget": "預算",
      "name": "PMP 訂單名稱",
      "duration": "走期",
      "dayparts": "指定投遞時間區段",
      "spaces": "機台",
      "agency": "經銷商 ID",
      "channelGroupId": "銷售渠道",
      "noAgency": "無經銷商資訊"
    },
    "adminStatus": {
      "notBinding": "未綁定",
      "binding": "已綁定",
      "stop": "已停用",
      "finish": "已結束",
      "expired": "失效"
    }
  },
  "pmpList": {
    "title": "PMP 訂單",
    "buttons": {
      "create": "+ PMP 訂單",
      "activate": "啟用",
      "deactivate": "停用",
      "showDevices": "顯示機台"
    },
    "placeholders": {
      "searchbar": "搜尋 PMP 訂單名稱...",
      "noData": "目前無活動，可由 + PMP 訂單 開始新增哦！"
    },
    "headers": {
      "name": "PMP 訂單名稱",
      "status": "狀態",
      "adAgencyId": "經銷商 ID",
      "budget": "預算與 PMP 模式",
      "schedule": "走期",
      "space": "機台",
      "channelGroupId": "銷售渠道"
    },
    "hints": {
      "cannotEdit": "已停用、失效以及超過最後設定時間的訂單不可編輯",
      "pmpStatus": "被經銷商成功綁定後，將無法修改該 PMP 訂單。"
    },
    "labels": {
      "devicesInfo": "戶外機台資訊",
      "deactivateSuccess": "PMP 訂單停用成功"
    }
  },
  "pmpActivateModal": {
    "titles": { "sponsorshipConflict": "與既有的 PMP 訂單衝突" },
    "hints": {
      "conflictWith": "與既有的 PMP 訂單",
      "durationConflict": "走期重疊",
      "spaceConflict": "版位重疊",
      "boundPmpSuggest": "此為已綁定的 PMP 訂單，建議重新開立新訂單，以符合新需求。",
      "unboundPmpSuggest": "此為未綁定的 PMP 訂單，可修正時間和版位後再開啟。"
    }
  },
  "pmpSetupFlowPage": {
    "titles": {
      "create": "建立 PMP 訂單",
      "edit": "編輯 PMP 訂單",
      "summary": "PMP 訂單總覽",
      "formSection": "PMP 訂單設定",
      "summarySection": "PMP 訂單總覽"
    },
    "labels": {
      "createSuccess": "PMP 訂單建立成功",
      "updateSuccess": "PMP 訂單更新成功"
    }
  },
  "pmpForm": {
    "errors": {
      "sponsorshipConflict": "選擇的版位時間重疊",
      "createBeforeMinDate": "開始時間必須是後天以後"
    },
    "hints": {
      "budget": "根據目前設定，建議的預算為 {{min}}",
      "dayparts": "※ 時間區段關閉為全選"
    }
  },
  "channelGroups": {
    "title": "投遞渠道管理",
    "titles": {
      "epaperDefaultImageTab": "電子紙預設圖片",
      "epaperDefaultImageContent": "電子紙預設圖片",
      "basicTab": "投遞渠道",
      "specialSettingsTab": "活動特殊設定",
      "reportTab": "報表設定",
      "bidPriceTab": "投遞金額限制",
      "adTypesTab": "廣告活動類型設定",
      "outdoorCreativeSizesTab": "戶外廣告素材尺寸設定",
      "basicContent": "投遞渠道資訊",
      "specialSettingsContent": "活動特殊設定",
      "reportContent": "報表設定",
      "bidPriceContent": "投遞金額限制",
      "edit": "編輯投遞渠道",
      "derecognitionAgencyContent": "經銷商銷售額不認列",
      "adTypesContent": "廣告活動類型設定",
      "outdoorCreativeSizesContent": "戶外廣告素材尺寸設定",
      "defaultMargin": "經銷商對帳報表預設利潤",
      "currencyContent": "報表幣別",
      "create": "建立投遞渠道",
      "nonExpressPassCategoriesTab": "非快速通關素材類型",
      "nonExpressPassCategoriesContent": "非快速通關素材類型",
      "auditLogTab": "操作歷程紀錄",
      "brandContent": "渠道品牌資訊"
    }
  },
  "channelGroup": {
    "labels": {
      "name": "投遞渠道",
      "publisherIds": "Publisher ID",
      "creativeSizes": "尺寸設定",
      "supportPMP": "支援 PMP",
      "supportWeatherTargeting": "天氣鎖定",
      "isScreenSpliced": "連台播放",
      "isMultiScreenSameVideo": "同播播放",
      "screenSplicedVerticalScreenCount": "連台垂直機台數",
      "screenSplicedHorizontalScreenCount": "連台水平機台數",
      "multiSplicedScreenCreativeSize": "連台尺寸",
      "singleScreenCreativeSize": "單台尺寸",
      "deliveryUnit": "投放點位",
      "alertEmails": "警示通知信箱",
      "siteId": "Site ID",
      "archivedSuffix": "(停用)",
      "isCompositeCreative": "要不要合成素材",
      "compositePixelSize": "實際播放尺寸",
      "allowedVideoCodecs": "支援的影片編碼",
      "allowedVideoCodecsAll": "所有",
      "supportCBO": "開放CBO功能"
    },
    "compositeSettingError": {
      "notSynced": "尚未收到 RMax 的合成設定",
      "sizeMissing": "缺少實際播放尺寸",
      "sizeNotMultiple": "實際播放尺寸不是版位尺寸的整數倍",
      "sizeTooSmall": "實際播放尺寸小於連台總尺寸"
    },
    "filter": {
      "statusFilter": "渠道狀態",
      "statusFilterMenuTitle": "選擇渠道狀態",
      "statusTag": "狀態"
    },
    "status": { "active": "啟用中", "all": "全部", "archived": "已停用" }
  },
  "channelGroupForm": {
    "labels": {
      "epaperDefaultImage": "預設圖片",
      "epaperDefaultImageNoScreenSizeError": "此渠道尚未同步螢幕解析度，無法驗證圖片尺寸",
      "name": "渠道名稱",
      "nameI18n": {
        "ja": "渠道名稱 (日文）",
        "en": "渠道名稱 (英文）",
        "zh-tw": "渠道名稱 (繁體中文）"
      },
      "publisherIds": "Publisher ID",
      "salesChannelReportShowOverspend": "扣除超支額",
      "derecognitionAgencyIds": "經銷商銷售額不認列",
      "defaultMargin": "經銷商對帳報表預設利潤",
      "limitPublisherId": "限制 Publisher",
      "publisherNotLimited": "不限制",
      "supportPMP": "支援 PMP",
      "supportWeatherTargeting": "天氣鎖定",
      "noPublisherIdWarning": "需通知RMax系統管理員該銷售渠道尚未設定發佈商ID，會影響PMax活動，請儘速調整，以免投遞異常",
      "alertEmails": "警示通知信箱",
      "currency": "報表幣別",
      "nonExpressPassCategories": "素材分類",
      "supportCBO": "開放CBO功能",
      "supportCBOStaticChannelHint": "此渠道的 CBO 由系統預設開啟，不受此開關控制",
      "supportCBOUnsupportedChannelHint": "此渠道不支援 CBO，此開關不生效",
      "brandNameI18n": {
        "ja": "品牌名稱 (日文)",
        "en": "品牌名稱 (英文)",
        "zh-tw": "品牌名稱 (繁體中文)"
      },
      "brandUrl": "品牌連結",
      "brandFilteredIcon": "地圖標示圖片 (符合篩選)",
      "brandNormalIcon": "地圖標示圖片 (未符合 / 已滿)",
      "brandIconTypeHint": "可使用 SVG 或 PNG 格式",
      "brandIconPinHint": "針尖須位於圖片底部中央",
      "brandIconTypeError": "圖片格式必須為 svg 或 png",
      "brandNameInvalidCharError": "不可包含換行、控制字元、不可見字元、< 或 >",
      "brandNameUrlError": "不可包含網址或電子郵件",
      "brandUrlError": "請輸入以 http:// 或 https:// 開頭的有效網址"
    },
    "placeholders": { "alertEmails": "輸入 email 後按 Enter 新增" },
    "errors": {
      "publisherIdIsUsed": "Publisher ID 已被其他銷售渠道使用: {{overlapIds}}"
    }
  },
  "channelGroupList": {
    "placeholders": { "searchbar": "搜尋 投遞渠道名稱 或 ID …" },
    "labels": {
      "noData": "目前無投遞渠道",
      "archiveReasonPmax": "PMax：{{reason}}",
      "archiveReasonRmax": "RMax：{{reason}}"
    },
    "hints": { "edit": "編輯投遞渠道" },
    "buttons": { "create": "+ 投遞渠道" },
    "headers": { "archiveReason": "停用理由", "status": "狀態" }
  },
  "channelGroupDetail": {
    "labels": {
      "name": "銷售渠道名稱：{{name}}",
      "archiveConfirmTitle": "確定要停用此銷售渠道？",
      "archiveConfirmContent": "此渠道底下啟用中的廣告活動將被暫停。\n底下的 PMP 訂單將被停用，且 RMax 端對應的 deal 會被刪除。\n重新啟用渠道不會恢復以上任何一項 —— 被刪除的 deal 必須重新建立。",
      "unarchiveConfirmTitle": "確定要重新啟用此銷售渠道？",
      "unarchiveConfirmContent": "渠道將可再次被選取。\n先前被停用的廣告活動與 PMP 訂單維持停用，需自行重新開啟。\nRMax 端已刪除的 deal 不會恢復，必須重新建立。",
      "archiveStatus": "渠道狀態",
      "archiveStatusArchived": "已停用",
      "archiveStatusActive": "啟用中",
      "archiveReason": "停用理由"
    },
    "buttons": { "archive": "停用", "unarchive": "重新啟用" },
    "placeholders": { "archiveReason": "請說明停用此渠道的原因" }
  },
  "channelGroupMembers": {
    "buttons": { "addMember": "+ 成員" },
    "headers": {
      "id": "編號",
      "email": "電子郵件",
      "name": "成員名稱",
      "status": "狀態",
      "permission": "權限"
    },
    "active": "啟用",
    "inactive": "停用",
    "permissions": {
      "RECONCILIATION_OFFICER": "財務人員 | 對帳人員",
      "BEACON_ADMIN": "Beacon 管理者 | 系統管理人員",
      "BEACON_EXECUTIVE": "Beacon 操作者 | 專注於投放與 beacon 維護，負責設定推播內容"
    },
    "labels": { "noDataAvailable": "目前無成員，可由 + 成員 開始新增哦！" },
    "hints": { "delete": "刪除帳號權限" }
  },
  "beaconConnectionList": {
    "labels": {
      "newBeaconConnection": "+ Beacon 連線方式",
      "beaconType": "Beacon Type",
      "lineOAName": "Line OA 名稱",
      "tenMaxBeaconName": "TenMax Beacon 名稱"
    },
    "hints": { "edit": "編輯 Beacon 連線方式" },
    "placeholders": {
      "noData": "目前無資料，可由 + Beacon 連線方式 開始新增哦！",
      "searchbar": "搜尋 Beacon 連線方式名稱…"
    },
    "headers": {
      "beaconType": "Beacon Type",
      "name": "名稱",
      "webhookType": "Webhook 類型",
      "hardwareId": "Hardware ID",
      "otherInfo": "其他 beacon 資訊"
    }
  },
  "beaconConnectionForm": {
    "titles": {
      "create": "建立 Beacon 連線方式",
      "edit": "編輯 Beacon 連線方式"
    }
  },
  "beaconType": {
    "lineSimpleBeacon": "Line Simple Beacon",
    "tenmaxBeacon": "TenMax Beacon"
  },
  "beaconField": { "labels": { "messageType": "訊息類型" } },
  "outdoorLineMessageField": {
    "labels": {
      "imageMessage": "推播圖片",
      "videoMessage": "推播影片",
      "videoMessagePreview": "推播影片預覽圖",
      "textMessage": "推播訊息",
      "messageTypes": {
        "text": "文字",
        "image": "圖片",
        "video": "影片",
        "join": "加入 LINE 好友",
        "coupon": "優惠券"
      },
      "officialAccount": "LINE 官方帳號",
      "coupon": "優惠券"
    },
    "hints": {
      "imageType": "可使用 PNG 或 JPG 格式",
      "storage": "檔案大小須小於 {{storage}} MB",
      "imageRatio": "圖片尺寸需要是 {{ratio}}",
      "videoType": "僅可使用 MP4 影片格式",
      "videoDuration": "可使用最長 {{second}} 秒的影片",
      "videoRatio": "影片比例需要是 {{ratio}}",
      "officialAccount": "請輸入包含 @ 開頭的官方帳號"
    }
  },
  "outdoorLineMessageFields": { "labels": { "addLineMessage": "推播類型" } },
  "creativeSummaryStep": {
    "labels": {
      "lineMessage": "訊息",
      "beaconInfo": "Beacon 資訊",
      "beaconSetting": "Beacon 設定",
      "join": "加入LINE 官方帳號 <1>{{value}}</1>",
      "coupon": "優惠券 <1>{{value}}</1>"
    }
  },
  "outdoorTenMaxBeaconMessageField": {
    "labels": {
      "messageTypes": { "text": "文字" },
      "messageType": "訊息類型",
      "bundleIds": "Bundle ID",
      "deepLinkIOS": "iOS App 頁面參數",
      "deepLinkAndroid": "Android App 頁面參數",
      "dataIOS": "iOS App 頁面參數",
      "dataAndroid": "Android App 頁面參數",
      "title": "推播標題",
      "message": "推播內文"
    },
    "errors": {
      "data": "需填入 iOS 或 Android 的 App 頁面參數",
      "bundleIdsUnique": "不可填入重複的 Bundle ID"
    },
    "hints": { "inputLength": "可填寫 {{length}} 字元" },
    "placeholders": {
      "bundleIds": "輸入ID後，可使用 Enter 鍵新增不同 Bundle ID …"
    }
  },
  "selectPmpStep": {
    "buttons": { "createNewCreative": "新增素材", "bindCreative": "綁定素材" }
  },
  "pmpComparingModal": {
    "title": "PMP 檢視變更",
    "labels": { "currentPmp": "修改前", "newPmp": "修改後" }
  },
  "adminBidPriceModal": {
    "titles": { "manageAdminBidPrice": "{{id}}修改出價設定" }
  },
  "adminBidPrice": { "labels": { "modifyAdminBidPrice": "修改金額" } },
  "modifyTrackingState": { "title": "編輯各類追蹤" },
  "modifyScheduleState": {
    "title": "編輯走期",
    "enableStartDate": "設定開始時間",
    "enableEndDate": "設定結束時間",
    "startDateCannotModifyHint": "廣告活動開始後，不能修改開始時間",
    "titles": { "conflictCampaigns": "會被忽略的廣告活動" },
    "hints": {
      "conflictCampaigns": "調整的時間與廣告原走期衝突，將會保留原設定"
    },
    "messages": { "scheduleUpdated": "批次編輯走期成功" }
  },
  "modifyLimitationState": {
    "titles": {
      "add": "新增優化目標",
      "remove": "移除優化目標",
      "ignoreCampaigns": "會被忽略的廣告活動"
    },
    "hints": {
      "remove": "選擇的項目將被移除",
      "ignoreRemoveFromCampaigns": "需要至少選擇一個Adx，避免投遞有問題",
      "ignoreAddToCampaigns": "新增的設定與廣告原設定衝突，將會保留原設定"
    }
  },
  "ignoreCampaignSummary": {
    "headers": {
      "name": "廣告活動名稱",
      "limitation": "原設定",
      "originalSettings": "原設定"
    }
  },
  "limitationSummaryState": {
    "titles": { "add": "新增的優化目標", "remove": "移除的優化目標" }
  },
  "channelGroupAdTypeForm": {
    "titles": { "addAdType": "新增廣告活動類型" },
    "labels": {
      "screenDisplayType": "播放特性",
      "name": "名稱",
      "nameI18n": {
        "ja": "名稱 (日文)",
        "en": "名稱 (英文)",
        "zh-tw": "名稱 (繁體中文)"
      },
      "minDuration": "素材最短秒數",
      "maxDuration": "素材最長秒數",
      "width": "素材寬度",
      "height": "素材高度",
      "outdoorType": "戶外廣告類型",
      "pricingModel": "計價模式",
      "state": "啟用廣告活動類型",
      "duration": "素材秒數"
    },
    "errors": {
      "duplicateName": "與其他廣告活動名稱衝突",
      "durationOverlap": "素材秒數與其他廣告類型衝突：{{adTypes}}",
      "cannotUseRsPricingModelAlone": "不可單獨選擇 RS 計價模式",
      "adTypeUsed": "不可刪除已被使用的廣告類型：{{adTypes}}"
    }
  },
  "channelGroupAdTypeList": {
    "buttons": { "new": "+ 廣告活動類型" },
    "headers": {
      "id": "名稱與 ID",
      "screenDisplayType": "播放特性",
      "duration": "素材秒數",
      "size": "素材尺寸",
      "state": "狀態",
      "pricingModel": "計價模式",
      "deliveryUnit": "投放點位",
      "supportedOutdoorTypes": "支援的戶外廣告類型"
    },
    "placeholders": {
      "noData": "目前無資料，可由 + 廣告活動類型 開始新增哦！"
    },
    "labels": { "active": "啟用", "inactive": "停用", "deleted": "刪除" },
    "hints": { "edit": "編輯廣告活動類型", "delete": "刪除廣告活動類型" }
  },
  "outdoorCreativeSizeHint": {
    "labels": {
      "creativeInfoHint": "素材資訊提醒",
      "sizeInstruction": "尺寸說明",
      "minSize": "最小尺寸",
      "maxSize": "最大尺寸"
    }
  },
  "outdoorDeviceReport": {
    "labels": {
      "metricType": "資料類型",
      "scheduledTimeRange": "走期",
      "timeSlot": "小時",
      "ePublisherImpresTotal": "總人流次數",
      "impresTotal": "總曝光次數"
    },
    "headers": { "storeName": "門市名稱", "deviceName": "機台名稱" },
    "title": "機台投遞成效",
    "errors": {
      "maxQueryHours": "請選擇不超出{{days}}天或{{hours}}小時的時間區間"
    }
  },
  "outdoorDeviceMetric": {
    "labels": { "ePublisherImpres": "人流數", "impres": "曝光數" }
  },
  "outdoorDeviceGran": {
    "labels": { "day": "天為單位小時累加呈現", "hour": "天和小時呈現" }
  },
  "outdoorDeviceReportChart": {
    "title": { "ePublisherImpres": "人流分佈", "impres": "曝光數分佈" }
  },
  "merchantList": {
    "labels": {
      "agencyOptionsTitle": "商家",
      "nodata": "目前無資料",
      "newMerchant": "+ 官方帳號"
    },
    "title": "官方帳號",
    "headers": { "name": "品牌名稱", "officialAccount": "官方帳號" },
    "placeholers": { "searchBar": "搜尋品牌名稱或官方帳號..." }
  },
  "merchantDetail": {
    "labels": {
      "name": "品牌名稱：{{name}}",
      "title": "官方帳號與 Beacon 列表",
      "editMerchant": "編輯官方帳號"
    }
  },
  "merchantForm": {
    "titles": { "create": "建立官方帳號", "edit": "編輯官方帳號" },
    "labels": {
      "id": "官方帳號編號",
      "name": "品牌名稱",
      "website": "官方網站",
      "category": "預設素材分類",
      "note": "其他說明事項",
      "agency": "商家"
    }
  },
  "beaconMessageList": {
    "title": "Beacon 訊息設定",
    "labels": {
      "restaurantOptionsTitle": "商家",
      "beaconConnectionOptionsTitle": "官方帳號",
      "nodata": "目前無資料，可由 + 訊息 開始新增哦！",
      "newBeaconMessage": "+ 訊息",
      "editHint": "編輯 Beacon 訊息",
      "reportHint": "檢視報表",
      "summaryHint": "訊息總覽"
    },
    "headers": {
      "name": "Beacon 訊息名稱",
      "merchant": "品牌",
      "beaconConnection": "官方帳號",
      "state": "廣告狀態",
      "endDate": "結束時間"
    },
    "buttons": { "activate": "啟用", "deactivate": "停用" },
    "placeholers": { "searchBar": "搜尋 Beacon 訊息名稱、品牌或官方帳號..." }
  },
  "beaconMessageSetupFlowPage": {
    "titles": {
      "create": "建立 Beacon 訊息",
      "basicSection": "基本資訊",
      "creativeSection": "訊息基本資訊",
      "deviceSetupSection": "裝置設定",
      "formStep": "訊息活動設定",
      "summaryStep": "資訊總覽",
      "summarySection": "訊息活動總覽",
      "edit": "編輯 Beacon 訊息",
      "summary": "Beacon 訊息總覽"
    }
  },
  "beaconMessageForm": {
    "labels": {
      "name": "訊息活動名稱",
      "schedule": "走期",
      "dayparts": "指定投遞時間區段",
      "channel": "銷售渠道"
    }
  },
  "restaurantDetail": { "labels": { "title": "商家" } },
  "restaurants": {
    "home": { "title": "商家", "searchPlaceholder": "搜尋商家..." },
    "noDataAvailable": "無資料",
    "headers": { "name": "商家名稱" }
  },
  "beaconMessageFields": {
    "labels": {
      "frequencyCapSwitch": "發送頻率",
      "deviceSetting": "Beacon 裝置設定"
    }
  },
  "screenDisplayType": {
    "movableOutdoor": { "single": "移動式單台" },
    "outdoor": { "single": "固定式單台" },
    "multiSpliced": "連台",
    "synchronizedPlayback": "同播",
    "ePaper": { "single": "電子紙單台" }
  },
  "multiSplicedCreativeDetail": {
    "labels": {
      "toggleSingleVideo": "原始影片",
      "toggleMultiSplicedVideo": "連台影片",
      "toggleSingleImage": "原始圖片",
      "toggleMultiSplicedImage": "連台圖片",
      "playAll": "播放",
      "pauseAll": "暫停"
    }
  },
  "downloadOutdoorFinalReportPanel": {
    "title": "Outdoor 結案報告",
    "buttons": { "generate": "產生" },
    "labels": {
      "targetImpressions": "目標曝光數",
      "showTop20Stores": "是否要呈現 Top 20 投遞門市 投遞成效"
    }
  },
  "deliveryUnit": { "device": "機台", "store": "門市" },
  "collapsibleSection": {
    "labels": { "expand": "編輯完成", "collapse": "編輯設定" }
  },
  "spaceHealth": {
    "labels": {
      "banned": "停止服務",
      "warmingUp": "服務啟動中",
      "noData": "訊號異常",
      "normal": "正常",
      "lastUpdated": "最後更新：{{time}}",
      "deleted": "已刪除"
    },
    "descriptions": {
      "warmingUp": "剛啟用，廣告投遞逐步回復正常",
      "noData": "此點位廣告已中斷超過 2 小時，相關人員排除中"
    }
  },
  "addUrlModal": {
    "title": "插入導外連結",
    "labels": { "clickUrl": "導外連結", "addUrl": "新增導外連結" }
  },
  "siteAnnouncementForm": {
    "titles": {
      "create": "新增通知訊息",
      "edit": "編輯通知訊息",
      "basicSettingSection": "基本資訊設定",
      "agencySection": "經銷商調整範圍",
      "contentSection": "通知內容",
      "advancedSection": "進階設定"
    },
    "labels": {
      "name": "通知標題",
      "publishTime": "發佈時間",
      "content": "通知內文",
      "duration": "通知時長",
      "prefix": { "duration": "訊息通知持續" },
      "postfix": { "duration": "天後就不顯示" },
      "chooseVendorStrategy": "經銷商",
      "allAgencies": "全經銷商",
      "partialAgencies": "指定經銷商",
      "shouldResend": "是否要重發通知",
      "attachmentUrls": "夾帶檔案",
      "type": "通知類型",
      "imageUrl": "通知圖片"
    },
    "placeholders": {
      "agencies": "請選擇經銷商",
      "attachmentUrls": "請選擇附件"
    },
    "errors": {
      "nameLength": "通知標題不可超過 50 字元",
      "contentLength": "通知內文不可超過 300 字元",
      "nameInvalid": "通知標題只接受文字與標點符號，其餘特殊符號無法正常呈現在訊息中，請調整標題後再送出",
      "contentInvalid": "通知內文只接受文字與標點符號，其餘特殊符號無法正常呈現在訊息中，請調整內文後再送出",
      "publishTimeTooEarly": "只能設定未來時間"
    },
    "hints": {
      "allFileStorage": "全部檔案大小必須小於 {{storage}}",
      "fileType": "僅可使用 {{type}} 格式"
    }
  },
  "siteAnnouncementList": {
    "title": "通知中心",
    "placeholders": {
      "adminNoData": "目前無通知，可由 + 通知 開始新增哦！",
      "noData": "目前無通知",
      "adminSearchbar": "搜尋 標題、內文 或 通知經銷商 …",
      "searchbar": "搜尋 標題或內文 …"
    },
    "buttons": {
      "create": "+ 通知",
      "showDetail": "顯示通知訊息詳情",
      "activate": "啟用",
      "deactivate": "停用"
    },
    "headers": {
      "name": "通知標題",
      "content": "通知內文",
      "agencyIds": "通知經銷商",
      "publishTime": "發佈時間",
      "status": "發佈狀態",
      "creator": "通知建立者",
      "attachmentUrls": "夾帶檔案",
      "type": "通知類型",
      "imageUrl": "通知圖片"
    },
    "labels": {
      "allAgencies": "全經銷商",
      "published": "已發佈",
      "unpublished": "未發佈",
      "inactive": "停用",
      "deleteModalTitle": "刪除通知訊息",
      "deleteModalContent": "確定要刪除所有選擇的通知訊息？"
    },
    "hints": { "edit": "編輯", "cannotDelete": "已發佈的通知不可刪除" },
    "messages": {
      "activateSuccess": "啟用成功",
      "deactivateSuccess": "停用成功",
      "deleteSuccess": "刪除成功",
      "deleteError": "刪除失敗"
    }
  },
  "siteAnnouncement": {
    "types": {
      "feature_update": "功能更新",
      "system_maintenance": "系統維護",
      "policy_announcement": "政策公告",
      "incident_report": "異常通報",
      "general": "一般公告"
    }
  },
  "siteAnnouncementDetailModal": {
    "labels": { "publishedTime": "{{time}} 發佈" }
  },
  "versionChecker": {
    "title": "有新版本 v{{version}} 可用",
    "message": "您目前使用的頁面版本較舊,請重新整理以載入最新版本,避免發生錯誤。",
    "reload": "立即重新整理"
  },
  "adjustmentTags": {
    "noCreativeBound": "素材未綁定",
    "creativeRejected": "素材審核未通過",
    "notDelivering": "未開始投遞",
    "behindSchedule": "進度落後",
    "severelyBehind": "進度嚴重落後",
    "storeBanned": "門市已關閉",
    "budgetUnderspendRisk": "預算恐花不完"
  },
  "weatherVerification": {
    "labels": {
      "reportType": "報表類型",
      "deliveryPerformance": "機台投遞成效",
      "deliveryVerification": "機台投遞驗證",
      "timeSlot": "時段",
      "campaign": "廣告活動",
      "store": "門市",
      "maxQueryDaysHint": "最多選擇 {{days}} 天",
      "noConditions": "無",
      "noStatusData": "查無機台狀態",
      "deviceStatus": "狀態：{{status}}",
      "deviceStatusReason": "原因：{{reason}}",
      "exportCsv": "匯出 CSV",
      "csvFileName": "機台投遞驗證_{{campaign}}_{{from}}_{{to}}_第{{page}}頁.csv"
    },
    "headers": {
      "dataTime": "時間",
      "storeName": "門市",
      "result": "結果",
      "unmatchedReasons": "未投遞原因",
      "targetOf": "{{dimension}}設定值"
    },
    "filters": {
      "all": "全部時段",
      "delivered": "有投遞",
      "weatherUnmatched": "天氣未符合・未投遞",
      "deviceAbnormal": "機台異常・未投遞"
    },
    "results": {
      "delivered": "有投遞",
      "weatherUnmatched": "天氣不符",
      "deviceAbnormal": "機台異常",
      "weatherAndDeviceAbnormal": "天氣不符・機台異常"
    },
    "reasons": {
      "weatherCode": "天氣現象不符",
      "temperature": "溫度不符",
      "relativeHumidity": "濕度不符",
      "uvIndex": "紫外線不符",
      "precipitation": "降雨機率不符",
      "device": "機台異常"
    },
    "descriptions": {
      "deviceAbnormalTooltip": "天氣條件符合，但機台於此時段未投遞。",
      "checkDevicePage": "請至機台管理頁確認。",
      "unmatchedTarget": "設定：{{target}}",
      "unmatchedActual": "實際：{{actual}}",
      "emptyTitle": "此廣告群組無天氣鎖定活動",
      "emptyHint": "啟用天氣鎖定後，此處將顯示各時段的投遞驗證結果",
      "weatherAndDeviceTooltip": "天氣不符合，機台異常未投遞"
    },
    "errors": { "maxQueryDays": "請選擇不超過 {{days}} 天的時間區間" }
  },
  "deviceManagement": {
    "buttons": {
      "clearFilter": "清除篩選",
      "downloadImportTemplate": "下載範例檔",
      "exitListMode": "退出名單模式",
      "export": "匯出清單",
      "import": "匯入名單",
      "loadImportSample": "載入示範名單",
      "nextMonth": "下個月",
      "previousMonth": "上個月",
      "startMatching": "開始比對",
      "daypartAll": "全選",
      "daypartCommute": "平日通勤",
      "daypartNone": "清除",
      "daypartWeekend": "週末全天"
    },
    "headers": {
      "address": "地址",
      "availabilityRate": "可售率",
      "availableSeconds": "可售秒數",
      "dailyAverageFootfall": "日均人流",
      "detail": "詳情",
      "deviceCharacteristic": "機台特徵",
      "deviceName": "機台名稱",
      "healthState": "狀態",
      "lastReportedAt": "最後回報",
      "soldSeconds": "已售秒數",
      "storeNum": "門市店號",
      "unitName": "門市名稱",
      "agencyName": "經銷商名稱",
      "orderName": "訂單名稱",
      "pmpFlight": "走期",
      "todayBusinessHours": "今日營業時間"
    },
    "hints": {
      "administrativeArea": "勾縣市＝含其下全部",
      "exportConditionsInFileName": "排序與篩選條件會寫入檔名",
      "exportListColumnsOnly": "匯出的檔案是清單檢視的欄位，不含走期與可售統計",
      "filterWithinList": "在名單內再篩選",
      "healthState": "不選＝全部狀態",
      "importFormat": "欄位格式：縣市_店號_店名",
      "importMatchKey": "以店號比對，縣市與店名僅作校驗",
      "placeCategory": "勾父層＝含其下全部",
      "region": "單一層級",
      "daypartsOutsideBusinessHours": "所選時間會在某些機台營業時間以外，麻煩確認各別機台營業時間"
    },
    "labels": {
      "availabilityCalendar": "未來可售狀況",
      "basicInformation": "基本資訊",
      "calendarRange": "{{startDate}} ~ {{endDate}}　共 {{days}} 天",
      "coordinates": "經緯度",
      "dayparts": "投放時段",
      "deliverableDevices": "可投機台",
      "deliverableStores": "可投門市",
      "detailTitle": "機台詳情",
      "exportAll": "全部 {{total}} 筆",
      "exportCount": "筆數",
      "exportDefaultSort": "預設排序（狀態異常優先）",
      "exportFilterApplied": "已套用 {{total}} 項篩選",
      "exportListMode": "名單模式 {{fileName}}",
      "exportNoFilter": "未套用篩選",
      "exportScope": "匯出範圍",
      "exportSortAsc": "{{field}} 由低至高",
      "exportSortBy": "依 <1>{{sort}}</1>",
      "exportSortDesc": "{{field}} 由高至低",
      "exportTopN": "目前排序前 N 筆",
      "flightDayCount": "共 {{days}} 天",
      "flightRange": "客戶走期",
      "importPastedName": "貼上的名單",
      "importReadCount": "{{fileName}}　已讀取 {{total}} 筆",
      "importRecognizedCount": "已辨識 {{total}} 筆",
      "importSampleName": "示範名單",
      "importTitle": "匯入門市名單",
      "lastReportedAtValue": "最後回報 {{value}}",
      "lastSynced": "最後同步 {{time}}",
      "listMode": "名單模式",
      "listModeCount": "共 {{total}} 筆　命中 {{hit}} 筆",
      "listModeIssueCount": "{{total}} 筆需確認",
      "overallAvailabilityRate": "整體可售率",
      "region": "地區",
      "resolution": "解析度",
      "secondsValue": "{{value}} 秒",
      "selectedHoursPerWeek": "已選 {{hours}} 小時／週",
      "statusReason": "狀態說明",
      "weeklyFootTraffic": "過去 7 天人流",
      "pmpBookings": "PMP 購買記錄",
      "weeklyFootTrafficPeak": "{{day}} 最高 {{value}} 人",
      "businessHours": "營業時間",
      "openAllDay": "24小時",
      "closedForDay": "休息",
      "weekdayShort": {
        "1": "一",
        "2": "二",
        "3": "三",
        "4": "四",
        "5": "五",
        "6": "六",
        "7": "日"
      }
    },
    "legends": {
      "ample": "充足",
      "low": "可售率低於 30%",
      "medium": "可售率低於 60%",
      "notScheduled": "非投放時段",
      "outOfRange": "走期外",
      "soldOut": "售罄"
    },
    "messages": {
      "calendarNoBusinessHours": "此點位尚無營業時段資料，無法計算可售狀況",
      "exportInvalidCount": "請輸入大於 0 的筆數",
      "exportUnknownScope": "請選擇匯出範圍",
      "calendarLoadFailed": "可售狀況載入失敗",
      "noPmpBooking": "走期內沒有 PMP 購買這個點位",
      "pmpBookingsLoadFailed": "PMP 購買記錄載入失敗",
      "listLoadFailed": "清單載入失敗",
      "importAmbiguous": "只有兩段，分不出哪一段是店號；請改成「縣市_店號_店名」或只填店號",
      "importInvalidStoreNum": "店號必須是數字",
      "importMismatch": "縣市或店名與查到的門市不一致",
      "importNotFound": "查無此店號",
      "insufficientBusinessHours": "資料不足",
      "loadingFilterOptions": "選項載入中…",
      "missingBusinessHoursDevices": "另有 {{total}} 台機台資料不足",
      "missingBusinessHoursStores": "另有 {{total}} 個門市資料不足",
      "noFilterOption": "沒有符合的選項",
      "noFootTrafficData": "無人流資料",
      "noUnit": "目前無符合條件的資料",
      "selectChannelFirst": "請先選擇銷售渠道",
      "uncomputableCampaigns": "有 {{total}} 檔活動無法計入已售秒數",
      "filterOptionsLoadFailed": "選項載入失敗"
    },
    "placeholders": {
      "filterSearch": "搜尋選項",
      "importPaste": "一行一間門市，例如：\n臺北市_177463_天福\n或直接貼店號：177463",
      "searchbar": "搜尋門市名稱、門市店號或地址"
    },
    "tabs": {
      "availability": "機台可售狀況",
      "importFile": "上傳檔案",
      "importPaste": "貼上店號",
      "list": "機台清單檢視"
    },
    "title": "機台管理"
  },
  "key": "zh-tw"
}
